import html2canvas from "html2canvas";
import { CHART_PALETTE } from "../utils/chartColors.js";
import { PROJECT_CHART_FONT, PROJECT_CHART_FONT_SIZE, PROJECT_CHART_PADDING } from "../utils/chartStyles.js";
import { jsPDF } from "jspdf";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useState,
    useContext,
    useRef, useEffect, useCallback, useMemo
} from "react";
import {
    Modal,
    Alert,
    Button,
    Col,
    Card,
    Row,
    Form,
    Tooltip,
    OverlayTrigger,
    Dropdown, Badge, ButtonToolbar, InputGroup, Table
} from "react-bootstrap";
import { faAnglesLeft, faAnglesRight, faCog, faClock, faClose, faUsers, faPencil, faMapLocation, faAddressCard, faChartLine, faBook, faCamera, faCogs, faChevronDown, faChevronLeft, faChevronRight, faFile, faFolder, faGlobe, faHeart, faImage, faMap, faPaperclip, faPhone, faPlane, faShoppingCart, faSignInAlt, faSignOutAlt, faStar, faTags, faThumbsUp, faTools, faTrophy, faWrench, faBookmark, faBriefcase, faBullhorn, faChartPie, faClipboard, faComment, faCompass, faCopy, faCreditCard, faDatabase, faDollarSign, faDownload, faExclamationCircle, faExternalLinkAlt, faFileAlt, faFileArchive, faFileAudio, faFileCode, faFileExcel, faFileImage, faFilePdf, faFilePowerpoint, faFileVideo, faFileWord, faFilter, faFlag, faFire, faFlask, faFolderOpen, faFont, faGift, faGlobeAfrica, faHdd, faHeadset, faHistory, faInbox, faKey, faLaptop, faLeaf, faLightbulb, faLink, faLock, faLockOpen, faMagic, faMagnifyingGlass, faMapMarkerAlt, faMedal, faMobileAlt, faMoneyBill, faMoneyCheckAlt, faPaintBrush, faPencilAlt, faPercent, faPhoneAlt, faPlug, faPlus, faPoll, faPowerOff, faPrint, faQuestion, faReceipt, faRecycle, faRedo, faRocket, faRss, faSave, faSearch, faShare, faShieldAlt, faShoppingBag, faSign, faSlidersH, faSmile, faSort, faSpinner, faStarHalf, faSync, faTabletAlt, faThumbsDown, faTrash, faTv, faUpload, faUser, faUserCircle, faVolumeUp, faWifi, faWindowClose, faEraser, faVideo, faHome, faCalendarDays, faStore, faChalkboardUser, faCrown, faUserGroup, faRankingStar, faImages, faComments, faUtensils, faExclamationTriangle, faTimesCircle, faCheckToSlot, faArrowsAlt, faAward } from '@fortawesome/free-solid-svg-icons';
import { Formik } from "formik";
import * as Yup from "yup";
import { formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";
import Select from "react-select";
import { Bar as ChartBar, Line as ChartLine } from "react-chartjs-2";
import ImageGallery from "react-image-gallery";
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { Trash, Download, Edit, Play, Square, RotateCcw, Users, FileText } from "react-feather";
import axios from "axios";
import { SocialMediaType, RecommendedSizeModal } from "./EventsComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropzoneComponent, { MultipleDropzoneComponent } from "./Dropzone.js";
import { addHours, format, parse, isAfter, isBefore, startOfDay, endOfDay, isSameDay, isValid } from 'date-fns';
import Datetime from 'react-datetime';
import { domainConfig } from "../config.js";
import { ShowConfirm } from "./Alerts.js";
import { ColumnSortingTable } from "./Table.js";
import { processData02, setHeaders02 } from "./EventHistory02.js";
import Loader from "./Loader.js";
import NotyfContext from "../contexts/NotyfContext.js";
import { confirmAlert } from "react-confirm-alert";
import useLayout from "../hooks/useLayout.js";
import useAuth from "../hooks/useAuth.js";
import { canEditEventReports } from "../utils/eventPermissions.js";
import { PLATFORM02_ACHIEVEMENT_GROUPS } from "../utils/platform02GuideGamification.js";
import {
    batchQRCodeDownload,
    convertDateToDisplayA,
    downloadQRCode,
    fillMissingProperties,
    generateSixDigitCode,
    getExcelFromObject,
    HelpTooltip, redirectURL, handleShare, getJsonFieldValue
} from "../assets/functions.js";
import { jsonComponents, schemaComponents, schemaAddGallery, jsonCustomizacao } from "../components/Json.js";
import ActivityQuizForm from "./apps/ActivityQuizForm.js";
import {
    PHOTO_COMPETITION_ACTIVITY_ID,
    PHOTO_SUBMISSION_ACTIVITY_ID,
    createPhotoActivityJson,
    formatPhotoActivityJsonForForm,
    normalizePhotoActivityJsonForSubmit,
    photoActivityValidationSchema,
} from "./apps/ActivityPhotoForm.js";
import ActivityPhotoSubmissionForm from "./apps/ActivityPhotoSubmissionForm.js";
import ActivityPhotoCompetitionForm from "./apps/ActivityPhotoCompetitionForm.js";
import ActivityVotingForm, { PARTICIPANT_VOTING_ACTIVITY_ID, createParticipantVotingJson, participantVotingValidationSchema } from "./apps/ActivityVotingForm.js";
import {
    ActivityAvailabilityFields,
    formatActivityAvailabilityForForm,
    normalizeActivityAvailabilityForSubmit,
} from "./apps/ActivityAvailability.js";
import ActivityScoreRuleModal from "./apps/ActivityScoreRuleModal.js";
import { formatActivityScoreOption } from "./apps/ActivityScoreSelector.js";
import { ActivityReportModal } from "./ActivityReportsSection.js";
import {
    getActivityAvailabilityText,
    getActivityDisplayName,
    getActivityScoreText,
    getQuizPossibleScore,
    getActivityStatusBadgeClass,
    getActivityStatusText,
    getActivityTypeLabel,
    normalizeActivityScoreJson,
} from "./apps/ActivityTableUtils.js";
import activityPhotoCompetitionImage from "../assets/img/activity-photo-competition.png";
import activityPhotoSubmissionImage from "../assets/img/activity-photo-submission.png";
import activityQuizImage from "../assets/img/activity-quiz.png";
import activityVotingImage from "../assets/img/activity-voting.png";
import imageNotFound from "../assets/img/image-not-found.png";
import {
    handlePreviewSuccess
} from './EventsComponents'
import { resolveHomeStreamingsConfig } from '../utils/homeConfig.js';
import { createSocialSection, SOCIAL_COMPONENT_VALUE } from '../utils/socialSection.js';
import { StreamingLoadTestModal } from './AutonomousStreamingLoadTestModal.js';
import { AnalyticsKpiCard } from './AnalyticsKpiCard.js';
import { StreamingActivityHelpModal } from './StreamingActivityHelpModal.js';
import {
    STREAMING_PLAYBACK_REPORT_COPY,
    buildStreamingParticipantExportMetadata,
    resolveStreamingViewerMeasurementStatus,
    resolveStreamingPlaybackCoverageMessage,
    shouldCommitStreamingReportRequest,
} from './streamingReportQuality.js';

const SOCIAL_COMPONENT_BUNDLE_VALUES = ["participantes", SOCIAL_COMPONENT_VALUE, "coleta-de-lead"];
const isSocialComponentBundle = (sectionValue) => SOCIAL_COMPONENT_BUNDLE_VALUES.includes(sectionValue);

const ACTIVITY_TYPE_OPTIONS = [
    { appId: 1, image: activityQuizImage },
    { appId: PHOTO_SUBMISSION_ACTIVITY_ID, image: activityPhotoSubmissionImage },
    { appId: PHOTO_COMPETITION_ACTIVITY_ID, image: activityPhotoCompetitionImage },
    { appId: PARTICIPANT_VOTING_ACTIVITY_ID, image: activityVotingImage },
];

export const ComponentsTabs = ({ setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, dataAddForm: propsDataAddForm, setDataAddForm: setPropsDataAddForm, setModal }) => {
    const [draggedIndexSections, setDraggedIndexSections] = useState(null);
    const [showComponentModal, setShowComponentModal] = useState(false);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [componentData, setComponentData] = useState(null);
    const [updateDataTable, setDataTableUpdate] = useState(0);
    const [updateDataTableWarning, setDataTableUpdateWarning] = useState(false);
    const [dataAddForm, setDataAddForm] = useState({
        addFieldData: false,
        socialMedia: [],
        gallery: [],
        allEvents: [],
        allActivities: [],
        availableQuizActivities: [],
        availableScores: [],
        allSpeakers: [],
        allAvailableTiers: [],
        availableUsers: [],
        scheduleStreamings: [],
        deletedScheduleStreamings: []
    });
    const notyf = useContext(NotyfContext);
    const isUpdating = useRef(false);
    const prevSelectedComponent = useRef(null);
    const { setLoading } = useLayout();
    const componentTabs = propsDataAddForm.tabs || [];

    // Function to process component data based on component_type
    const processComponentData = (data, componentType) => {
        if (!data || !Array.isArray(data)) return data;

        switch (componentType) {
            case 'expositores':
                {
                    const requiredQuizActivityIds = Array.isArray(dataTable?.json?.configs?.exhibitor?.quizActivityIds)
                        ? [...new Set(
                            dataTable.json.configs.exhibitor.quizActivityIds
                                .map((id) => Number(id))
                                .filter((id) => Number.isInteger(id) && id > 0)
                        )]
                        : [];
                    const quizTipsDynamicEnabled =
                        !!dataTable?.json?.configs?.exhibitor?.enableCollection &&
                        !!dataTable?.json?.configs?.exhibitor?.enableQuizTips &&
                        requiredQuizActivityIds.length > 0;

                    return data.map(exhibitor => {
                        // Extract user name
                        let userName = "";
                        if (exhibitor.user_id && exhibitor.user_json) {
                            try {
                                const userData = typeof exhibitor.user_json === 'string'
                                    ? JSON.parse(exhibitor.user_json)
                                    : exhibitor.user_json;
                                userName = userData.name || userData.nome || exhibitor.email || "";
                            } catch (e) {
                                userName = exhibitor.email || "";
                            }
                        }

                        // Convert categories array to string
                        const categoriesStr = exhibitor.json?.categories && Array.isArray(exhibitor.json.categories)
                            ? exhibitor.json.categories.join(", ")
                            : "";
                        const normalizedQuizTips = (Array.isArray(exhibitor.json?.quiz_tips)
                            ? exhibitor.json.quiz_tips
                            : exhibitor.json?.quiz_tip
                                ? [exhibitor.json.quiz_tip]
                                : [])
                            .map((tip) => ({
                                activity_id: Number(tip?.activity_id),
                                question_id: Number(tip?.question_id),
                            }))
                            .filter((tip) => Number.isInteger(tip.activity_id) && tip.activity_id > 0 && Number.isInteger(tip.question_id) && tip.question_id > 0);
                        const hasQuizAssociation = quizTipsDynamicEnabled && requiredQuizActivityIds.every(
                            (activityId) => normalizedQuizTips.some((tip) => tip.activity_id === activityId)
                        );

                        return {
                            ...exhibitor,
                            userName: userName,
                            categoriesStr: categoriesStr,
                            name: exhibitor.json?.name || "",
                            description: exhibitor.json?.description || "",
                            logo: exhibitor.json?.logo || "",
                            quizAssociationStatus: hasQuizAssociation,
                            quizAssociationStatusLabel: hasQuizAssociation ? 'Questão associada' : 'Não associado'
                        };
                    });
                }

            case 'palestrantes':
                return data.map(speaker => {
                    return {
                        ...speaker,
                        // Processed fields for table display
                        speakerName: speaker.json?.name || "",
                        speakerRole: speaker.json?.role || "",
                        speakerCompany: speaker.json?.company || "",
                        speakerImage: speaker.json?.image || "",
                        favoriteCount: speaker.favorite_count || 0,
                        scheduleEventsCount: speaker.schedule_events ? speaker.schedule_events.length : 0
                    };
                });

            case 'patrocinadores':
                return data.map(sponsor => {
                    return {
                        ...sponsor,
                        // Processed fields for table display
                        sponsorName: sponsor.json?.name || "",
                        sponsorCategory: sponsor.json?.category || "",
                        sponsorImage: sponsor.json?.image || "",
                        tierName: sponsor.tier || ""
                    };
                });

            case 'agenda':
                return data.map(schedule => {
                    const vacancySystem = schedule.json?.vacancySystem;
                    const hasVacancySystem = vacancySystem?.status;
                    const vacancyText = hasVacancySystem
                        ? `${schedule.vacancyCount || 0} de ${vacancySystem.slots || 0} vagas`
                        : "";
                    const vacancyTimeLimit = hasVacancySystem && schedule.json?.timeLimit
                        ? convertDateToDisplayA(schedule.json.timeLimit, 0)
                        : "";

                    return {
                        ...schedule,
                        // Processed fields for table display
                        scheduleTitle: schedule.json?.title || "",
                        startDateFormatted: convertDateToDisplayA(schedule.start_date, 0),
                        endDateFormatted: convertDateToDisplayA(schedule.end_date, 0),
                        vacancySystemText: vacancyText,
                        vacancySystemTimeLimit: vacancyTimeLimit,
                        interestedCountDisplay: schedule.interestedCount || 0,
                        speakersCount: schedule.speakers ? schedule.speakers.length : 0,
                        activitiesCount: schedule.json?.activities ? schedule.json.activities.length : 0,
                        streamingsCount: Array.isArray(schedule.streamings) ? schedule.streamings.length : 0
                    };
                });

            case 'atividades':
                return data.map(activity => {
                    // Handle null, undefined, or invalid status values
                    const normalizedStatus = Number(activity.status ?? 0);

                    return {
                        ...activity,
                        // Processed fields for table display
                        activityTitle: activity.title || "",
                        activityType: getActivityDisplayName(activity),
                        statusText: getActivityStatusText(normalizedStatus, activity),
                        statusBadgeClass: getActivityStatusBadgeClass(normalizedStatus, activity),
                        availabilityPeriodText: getActivityAvailabilityText(activity),
                        normalizedStatus: normalizedStatus
                    };
                });

            case 'pontos-de-interesse':
                return data.map(interestPoint => {
                    const tip = interestPoint.json?.tip || '';
                    const truncatedTip = tip.length > 50 ? tip.substring(0, 50) + '...' : tip;

                    return {
                        ...interestPoint,
                        // Processed fields for table display
                        interestPointTitle: interestPoint.json?.title || "",
                        interestPointImage: interestPoint.json?.image || "",
                        interestPointTip: truncatedTip,
                        interestPointValue: interestPoint.value || 0,
                        totalCollected: interestPoint.total_collected || 0
                    };
                });

            default:
                return data;
        }
    };

    // useEffect to refetch component data when dataTableUpdate changes
    useEffect(() => {
        if (isUpdating.current === false && selectedComponent) {
            if (selectedComponent.value === 'comunicados' || selectedComponent.value === SOCIAL_COMPONENT_VALUE) {
                setComponentData([]);
                setShowComponentModal(true);
                prevSelectedComponent.current = selectedComponent;
                return;
            }

            isUpdating.current = true
            setLoading(true);

            // Check if we're switching to a different component
            const isComponentChanged = prevSelectedComponent.current &&
                prevSelectedComponent.current.value !== selectedComponent.value;

            // Clear previous componentData only when switching components
            if (componentData && isComponentChanged) {
                setComponentData(null);
            }

            // Update the ref to track current component
            prevSelectedComponent.current = selectedComponent;

            // Fetch component data
            axios.get('/api/event/plataformaEventos/component', {
                params: {
                    event_id: dataTable.event_id,
                    component_type: selectedComponent.value
                }
            })
                .then(function (response) {
                    const processedData = processComponentData(response.data.message, selectedComponent.value);
                    setComponentData(processedData);

                    // Mix additionalData with dataAddForm if available
                    if (response.data.additionalData) {
                        setDataAddForm(prevState => ({
                            ...prevState,
                            allEvents: response.data.additionalData.allEvents || [],
                            allSpeakers: response.data.additionalData.allSpeakers || [],
                            allActivities: response.data.additionalData.allActivities || [],
                            availableQuizActivities: response.data.additionalData.availableQuizActivities || [],
                            availableScores: response.data.additionalData.availableScores || [],
                            allAvailableTiers: response.data.additionalData.allAvailableTiers || [],
                            availableUsers: response.data.additionalData.availableUsers || []
                        }));
                    }

                    if (updateDataTableWarning === "update") {
                        setDataTableUpdateWarning(false);
                        notyf.open({
                            type: "success",
                            message: "Dados atualizados com sucesso",
                            ripple: true,
                            dismissible: true,
                        });
                    }
                    setShowComponentModal(true)
                    setLoading(false);
                    setTimeout(() => {
                        isUpdating.current = false;
                    }, 250);
                })
                .catch(function (error) {

                    setLoading(false);
                    notyf.open({
                        type: "danger",
                        message: "Houve um erro ao atualizar os dados, tente novamente",
                        ripple: true,
                        dismissible: true,
                    });
                    setTimeout(() => {
                        isUpdating.current = false;
                    }, 250);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateDataTable, selectedComponent]);

    const handleDragStartSections = (index) => {
        setDraggedIndexSections(index);
    };

    const handleDragOverSections = (index) => {
        if (draggedIndexSections === index) return;

        const updatedTabs = [...(propsDataAddForm.tabs || [])];
        const [draggedTab] = updatedTabs.splice(draggedIndexSections, 1);
        updatedTabs.splice(index, 0, draggedTab);

        setDraggedIndexSections(index);
        setPropsDataAddForm((prevDataAddForm) => {
            return {
                ...prevDataAddForm,
                tabs: updatedTabs,
            }
        });
    };

    const handleDragEndSections = () => {
        setDraggedIndexSections(null);
    };

    const removeSection = (sectionValue) => {
        const valuesToRemove = Array.isArray(sectionValue) ? sectionValue : [sectionValue];
        setPropsDataAddForm((prevDataAddForm) => {
            const updatedTabs = (prevDataAddForm.tabs || []).filter((tab) => !valuesToRemove.includes(tab.value));
            const removesActiveTab = valuesToRemove.includes(prevDataAddForm.activeTab);
            const newActiveTab =
                removesActiveTab && updatedTabs.length
                    ? updatedTabs[0].value
                    : prevDataAddForm.activeTab;

            return {
                ...prevDataAddForm,
                activeTab: newActiveTab,
                tabs: updatedTabs,
            };
        });
    };

    const handleSelectChange = (value, field, newValue) => {
        setPropsDataAddForm(prevDataAddForm => ({
            ...prevDataAddForm,
            tabs: (prevDataAddForm.tabs || []).map(option =>
                option.value === value
                    ? { ...option, [field]: newValue }
                    : option
            )
        }));
    };

    const openComponentModal = (tab, index) => {
        setSelectedComponent({ ...tab, index });
    };

    const editSection = (tab) => {
        setPropsDataAddForm(prevState => ({
            ...prevState,
            editingSection: tab
        }));
        setModal((prevState) => ({
            ...prevState,
            showExtraSectionsForm: true
        }));
    };

    return (
        <>
            <ModalComponentsTabs showComponentModal={showComponentModal} setShowComponentModal={setShowComponentModal} selectedComponent={selectedComponent} setDataTableUpdate={setDataTableUpdate} setDataTableUpdateWarning={setDataTableUpdateWarning} componentData={componentData} setComponentData={setComponentData} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} propsDataAddForm={propsDataAddForm} setPropsDataAddForm={setPropsDataAddForm} />
            <Row className="my-3 mx-0">
                <Col lg="12" className="text-center mb-2">
                    {componentTabs.length > 0 && <small className="text-center opacity-75">(Clique e arraste para ordenar)</small>}
                </Col>
                {componentTabs.map((tab, index) => {
                    return (
                        <Col
                            className="mb-3 pointer"
                            key={"card" + index}
                            lg="3"
                            md="3"
                            sm="4"

                            draggable
                            onDragStart={() => handleDragStartSections(index)}
                            onDragOver={(e) => {
                                e.preventDefault();
                                handleDragOverSections(index);
                            }}
                            onClick={() => openComponentModal(tab, index)}
                            onDragEnd={handleDragEndSections}>
                            <Card className="sectionCardLayout mb-0 h-100">
                                <Card.Body className="sectionCardLayout__body d-flex flex-column h-100">
                                    <div className="sectionCardLayout__topline">
                                        <span className="sectionCardLayout__position">{String(index + 1).padStart(2, "0")}</span>
                                        <span className="sectionCardLayout__drag-handle" title="Arraste para alterar a ordem">
                                            <FontAwesomeIcon icon={faArrowsAlt} />
                                        </span>
                                    </div>
                                    <div className="sectionCardLayout__icon" aria-hidden="true">
                                        <FontAwesomeIcon icon={iconMapping[tab.icon]} size="lg" />
                                    </div>
                                    <div className="sectionCardLayout__content">
                                        <span className="sectionCardLayout__eyebrow">Componente</span>
                                        <h6 className="sectionCardLayout__title" title={tab.title}>{tab.title}</h6>
                                    </div>
                                    <div className="sectionCardLayout__actions mt-auto">
                                        {tab.value !== 'pagina-inicial' && (
                                            <Button className="sectionCardLayout__action sectionCardLayout__action--delete" variant="outline-danger" size="sm" onClick={(e) => { e.preventDefault(); e.stopPropagation(); confirmAlert({ closeOnEscape: false, closeOnClickOutside: false, customUI: ({ onClose }) => <ShowConfirm title="Confirmar ação" description={isSocialComponentBundle(tab.value) ? "Networking, Social e Coleta de lead funcionam juntos. Ao excluir este componente, os 3 componentes serão removidos do evento." : "Deseja remover essa seção?"} action={() => removeSection(isSocialComponentBundle(tab.value) ? SOCIAL_COMPONENT_BUNDLE_VALUES : tab.value)} onClose={onClose} /> }); }} title="Excluir" aria-label={`Excluir ${tab.title}`}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                        )}
                                        <Button className="sectionCardLayout__action" variant="primary" size="sm" onClick={(e) => { e.preventDefault(); e.stopPropagation(); editSection(tab); }} title="Editar seção" aria-label={`Editar ${tab.title}`}>
                                            <FontAwesomeIcon icon={faPencil} />
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    );
                })}
                <Col className="componentCard mb-3" lg="3" md="3" sm="4">
                    <div
                        className="addMainCard sectionCardLayout__add"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setModal((prevState) => ({
                                ...prevState,
                                showExtraSectionsForm: true
                            }));
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setModal((prevState) => ({
                                    ...prevState,
                                    showExtraSectionsForm: true
                                }));
                            }
                        }}
                    >
                        <span className="sectionCardLayout__add-icon"><FontAwesomeIcon icon={faPlus} /></span>
                        <span className="sectionCardLayout__add-label">Adicionar componente</span>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export const ModalComponentsTabs = ({ showComponentModal, setShowComponentModal, selectedComponent, setDataTableUpdate, setDataTableUpdateWarning, componentData, setComponentData, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, dataAddForm, setDataAddForm, propsDataAddForm, setPropsDataAddForm }) => {
    const [showImageModal, setShowImageModal] = useState({ url: '', show: false });

    if (!componentData) {
        return null
    }

    return (
        <Modal
            show={showComponentModal}
            size="lg"
            onHide={() => setShowComponentModal(false)}
            fullscreen={true}
            centered
            backdrop
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon icon={iconMapping[selectedComponent.icon]} className="me-1" /> {selectedComponent ? `${selectedComponent.label}` : ''}
                    <br></br><small>Evento: <span className="opacity-75">{dataTable.title}</span></small>
                </Modal.Title>
            </Modal.Header>
            <Button
                type="button"
                variant="primary"
                className="btn update-side-panel-button-modal"
                onClick={() => {
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    setDataTableUpdateWarning("update");
                }}
                title="Atualizar dados do componente"
            >
                <FontAwesomeIcon icon={faSync} size={"lg"} />
            </Button>
            <Modal.Body>

                <ModalImage showImageModal={showImageModal} setShowImageModal={setShowImageModal}></ModalImage>
                {selectedComponent && (
                    <EventTabs
                        selectedValue={selectedComponent}
                        currentIndex={selectedComponent.index}
                        handleSelectChange={handleSelectChange}
                        setFieldValue={setFieldValue}
                        dataTable={dataTable}
                        handleChange={handleChange}
                        touched={touched}
                        errors={errors}
                        handlePreviewError={handlePreviewError}
                        componentData={componentData}
                        setComponentData={setComponentData}
                        setDataTableUpdate={setDataTableUpdate}
                        showImageModal={showImageModal}
                        setShowImageModal={setShowImageModal}
                        dataAddForm={dataAddForm}
                        setDataAddForm={setDataAddForm}
                        propsDataAddForm={propsDataAddForm}
                        setPropsDataAddForm={setPropsDataAddForm}
                        setDataTableUpdateWarning={setDataTableUpdateWarning}

                    />
                )
                }
            </Modal.Body>
        </Modal>
    )
}

export const EventTabs = ({ selectedValue, currentIndex, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setComponentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm, propsDataAddForm, setPropsDataAddForm, setDataTableUpdateWarning }) => {

    // Handle content changes for custom pages
    const handleContentChange = (field, value) => {
        setPropsDataAddForm(prevDataAddForm => ({
            ...prevDataAddForm,
            tabs: (prevDataAddForm.tabs || []).map((tab, index) =>
                index === currentIndex
                    ? {
                        ...tab,
                        content: {
                            ...(tab.content || { type: 'cardWithImage', image: '', location: '', link: '' }),
                            [field]: value
                        }
                    }
                    : tab
            )
        }));
    };

    // Handle htmlContent changes for custom pages
    const handleHtmlContentChange = (value) => {
        setPropsDataAddForm(prevDataAddForm => ({
            ...prevDataAddForm,
            tabs: (prevDataAddForm.tabs || []).map((tab, index) =>
                index === currentIndex
                    ? { ...tab, htmlContent: value }
                    : tab
            )
        }));
    };

    switch (selectedValue.value) {
        case 'pagina-inicial':
            return (
                <TabPaginaInicial selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} />
            )
        case 'ranking':
            return (
                <TabRanking setFieldValue={setFieldValue} dataTable={dataTable} setDataTableUpdate={setDataTableUpdate} />
            )
        case 'coleta-de-lead':
            return (
                <TabColetaDeLead setFieldValue={setFieldValue} dataTable={dataTable} />
            )
        case 'participantes':
            return (
                <TabParticipantes setFieldValue={setFieldValue} dataTable={dataTable} />
            )
        case 'expositores':
            return (
                <TabExhibitors selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setComponentData={setComponentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'palestrantes':
            return (
                <TabSpeakers selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setComponentData={setComponentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'patrocinadores':
            return (
                <TabSponsors selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'pontos-de-interesse':
            return (
                <TabInterestsPoints selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'atividades':
            return (
                <TabActivity selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} setComponentData={setComponentData} setDataTableUpdate={setDataTableUpdate} setDataTableUpdateWarning={setDataTableUpdateWarning} />
            )
        case 'agenda':
            return (
                <TabSchedule selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'galeria':
            return (
                <TabGallery selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} componentData={componentData} setDataTableUpdate={setDataTableUpdate} setShowImageModal={setShowImageModal} dataAddForm={dataAddForm} setDataAddForm={setDataAddForm} />
            )
        case 'a&b':
            return (
                <TabRestaurante selectedValue={selectedValue} handleSelectChange={handleSelectChange} setFieldValue={setFieldValue} dataTable={dataTable} handleChange={handleChange} touched={touched} errors={errors} handlePreviewError={handlePreviewError} />
            )
        case SOCIAL_COMPONENT_VALUE:
            return (
                <TabSocial
                    setFieldValue={setFieldValue}
                    dataTable={dataTable}
                />
            )
        case 'comunicados':
            return (
                <TabComunicados />
            )

        default:
            return (
                <TabCustomization
                    selectedValue={selectedValue}
                    currentIndex={currentIndex}
                    handleContentChange={handleContentChange}
                    handleHtmlContentChange={handleHtmlContentChange}
                    handleSelectChange={handleSelectChange}
                    dataTable={dataTable}
                    handlePreviewError={handlePreviewError}
                    dataAddForm={dataAddForm}
                    setDataAddForm={setDataAddForm}
                    propsDataAddForm={propsDataAddForm}
                    setPropsDataAddForm={setPropsDataAddForm}
                />
            );
    }
};

export const TabPaginaInicial = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError }) => {
    const homeStreamings = resolveHomeStreamingsConfig(dataTable.json.home);
    const [currentBanner, setCurrentBanner] = useState(0);

    // Initialize banner array if it doesn't exist, is not an array, or is empty
    React.useEffect(() => {
        const bannerValue = dataTable.json.banner;
        if (!bannerValue || !Array.isArray(bannerValue) || bannerValue.length === 0) {
            setFieldValue("json.banner", bannerValue && !Array.isArray(bannerValue) ? [bannerValue] : [""]);
        }
    }, [dataTable.json.banner, setFieldValue]);

    // Ensure banner is array for processing
    const banners = Array.isArray(dataTable.json.banner) ? dataTable.json.banner : [dataTable.json.banner || ""];

    function newBanner() {
        if (banners.length < 4) {
            const updatedBanners = [...banners, ""];
            setFieldValue("json.banner", updatedBanners);
            setCurrentBanner(updatedBanners.length - 1);
        }
    }

    function deleteBanner(index) {
        if (banners.length > 1) {
            const updatedBanners = banners.filter((_, i) => i !== index);
            setFieldValue("json.banner", updatedBanners);
            setCurrentBanner(Math.max(0, index - 1));
        } else {
            // When only one banner remains, set it to empty string to show empty background
            const updatedBanners = [...banners];
            updatedBanners[index] = "";
            setFieldValue("json.banner", updatedBanners);
            setCurrentBanner(Math.max(0, index - 1));
        }
    }

    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Banners</h5>
            </Form.Group>
            <ButtonToolbar className="mb-4 justify-content-center">
                {banners.map((banner, index) => {
                    let hasError = false;
                    if (errors?.json?.banner && Array.isArray(errors.json.banner)) {
                        hasError = !!errors.json.banner[index];
                    }
                    return (
                        <Button
                            key={"bannerButton" + index}
                            className={`mt-3 me-2 buttonToolbarApp ${hasError ? 'is-invalid' : ''} ${currentBanner === index ? 'active' : ''}`}
                            onClick={() => setCurrentBanner(index)}
                        >
                            {index + 1}
                        </Button>
                    );
                })}
                <Button onClick={() => newBanner()} className="mt-3 ms-2" disabled={banners.length >= 4}>
                    Adicionar
                </Button>
            </ButtonToolbar>
            <Row className="mx-0 mb-3">
                {banners.map((banner, index) => {
                    if (index !== currentBanner) {
                        return ("");
                    }
                    return (
                        <Form.Group
                            as={Col}
                            className="mb-3"
                            md="12"
                            key={index + 'banner'}>
                            <Card className="mb-3">
                                <Card.Body>
                                    <Form.Control
                                        type="hidden"
                                        name={`json.banner[${index}]`}
                                        value={banners[index]}
                                        onChange={handleChange}
                                        isInvalid={!!errors?.json?.banner?.[index]}
                                        isValid={touched?.json?.banner?.[index] && !errors?.json?.banner?.[index]}
                                    />
                                    <div className="imagesUpload">
                                        <img
                                            className={`h-100 img-thumbnail ${!!errors?.json?.banner?.[index] ? "is-invalid" : ""}`}
                                            src={
                                                banners[index] !== "" && banners[index] !== null
                                                    ? domainConfig.imageServer +
                                                    "/plataforma-eventos/" +
                                                    dataTable.event_id +
                                                    "/" +
                                                    banners[index]
                                                    : domainConfig.imageServer + "/empty-background.png"
                                            }
                                            alt="Banner preview"
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.json?.banner?.[index]}
                                        </Form.Control.Feedback>
                                    </div>
                                    <DropzoneComponent
                                        className="mt-3 dropzoneComp"
                                        type="image"
                                        handlePreviewSuccess={handlePreviewSuccess}
                                        handlePreviewError={handlePreviewError}
                                        setFieldValue={setFieldValue}
                                        folder="plataforma-eventos"
                                        id={dataTable.event_id}
                                        field={`json.banner[${index}]`}
                                    />
                                </Card.Body>
                            </Card>
                        </Form.Group>
                    );
                })}
                {(banners.length > 1 || banners[currentBanner] !== "") && <Col className="text-center">
                    <Button
                        variant="danger"
                        className="mb-3"
                        onClick={() => deleteBanner(currentBanner)}
                    >
                        Excluir Banner
                    </Button>
                </Col>}
            </Row>
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Contéudo</h5>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check
                    checked={dataTable.json.home.status ? true : false}
                    type="checkbox"
                    name="json.home.status"
                    className="mt-1"
                    label='Adicionar texto após o banner'
                    onChange={(e) => {
                        setFieldValue(
                            "json.home.status",
                            dataTable.json.home.status ? false : true
                        );
                    }}
                />
                <Form.Check
                    checked={dataTable.json.home.activities?.status === true}
                    type="checkbox"
                    name="json.home.activities.status"
                    label="Exibir atividades na página inicial"
                    onChange={(e) => setFieldValue("json.home.activities.status", e.target.checked)}
                />
                <Form.Check
                    checked={homeStreamings.status}
                    type="checkbox"
                    name="json.home.streamings.status"
                    label="Exibir transmissões na página inicial"
                    onChange={(e) => setFieldValue("json.home.streamings.status", e.target.checked)}
                />
            </Form.Group>
            {dataTable.json.home.status &&
                <Form.Group
                    className="mb-3"
                    as={Col}
                    sm="12">
                    <Form.Control
                        name="json.home.content"
                        as="textarea"
                        value={dataTable.json.home.content}
                        onChange={handleChange}
                        placeholder="Digite o conteúdo HTML aqui..."
                        isInvalid={!!errors.json?.home?.content}
                        isValid={touched.json?.home?.content && !errors.json?.home?.content}
                        rows={5}
                    />
                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                        {errors.json?.home?.content}
                    </Form.Control.Feedback>
                </Form.Group>
            }
            <div className="my-3">
                {dataTable.json.home.activities?.status === true && (
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} className="mb-3">
                            <Form.Label>Título</Form.Label>
                            <Form.Control
                                maxLength={100}
                                value={dataTable.json.home.activities?.title || "Atividades em destaque"}
                                onChange={(e) => setFieldValue("json.home.activities.title", e.target.value)}
                            />
                        </Form.Group>
                    </Row>
                )}
                {homeStreamings.status && (
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} className="mb-3">
                            <Form.Label>Título</Form.Label>
                            <Form.Control
                                maxLength={100}
                                value={homeStreamings.title}
                                onChange={(e) => setFieldValue("json.home.streamings.title", e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} className="mb-3">
                            <Form.Label>Ordenação</Form.Label>
                            <Form.Select
                                value={homeStreamings.sort}
                                onChange={(e) => setFieldValue("json.home.streamings.sort", e.target.value)}
                            >
                                <option value="live_first">Ao vivo primeiro</option>
                                <option value="nearest_start">Horário mais próximo</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>
                )}
            </div>
        </Row>
    )
}

const GLOBAL_SCORE_BOOST_TIMEZONE = "America/Sao_Paulo";
const GLOBAL_SCORE_BOOST_DISPLAY_FORMAT = "dd/MM/yyyy HH:mm";
const EVENT_DATE_FORMAT = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
const GLOBAL_SCORE_BOOST_DEFAULT_MULTIPLIER = 2;
const GLOBAL_SCORE_BOOST_MIN_MULTIPLIER = 1;
const GLOBAL_SCORE_BOOST_MAX_MULTIPLIER = 5;

const PLATFORM02_ACHIEVEMENT_CATALOG = Object.freeze(
    PLATFORM02_ACHIEVEMENT_GROUPS.flatMap((group) => group.items.map((item) => ({
        ...item,
        category: group.title,
    }))),
);

const parseGlobalScoreBoostDate = (value) => {
    if (typeof value !== "string" || !value.trim()) return null;
    const parsed = parse(value.trim(), GLOBAL_SCORE_BOOST_DISPLAY_FORMAT, new Date());
    return isValid(parsed) && format(parsed, GLOBAL_SCORE_BOOST_DISPLAY_FORMAT) === value.trim()
        ? parsed
        : null;
};

const parseEventBoundaryDate = (value) => {
    const displayDate = parseGlobalScoreBoostDate(value);
    if (displayDate) return displayDate;
    if (!value) return null;
    const normalizedValue = String(value).trim();
    const date = EVENT_DATE_FORMAT.test(normalizedValue)
        ? new Date(`${normalizedValue.replace(" ", "T")}:00.000Z`)
        : new Date(value);
    return isValid(date) ? date : null;
};

const isWithinEventPeriod = (value, eventStart, eventEnd) => (
    (!eventStart || !isBefore(value, eventStart))
    && (!eventEnd || !isAfter(value, eventEnd))
);

const buildEventDatePredicate = (eventStart, eventEnd) => (current) => (
    isWithinEventPeriod(current.toDate(), eventStart ? startOfDay(eventStart) : null, eventEnd ? endOfDay(eventEnd) : null)
);

const getDefaultScoreBoostStart = (eventStart, eventEnd, now = new Date()) => {
    let startDate = addHours(now, 1);
    if (eventStart && isBefore(startDate, eventStart)) startDate = eventStart;
    if (eventEnd && !isBefore(startDate, eventEnd)) {
        startDate = eventStart && isBefore(eventStart, eventEnd) ? eventStart : eventEnd;
    }
    return startDate;
};

const toGlobalScoreBoostDate = (value) => {
    if (!value) return null;
    const displayDate = parseGlobalScoreBoostDate(value);
    if (displayDate) return zonedTimeToUtc(displayDate, GLOBAL_SCORE_BOOST_TIMEZONE).toISOString();
    const date = new Date(value);
    return isValid(date) ? date.toISOString() : null;
};

const formatGlobalScoreBoostDateForForm = (value) => {
    if (!value) return "";
    if (parseGlobalScoreBoostDate(value)) return value;
    const date = new Date(value);
    return isValid(date)
        ? formatInTimeZone(date, GLOBAL_SCORE_BOOST_TIMEZONE, GLOBAL_SCORE_BOOST_DISPLAY_FORMAT)
        : String(value);
};

const getGlobalScoreBoostDateInput = (value) => formatGlobalScoreBoostDateForForm(value);

const getGlobalScoreBoostWindows = (scoreBoost) => {
    if (Array.isArray(scoreBoost?.windows) && scoreBoost.windows.length > 0) return scoreBoost.windows;
    if (scoreBoost?.start_at || scoreBoost?.end_at) {
        return [{
            start_at: scoreBoost.start_at || null,
            end_at: scoreBoost.end_at || null,
            multiplier: GLOBAL_SCORE_BOOST_DEFAULT_MULTIPLIER,
        }];
    }
    return [];
};

export const TabRanking = ({ setFieldValue, dataTable, setDataTableUpdate }) => {
    const notyf = useContext(NotyfContext);
    const [scoreRules, setScoreRules] = useState([]);
    const [loadingScores, setLoadingScores] = useState(true);
    const [savingScores, setSavingScores] = useState(false);
    const [showActivityScoreModal, setShowActivityScoreModal] = useState(false);
    const [deletingScoreId, setDeletingScoreId] = useState(null);
    const [quizPossibleScore, setQuizPossibleScore] = useState(0);
    const eventStart = parseEventBoundaryDate(dataTable?.creation_date);
    const eventEnd = parseEventBoundaryDate(dataTable?.end_date);

    const scoreGroups = [
        {
            key: "networking",
            title: "Networking",
            types: ["networking_connection", "networking_qr_connection", "networking_connections_5", "networking_connections_10", "networking_connections_25"],
        },
        {
            key: "event_engagement",
            title: "Engajamento no evento",
            types: ["interest_point_collection", "exhibitor_visit", "schedule_interest", "participant_checkin_day"],
        },
        {
            key: "profile",
            title: "Perfil",
            types: ["profile_complete"],
        },
        {
            key: "streaming",
            title: "Transmissões",
            types: ["stream_watch_15m", "stream_watch_30m", "stream_watch_60m", "stream_poll_answered", "stream_full_engagement"],
        },
        {
            key: "newsfeed",
            title: "Newsfeed",
            types: ["newsfeed_post_published"],
        },
        {
            key: "activities",
            title: "Atividades",
            types: ["activity_photo_approval", "activity_photo_competition_winner", "activity_participant_voting_winner"],
        },
    ];
    const scoreSourceLabels = {
        networking_connection: "Conexão de networking",
        networking_qr_connection: "Conexão via QR Code",
        networking_connections_5: "Alcançar 5 conexões",
        networking_connections_10: "Alcançar 10 conexões",
        networking_connections_25: "Alcançar 25 conexões",
        interest_point_collection: "Coleta de ponto de interesse",
        exhibitor_visit: "Visita a expositor",
        schedule_interest: "Interesse ou confirmação de agenda",
        participant_checkin_day: "Check-in no evento",
        profile_complete: "Perfil completo",
        stream_watch_15m: "Assistir transmissão por 15 minutos",
        stream_watch_30m: "Assistir transmissão por 30 minutos",
        stream_watch_60m: "Assistir transmissão por 60 minutos",
        stream_poll_answered: "Responder enquete da transmissão",
        stream_full_engagement: "Engajamento completo na transmissão",
        newsfeed_post_published: "Publicar no Newsfeed",
    };
    const activityScoreSourceLabels = {
        activity_photo_approval: { title: "Envio de foto", description: "Foto aprovada pela gestão" },
        activity_photo_competition_winner: { title: "Competição de fotos", description: "Vencedor da competição" },
        activity_participant_voting_winner: { title: "Votação", description: "Vencedor da votação" },
    };
    const repeatableScoreTypes = new Set([
        "networking_connection",
        "networking_qr_connection",
        "interest_point_collection",
        "exhibitor_visit",
        "schedule_interest",
        "participant_checkin_day",
        "activity_photo_approval",
        "activity_photo_competition_winner",
        "activity_participant_voting_winner",
        "stream_full_engagement",
    ]);
    const getScoreRepeatability = (type, groupKey = null) => {
        if (groupKey === "activities") {
            return { label: "Por atividade", title: "Pode conceder pontos uma vez por ocorrência válida da atividade." };
        }
        return repeatableScoreTypes.has(type)
            ? { label: "Repetível", title: "Pode conceder pontos novamente para cada ocorrência válida." }
            : { label: "Única", title: "Concede pontos uma vez por participante neste evento." };
    };
    const rankingScoreBoost = dataTable.json.configs.ranking.score_boost || {};
    const scoreBoostWindows = getGlobalScoreBoostWindows(rankingScoreBoost);
    const scoreBoostEnabled = rankingScoreBoost.enabled === true
        || rankingScoreBoost.enabled === 1
        || rankingScoreBoost.enabled === "1"
        || rankingScoreBoost.enabled === "true";
    const activitiesOnly = dataTable.json.configs.ranking.scoreAggregation === "activities_only";
    const visibleScoreGroups = activitiesOnly
        ? scoreGroups.filter((group) => group.key === "activities")
        : scoreGroups;
    const visibleScoreRules = scoreRules.filter((rule) => visibleScoreGroups.some((group) => group.types.includes(rule.type)));
    const hasActivityScoreSection = visibleScoreRules.some((rule) => scoreGroups.find((group) => group.key === "activities")?.types.includes(rule.type));
    const availableScoreTypeCount = visibleScoreRules.length + (hasActivityScoreSection ? 1 : 0);
    const possibleScoreTotal = visibleScoreRules.reduce((total, rule) => total + Number(rule.value || 0), 0)
        + (hasActivityScoreSection ? Number(quizPossibleScore || 0) : 0);

    const persistScoreBoostWindows = (windows) => {
        setFieldValue("json.configs.ranking.score_boost.windows", windows);
        setFieldValue("json.configs.ranking.score_boost.start_at", null);
        setFieldValue("json.configs.ranking.score_boost.end_at", null);
    };

    const updateScoreBoostDate = (index, field, value) => {
        const isDateObject = value && typeof value.format === "function";
        const displayValue = isDateObject
            ? value.format("DD/MM/YYYY HH:mm")
            : String(value ?? "");
        if (isDateObject) {
            const parsedDate = parseGlobalScoreBoostDate(displayValue);
            if (!parsedDate || !isWithinEventPeriod(parsedDate, eventStart, eventEnd)) return;
        }
        persistScoreBoostWindows(scoreBoostWindows.map((window, windowIndex) => (
            windowIndex === index
                ? {
                    ...window,
                    [field]: isDateObject
                        ? toGlobalScoreBoostDate(displayValue)
                        : displayValue || null,
                }
                : window
        )));
    };

    const updateScoreBoostMultiplier = (index, value) => {
        persistScoreBoostWindows(scoreBoostWindows.map((window, windowIndex) => (
            windowIndex === index
                ? { ...window, multiplier: value === "" ? "" : Number(value) }
                : window
        )));
    };

    const addScoreBoostWindow = () => {
        const defaultStart = getDefaultScoreBoostStart(eventStart, eventEnd).toISOString();
        const defaultEnd = toGlobalScoreBoostDate(dataTable.end_date);
        persistScoreBoostWindows([
            ...scoreBoostWindows,
            {
                start_at: defaultStart,
                end_at: defaultEnd,
                multiplier: GLOBAL_SCORE_BOOST_DEFAULT_MULTIPLIER,
            },
        ]);
    };

    const removeScoreBoostWindow = (index) => {
        persistScoreBoostWindows(scoreBoostWindows.filter((_, windowIndex) => windowIndex !== index));
    };

    const toggleScoreBoost = (event) => {
        const enabled = event.target.checked;
        setFieldValue("json.configs.ranking.score_boost.enabled", enabled);
    };

    useEffect(() => {
        if (dataTable.json.configs.ranking.enableAchievements !== true) {
            setFieldValue("json.configs.ranking.enableAchievements", true);
        }
    }, [dataTable.json.configs.ranking.enableAchievements, setFieldValue]);

    useEffect(() => {
        let active = true;
        setLoadingScores(true);
        axios.get(`/api/event/plataformaEventos/scores/${dataTable.event_id}`)
            .then((response) => {
                if (active) setScoreRules(response.data.scores || []);
            })
            .catch(() => {
                notyf.open({ type: "danger", message: "Não foi possível carregar o sistema de pontuação", dismissible: true });
            })
            .finally(() => {
                if (active) setLoadingScores(false);
            });
        return () => { active = false; };
    }, [dataTable.event_id, notyf]);

    useEffect(() => {
        let active = true;
        axios.get("/api/event/plataformaEventos/component", {
            params: { event_id: dataTable.event_id, component_type: "atividades" },
        }).then((response) => {
            if (!active) return;
            const activities = Array.isArray(response.data.message) ? response.data.message : [];
            setQuizPossibleScore(activities
                .filter((activity) => Number(activity.app_id) === 1)
                .reduce((total, activity) => total + getQuizPossibleScore(activity), 0));
        }).catch(() => { if (active) setQuizPossibleScore(0); });
        return () => { active = false; };
    }, [dataTable.event_id]);

    const changeScoreValue = (id, rawValue) => {
        setScoreRules((current) => current.map((rule) => (
            Number(rule.id) === Number(id) ? { ...rule, value: rawValue } : rule
        )));
    };

    const saveScoreRules = async () => {
        const scores = scoreRules.map((rule) => ({ id: Number(rule.id), value: Number(rule.value) }));
        if (scores.some((rule) => !Number.isInteger(rule.value) || rule.value < 0 || rule.value > 1000000)) {
            notyf.open({ type: "danger", message: "Use valores inteiros entre 0 e 1.000.000", dismissible: true });
            return;
        }
        setSavingScores(true);
        try {
            const response = await axios.put(`/api/event/plataformaEventos/scores/${dataTable.event_id}`, { scores });
            setScoreRules(response.data.scores || []);
            setDataTableUpdate((current) => current + 1);
            notyf.open({ type: "success", message: "Pontuação atualizada e ranking recalculado", dismissible: true });
        } catch (error) {
            notyf.open({ type: "danger", message: error.response?.data?.message || "Não foi possível salvar a pontuação", dismissible: true });
        } finally {
            setSavingScores(false);
        }
    };

    const deleteActivityScore = async (scoreId) => {
        setDeletingScoreId(Number(scoreId));
        try {
            const response = await axios.delete(`/api/event/plataformaEventos/scores/${dataTable.event_id}/${scoreId}`);
            setScoreRules(response.data.scores || []);
            setDataTableUpdate((current) => current + 1);
            notyf.open({ type: "success", message: "Pontuação personalizada removida", dismissible: true });
        } catch (error) {
            notyf.open({ type: "danger", message: error.response?.data?.message || "Não foi possível remover a pontuação", dismissible: true });
        } finally {
            setDeletingScoreId(null);
        }
    };

    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Sistema de pontuação</h5>
            </Form.Group>
            <h6 className="text-muted mt-3">Configure quais ações geram pontos e como elas entram no ranking dos participantes.</h6>
            <Form.Group as={Col} sm="12">
                <Form.Label>Tipo de sistema</Form.Label>
                <Form.Select
                    name="json.configs.ranking.scoreAggregation"
                    value={dataTable.json.configs.ranking.scoreAggregation || "all"}
                    onChange={(event) => setFieldValue("json.configs.ranking.scoreAggregation", event.target.value)}
                >
                    <option value="all">Todas as fontes de pontuação</option>
                    <option value="activities_only">Somente atividades</option>
                </Form.Select>
            </Form.Group>
            <Form.Group as={Col} sm="12" className="mt-4">
                <Form.Check
                    type="checkbox"
                    label="Ativar multiplicadores extras nos períodos"
                    checked={scoreBoostEnabled}
                    onChange={toggleScoreBoost}
                />
                <Form.Text className="text-muted d-block">
                    Novas pontuações elegíveis usam o multiplicador configurado. Em períodos sobrepostos, vale o maior multiplicador.
                </Form.Text>
            </Form.Group>
            {scoreBoostEnabled && (
                <Col sm="12" className="mt-3">
                    <p className="fw-bold mb-0">Períodos de bônus</p>
                    <p className="text-muted small mb-3">
                        Cada período usa o maior multiplicador aplicável. Os horários são exibidos em São Paulo e salvos em UTC.
                    </p>
                    {scoreBoostWindows.map((window, index) => (
                        <Card className="mb-3 bg-transparent border rounded shadow-none" key={`score-boost-window-${index}`}>
                            <Card.Body>
                                <strong className="d-block mb-0">Período {index + 1}</strong>
                                <Row className="g-2 align-items-end">
                                    <Form.Group as={Col} md="4">
                                        <Form.Label>Início</Form.Label>
                                        <Datetime
                                            value={getGlobalScoreBoostDateInput(window.start_at)}
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="HH:mm"
                                            locale="pt-br"
                                            closeOnSelect
                                            isValidDate={buildEventDatePredicate(eventStart, eventEnd)}
                                            onChange={(value) => updateScoreBoostDate(index, "start_at", value)}
                                            inputProps={{ placeholder: "DD/MM/AAAA HH:mm", readOnly: false }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label>Fim</Form.Label>
                                        <Datetime
                                            value={getGlobalScoreBoostDateInput(window.end_at)}
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="HH:mm"
                                            locale="pt-br"
                                            closeOnSelect
                                            isValidDate={buildEventDatePredicate(eventStart, eventEnd)}
                                            onChange={(value) => updateScoreBoostDate(index, "end_at", value)}
                                            inputProps={{ placeholder: "DD/MM/AAAA HH:mm", readOnly: false }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label>Multiplicador</Form.Label>
                                        <Form.Control
                                            type="number"
                                            min={GLOBAL_SCORE_BOOST_MIN_MULTIPLIER}
                                            max={GLOBAL_SCORE_BOOST_MAX_MULTIPLIER}
                                            step="0.01"
                                            value={window.multiplier ?? GLOBAL_SCORE_BOOST_DEFAULT_MULTIPLIER}
                                            onChange={(event) => updateScoreBoostMultiplier(index, event.target.value)}
                                        />
                                    </Form.Group>
                                </Row>
                                <div className="d-flex justify-content-end mt-3">
                                    <Button
                                        type="button"
                                        variant="danger"
                                        title="Remover período de bônus"
                                        aria-label={`Remover período de bônus ${index + 1}`}
                                        onClick={() => removeScoreBoostWindow(index)}
                                    >
                                        <FontAwesomeIcon icon={faClose} />
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    ))}
                    <Button type="button" variant="primary" onClick={addScoreBoostWindow}>
                        Adicionar período de bônus
                    </Button>
                </Col>
            )}
            <Col sm="12" className="mt-4">
                <div className="mb-2">
                    <div>
                        <p className="text-start fw-bold mb-2">Origem de pontuações</p>
                        <div><small className="text-muted">Os valores são exclusivos deste evento e recalculam o ranking retroativamente. Zero mantém o histórico, mas faz a regra valer zero ponto.</small></div>
                    </div>
                </div>
                {loadingScores ? <Loader /> : visibleScoreGroups.map((group) => {
                    const rules = scoreRules.filter((rule) => group.types.includes(rule.type));
                    if (!rules.length) return null;
                    return (
                        <section key={group.title} className="border rounded p-3 mb-3">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-1 mb-1">
                                <span>{group.title}</span>
                                {group.key === "activities" && <small className="text-muted">Estes valores definem a pontuação base de cada atividade</small>}
                            </div>
                            <div>
                                {group.key === "activities" && (
                                    <Row className="g-2 align-items-center border-bottom py-2 mx-0">
                                        <Col>
                                            <div className="d-flex flex-wrap align-items-center gap-2">
                                                <strong>Quiz</strong>
                                                <Badge bg="secondary" title="Pode conceder pontos uma vez por ocorrência válida da atividade.">Por atividade</Badge>
                                            </div>
                                            <small className="text-muted d-block">
                                                A pontuação no ranking é a soma verificada dos “Pontos por acerto” definidos em cada pergunta.
                                            </small>
                                        </Col>
                                        <Col xs="8" md="3">
                                            <Form.Control value={`${quizPossibleScore} pontos`} disabled />
                                        </Col>
                                    </Row>
                                )}
                                {rules.map((rule, index) => {
                                    const repeatability = getScoreRepeatability(rule.type, group.key);
                                    const isLastRule = index === rules.length - 1;
                                    return (
                                        <Row key={rule.id} className={`g-2 align-items-center ${!isLastRule ? "border-bottom" : ""} py-2 mx-0`}>
                                            <Col md>
                                                {group.key === "activities" ? (
                                                    <>
                                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                                            <strong>{activityScoreSourceLabels[rule.type]?.title}</strong>
                                                            <Badge bg="secondary" title={repeatability.title}>{repeatability.label}</Badge>
                                                        </div>
                                                        <small className="text-muted d-block">
                                                            {Number(rule.is_custom) === 1
                                                                ? rule.description
                                                                : formatActivityScoreOption(rule)}
                                                        </small>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                                            <strong>{scoreSourceLabels[rule.type] || rule.description || rule.type}</strong>
                                                            <Badge bg="secondary" title={repeatability.title}>{repeatability.label}</Badge>
                                                        </div>
                                                        {Number(rule.is_custom) === 1 && rule.description && (
                                                            <small className="text-muted d-block">{rule.description}</small>
                                                        )}
                                                    </>
                                                )}
                                            </Col>
                                            <Col xs="8" md="3">
                                                <InputGroup>
                                                    <Form.Control
                                                        type="number"
                                                        onBlur={saveScoreRules}
                                                        min="0"
                                                        max="1000000"
                                                        step="1"
                                                        value={rule.value}
                                                        onChange={(event) => changeScoreValue(rule.id, event.target.value)}
                                                    />
                                                    {Number(rule.is_custom) === 1 && (
                                                        <Button
                                                            type="button"
                                                            variant="danger"
                                                            disabled={!rule.can_delete || deletingScoreId === Number(rule.id)}
                                                            title={rule.activity_count > 0
                                                                ? "Esta pontuação está associada a uma atividade salva"
                                                                : rule.award_count > 0
                                                                    ? "Esta pontuação já possui pontos concedidos"
                                                                    : "Remover pontuação personalizada"}
                                                            aria-label="Remover pontuação personalizada"
                                                            onClick={() => deleteActivityScore(rule.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faClose} />
                                                        </Button>
                                                    )}
                                                </InputGroup>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </div>
                            {group.key === "activities" && !loadingScores && (
                                <div className="border-top pt-3 mt-4">
                                    <Button type="button" variant="primary" aria-label="Nova regra de pontuação" title="Nova regra de pontuação" onClick={() => setShowActivityScoreModal(true)}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Button>
                                </div>
                            )}
                        </section>
                    );
                })}
                {!loadingScores && (
                    <div className="border rounded p-3 mt-4 mb-3">
                        <div className="border-bottom pb-1 mb-3">
                            <span>Resumo da pontuação</span>
                        </div>
                        <Row className="g-3">
                            <Col md={6}>
                                <small className="text-muted d-block">Tipos de pontuação disponíveis</small>
                                <strong className="fs-4">{availableScoreTypeCount}</strong>
                            </Col>
                            <Col md={6}>
                                <small className="text-muted d-block">Pontuação possível</small>
                                <strong className="fs-4">{possibleScoreTotal.toLocaleString("pt-BR")} pontos</strong>
                            </Col>
                        </Row>
                        <small className="text-muted d-block mt-3">
                            Inclui todas as pontuações únicas e uma ocorrência de cada pontuação repetível ou por atividade.
                        </small>
                    </div>
                )}
            </Col>
            <Form.Group as={Col} className="mt-4 textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Conquistas</h5>
            </Form.Group>
            <Form.Group className="mt-3">
                <Form.Check
                    className="w-auto"
                    checked={dataTable.json.configs.ranking.showAchievements !== false}
                    type="checkbox"
                    name="json.configs.ranking.showAchievements"
                    label={<>Exibir conquistas para participantes <OverlayTrigger overlay={<Tooltip>Controla somente a página de Conquistas e seus avisos. Desative para manter o registro e o progresso salvos sem mostrar conquistas ou notificações ao participante.</Tooltip>}>
                        <HelpTooltip icon={faExclamationCircle} />
                    </OverlayTrigger></>}
                    onChange={() => {
                        setFieldValue(
                            "json.configs.ranking.showAchievements",
                            dataTable.json.configs.ranking.showAchievements === false
                        );
                    }}
                />
            </Form.Group>
            {dataTable.json.configs.ranking.showAchievements !== false && (
                <Col sm="12" className="mt-3">
                    <Card className="mb-3 bg-transparent border rounded shadow-none">
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                <div>
                                    <span className="fw-bold d-block">Catálogo de conquistas</span>
                                </div>
                                <Badge bg="secondary">{PLATFORM02_ACHIEVEMENT_CATALOG.length}</Badge>
                            </div>
                            <Table responsive hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">Categoria</th>
                                        <th scope="col">Conquista</th>
                                        <th scope="col">Como conquistar</th>
                                        <th scope="col">Meta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {PLATFORM02_ACHIEVEMENT_CATALOG.map((achievement) => (
                                        <tr key={achievement.code}>
                                            <td>{achievement.category}</td>
                                            <th scope="row">{achievement.title}</th>
                                            <td>{achievement.logic}</td>
                                            <td>{achievement.target}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
            )}
            <ActivityScoreRuleModal
                show={showActivityScoreModal}
                onHide={() => setShowActivityScoreModal(false)}
                eventId={dataTable.event_id}
                onCreated={(score, scores) => {
                    setScoreRules(scores);
                    setDataTableUpdate((current) => current + 1);
                    notyf.open({ type: "success", message: "Regra de pontuação criada", dismissible: true });
                }}
            />
        </Row >
    )
}

export const TabRestaurante = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError }) => {
    const [currentBanner, setCurrentBanner] = useState(0);

    // Initialize banner array if it doesn't exist, is not an array, or is empty
    React.useEffect(() => {
        const bannerValue = dataTable.json.configs?.restaurant?.banner;
        if (!bannerValue || !Array.isArray(bannerValue) || bannerValue.length === 0) {
            setFieldValue("json.configs.restaurant.banner", bannerValue && !Array.isArray(bannerValue) ? [bannerValue] : [""]);
        }
    }, [dataTable.json.configs?.restaurant?.banner, setFieldValue]);

    // Ensure banner is array for processing
    const banners = Array.isArray(dataTable.json.configs?.restaurant?.banner)
        ? dataTable.json.configs.restaurant.banner
        : [dataTable.json.configs?.restaurant?.banner || ""];

    function newBanner() {
        if (banners.length < 4) {
            const updatedBanners = [...banners, ""];
            setFieldValue("json.configs.restaurant.banner", updatedBanners);
            setCurrentBanner(updatedBanners.length - 1);
        }
    }

    function deleteBanner(index) {
        if (banners.length > 1) {
            const updatedBanners = banners.filter((_, i) => i !== index);
            setFieldValue("json.configs.restaurant.banner", updatedBanners);
            setCurrentBanner(Math.max(0, index - 1));
        } else {
            // When only one banner remains, set it to empty string to show empty background
            const updatedBanners = [...banners];
            updatedBanners[index] = "";
            setFieldValue("json.configs.restaurant.banner", updatedBanners);
            setCurrentBanner(Math.max(0, index - 1));
        }
    }

    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo mb-3">
                <h5 className="card-title mb-0">Banners</h5>
            </Form.Group>
            <ButtonToolbar className="mb-4 justify-content-center">
                {banners.map((banner, index) => {
                    let hasError = false;
                    if (errors?.json?.configs?.restaurant?.banner && Array.isArray(errors.json.configs.restaurant.banner)) {
                        hasError = !!errors.json.configs.restaurant.banner[index];
                    }
                    return (
                        <Button
                            key={"bannerButton" + index}
                            className={`mt-3 me-2 buttonToolbarApp ${hasError ? 'is-invalid' : ''} ${currentBanner === index ? 'active' : ''}`}
                            onClick={() => setCurrentBanner(index)}
                        >
                            {index + 1}
                        </Button>
                    );
                })}
                <Button onClick={() => newBanner()} className="mt-3 ms-2" disabled={banners.length >= 4}>
                    Adicionar
                </Button>
            </ButtonToolbar>
            <Row className="mx-0 mb-3">
                {banners.map((banner, index) => {
                    if (index !== currentBanner) {
                        return ("");
                    }
                    return (
                        <Form.Group
                            as={Col}
                            className="mb-3"
                            md="12"
                            key={index + 'banner'}>
                            <Card className="mb-3">
                                <Card.Body>
                                    <Form.Control
                                        type="hidden"
                                        name={`json.configs.restaurant.banner[${index}]`}
                                        value={banners[index]}
                                        onChange={handleChange}
                                        isInvalid={!!errors?.json?.configs?.restaurant?.banner?.[index]}
                                        isValid={touched?.json?.configs?.restaurant?.banner?.[index] && !errors?.json?.configs?.restaurant?.banner?.[index]}
                                    />
                                    <div className="imagesUpload">
                                        <img
                                            className={`h-100 img-thumbnail ${!!errors?.json?.configs?.restaurant?.banner?.[index] ? "is-invalid" : ""}`}
                                            src={
                                                banners[index] !== "" && banners[index] !== null
                                                    ? domainConfig.imageServer +
                                                    "/plataforma-eventos/" +
                                                    dataTable.event_id +
                                                    "/" +
                                                    banners[index]
                                                    : domainConfig.imageServer + "/empty-background.png"
                                            }
                                            alt="Banner preview"
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.json?.configs?.restaurant?.banner?.[index]}
                                        </Form.Control.Feedback>
                                    </div>
                                    <DropzoneComponent
                                        className="mt-3 dropzoneComp"
                                        type="image"
                                        handlePreviewSuccess={handlePreviewSuccess}
                                        handlePreviewError={handlePreviewError}
                                        setFieldValue={setFieldValue}
                                        folder="plataforma-eventos"
                                        id={dataTable.event_id}
                                        field={`json.configs.restaurant.banner[${index}]`}
                                    />
                                </Card.Body>
                            </Card>
                        </Form.Group>
                    );
                })}
                {(banners.length > 1 || banners[currentBanner] !== "") && <Col className="text-center">
                    <Button
                        variant="danger"
                        className="mb-3"
                        onClick={() => deleteBanner(currentBanner)}
                    >
                        Excluir Banner
                    </Button>
                </Col>}
            </Row>
        </Row>
    )
}

export const TabSocial = ({ setFieldValue, dataTable }) => {
    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Social</h5>
            </Form.Group>
            <Form.Group className="mt-3">
                <Form.Label>Conversas</Form.Label>
                <Form.Check
                    className="w-auto"
                    checked={dataTable?.json?.chat?.enableGroups !== false}
                    type="checkbox"
                    name="json.chat.enableGroups"
                    label="Habilitar bate-papos em grupo"
                    onChange={(event) => setFieldValue("json.chat.enableGroups", event.target.checked)}
                />
            </Form.Group>
        </Row>
    );
};

export const TabComunicados = () => {
    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Row className="mx-0 mb-3">
                <p className="my-5 text-center opacity-75">
                    Nenhuma configuração disponível
                </p>
            </Row>
        </Row>
    )
}

export const TabColetaDeLead = ({ setFieldValue, dataTable }) => {
    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Form.Group className="mt-3">
                <Form.Check
                    className="w-auto"
                    checked={dataTable.json.configs.leadCollection.showNotRegistered ? true : false}
                    type="checkbox"
                    name="json.configs.leadCollection.showNotRegistered"
                    label="Mostrar participantes não registrados para o usuário"
                    onChange={(e) => {
                        setFieldValue(
                            "json.configs.leadCollection.showNotRegistered",
                            dataTable.json.configs.leadCollection.showNotRegistered ? false : true
                        );
                    }}
                />
            </Form.Group>
        </Row>
    )
}

export const TabParticipantes = ({ setFieldValue, dataTable, values }) => {
    return (
        <Row className="mb-3 mx-0">
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Form.Group>
                <Form.Check
                    className="w-auto mt-3"
                    checked={dataTable.json.configs.networking.qrcodeOnly ? true : false}
                    type="checkbox"
                    label="Remover botões de interação e adicionar contatos apenas via Código QR"
                    onChange={(e) => {
                        setFieldValue(
                            "json.configs.networking.qrcodeOnly",
                            dataTable.json.configs.networking.qrcodeOnly ? false : true
                        );
                    }}
                />
            </Form.Group>
        </Row>
    )
}

const TabExhibitors = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [showCollectedModal, setShowCollectedModal] = useState({ show: false, data: null });
    const [modal, setModal] = useState({ showSocialMediaForm: false, showGalleryItemForm: false });
    const [zipIsReady, setZipIsReady] = useState(true);
    const [triggerExport, setTriggerExport] = useState(false);

    const fetchExhibitorModalData = async (exhibitorData = null) => {
        setLoading(true);

        try {
            const response = await axios.get('/api/event/plataformaEventos/component', {
                params: {
                    event_id: dataTable.event_id,
                    component_type: 'expositores',
                    current_exhibitor_id: exhibitorData?.id || undefined,
                }
            });

            setDataAddForm((prevState) => ({
                ...prevState,
                addFieldData: false,
                socialMedia: exhibitorData?.json?.social_media || [],
                gallery: exhibitorData?.json?.gallery || [],
                allActivities: response.data.additionalData?.allActivities || prevState.allActivities,
                availableQuizActivities: response.data.additionalData?.availableQuizActivities || [],
                availableUsers: response.data.additionalData?.availableUsers || []
            }));

            return true;
        } catch (error) {
            notyf.open({
                type: "danger",
                message: "Houve um erro ao carregar os dados do expositor",
                ripple: true,
                dismissible: true,
            });
            return false;
        } finally {
            setLoading(false);
        }
    };

    const registerExhibitor = (props, actions) => {
        setLoading(true)

        // Create a deep copy to avoid mutating the original props
        const updatedValues = JSON.parse(JSON.stringify(props));

        let id = null;
        if (updatedValues.id) {
            id = updatedValues.id;
        }
        delete updatedValues.id;

        // Extract user_id for separate handling
        let user_id = updatedValues.user_id;
        delete updatedValues.user_id;

        const rawQuizTips = Array.isArray(updatedValues.quiz_tips) ? updatedValues.quiz_tips : [];
        delete updatedValues.quiz_tips;

        updatedValues.social_media = dataAddForm.socialMedia;
        updatedValues.gallery = dataAddForm.gallery;

        updatedValues.quiz_tips = rawQuizTips
            .filter((tip) => {
                const a = Number(tip?.activity_id);
                const q = Number(tip?.question_id);
                return Number.isInteger(a) && a > 0 && Number.isInteger(q) && q > 0;
            })
            .map((tip) => ({
                activity_id: Number(tip.activity_id),
                question_id: Number(tip.question_id),
            }))
            .reduce((acc, entry) => {
                if (!acc.find((e) => e.activity_id === entry.activity_id)) acc.push(entry);
                return acc;
            }, []);

        // Process categories string into array
        if (updatedValues.categories && typeof updatedValues.categories === 'string') {
            updatedValues.categories = updatedValues.categories
                .split(',')
                .map(category => category.trim())
                .filter(category => category.length > 0);
        } else {
            updatedValues.categories = [];
        }

        let json = JSON.stringify(updatedValues);

        if (id) {
            axios.put(`/api/event/plataformaEventos/component`, {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'expositores',
                json: json,
                user_id: user_id
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Expositor registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: error?.response?.data?.message || 'Houve um erro no registro do expositor',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            // Create new exhibitor
            axios.post("/api/event/plataformaEventos/component", {
                event_id: dataTable.event_id,
                component_type: 'expositores',
                json: json,
                user_id: user_id
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    // Refresh component data
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Expositor registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: error?.response?.data?.message || 'Houve um erro no registro do expositor',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    };

    const validateExhibitorAccount = (values) => {
        const validationErrors = {};

        if (!(Number(values.user_id) > 0)) {
            validationErrors.user_id = 'Associe uma conta de usuário ao expositor.';
        }

        const quizTipDiagnostics = getExhibitorQuizTipDiagnostics(values);
        if (quizTipDiagnostics.missingActivityIds.length > 0) {
            validationErrors.quiz_tips = 'Selecione uma questão para cada quiz habilitado na dinâmica do expositor.';
        }

        return validationErrors;
    };

    const getExhibitorQuizTipDiagnostics = (values = {}) => {
        const exhibitorConfig = dataTable?.json?.configs?.exhibitor || {};
        const quizTipsRequired = !!exhibitorConfig.enableCollection && !!exhibitorConfig.enableQuizTips;
        const configuredQuizActivityIds = quizTipsRequired && Array.isArray(exhibitorConfig.quizActivityIds)
            ? [...new Set(
                exhibitorConfig.quizActivityIds
                    .map((id) => Number(id))
                    .filter((id) => Number.isInteger(id) && id > 0)
            )]
            : [];
        const allActivityIds = new Set((dataAddForm.allActivities || []).map((activity) => Number(activity.id)));
        const requiredQuizActivityIds = configuredQuizActivityIds.filter((activityId) => allActivityIds.has(activityId));
        const selectedQuizTips = Array.isArray(values.quiz_tips)
            ? values.quiz_tips
                .map((tip) => ({
                    activity_id: Number(tip?.activity_id),
                    question_id: Number(tip?.question_id),
                }))
                .filter((tip) => Number.isInteger(tip.activity_id) && tip.activity_id > 0 && Number.isInteger(tip.question_id) && tip.question_id > 0)
            : [];
        const selectedActivityIds = new Set(selectedQuizTips.map((tip) => tip.activity_id));
        const visibleActivityIds = new Set((dataAddForm.availableQuizActivities || []).map((activity) => Number(activity.id)));
        const allActivitiesById = new Map((dataAddForm.allActivities || []).map((activity) => [Number(activity.id), activity]));
        const staleActivityIds = configuredQuizActivityIds.filter((activityId) => !allActivityIds.has(activityId));
        const missingActivityIds = requiredQuizActivityIds.filter((activityId) => !selectedActivityIds.has(activityId));
        const unavailableActivityIds = requiredQuizActivityIds.filter((activityId) => !visibleActivityIds.has(activityId));

        return {
            configuredQuizActivityIds,
            requiredQuizActivityIds,
            staleActivityIds,
            selectedQuizTips,
            missingActivityIds,
            unavailableActivityIds,
            staleActivities: staleActivityIds.map((activityId) => `Quiz ${activityId}`),
            missingActivities: missingActivityIds.map((activityId) => allActivitiesById.get(activityId)?.title || `Quiz ${activityId}`),
            unavailableActivities: unavailableActivityIds.map((activityId) => allActivitiesById.get(activityId)?.title || `Quiz ${activityId}`),
        };
    };

    const logBlockedExhibitorSave = (values, errors) => {
        const quizTipDiagnostics = getExhibitorQuizTipDiagnostics(values);
        const formErrors = errors || {};
        const hasBlockingError = Object.keys(formErrors).length > 0 || quizTipDiagnostics.missingActivityIds.length > 0;

        if (!hasBlockingError) {
            return;
        }

        console.warn('[TabExhibitors] Save blocked by form validation', {
            event_id: dataTable?.event_id,
            exhibitor_id: values?.id || null,
            user_id: values?.user_id || null,
            errors: formErrors,
            quizTipDiagnostics,
        });

        if (quizTipDiagnostics.missingActivityIds.length > 0) {
            notyf.open({
                type: "danger",
                message: `Selecione uma questão para cada quiz habilitado: ${quizTipDiagnostics.missingActivities.join(', ')}`,
                ripple: true,
                dismissible: true,
            });
        }
    };

    const getActiveExhibitorQuizActivityIds = () => {
        const configuredQuizActivityIds = Array.isArray(dataTable?.json?.configs?.exhibitor?.quizActivityIds)
            ? dataTable.json.configs.exhibitor.quizActivityIds
                .map((id) => Number(id))
                .filter((id) => Number.isInteger(id) && id > 0)
            : [];
        const validQuizActivityIds = new Set((dataAddForm.allActivities || []).map((activity) => Number(activity.id)));

        return [...new Set(configuredQuizActivityIds)].filter((activityId) => validQuizActivityIds.has(activityId));
    };

    const getVisibleExhibitorQuizActivities = () => {
        const activeQuizActivityIds = getActiveExhibitorQuizActivityIds();

        if (activeQuizActivityIds.length === 0) {
            return [];
        }

        return (dataAddForm.availableQuizActivities || []).filter(
            (activity) => activeQuizActivityIds.some((id) => Number(id) === Number(activity.id))
        );
    };

    const getExhibitorValidationDataTable = () => ({
        ...dataTable,
        json: {
            ...dataTable?.json,
            configs: {
                ...dataTable?.json?.configs,
                exhibitor: {
                    ...dataTable?.json?.configs?.exhibitor,
                    quizActivityIds: getActiveExhibitorQuizActivityIds(),
                },
            },
        },
    });

    const getExhibitorAccountOptions = (values = {}) => {
        const optionsMap = new Map();

        (dataAddForm.availableUsers || []).forEach((user) => {
            const normalizedUserId = Number(user.user_id);
            if (Number.isInteger(normalizedUserId) && normalizedUserId > 0 && Number(user.type) === 2) {
                optionsMap.set(normalizedUserId, {
                    ...user,
                    user_id: normalizedUserId,
                });
            }
        });

        if (values.user_id && showEditModal.data.email && Number(showEditModal.data.user_type) === 2) {
            const normalizedUserId = Number(values.user_id);
            if (Number.isInteger(normalizedUserId) && normalizedUserId > 0 && !optionsMap.has(normalizedUserId)) {
                optionsMap.set(normalizedUserId, {
                    user_id: normalizedUserId,
                    email: showEditModal.data.email,
                    access_code: showEditModal.data.access_code,
                    type: showEditModal.data.user_type,
                });
            }
        }

        return Array.from(optionsMap.values()).sort((a, b) => String(a.email || '').localeCompare(String(b.email || '')));
    };

    const getSelectedExhibitorAccount = (values = {}) => {
        const normalizedUserId = Number(values.user_id);
        if (!Number.isInteger(normalizedUserId) || normalizedUserId <= 0) {
            return null;
        }

        return getExhibitorAccountOptions(values).find((user) => Number(user.user_id) === normalizedUserId) || null;
    };

    const handleDownloadExhibitorQRCode = (exhibitor) => {
        if (!exhibitor?.user_id) {
            notyf.open({
                type: "danger",
                message: 'Associe uma conta ao expositor antes de gerar o código QR.',
                ripple: true,
                dismissible: true,
            });
            return;
        }

        if (exhibitor.json) {
            downloadQRCode(
                `${domainConfig.eventos}/?token=${encodeURIComponent(dataTable.token)}&addCode=${encodeURIComponent(createCode(exhibitor.id))}`,
                exhibitor.name || exhibitor.json?.name || `exhibitor_${exhibitor.id}`,
            );
        }
    };

    const createCode = (id) => {
        const code = 'exhibitor=' + id
        return window.btoa(code); // Make sure it's 'exhibitor='
    }

    const showQuizAssociationColumn =
        !!dataTable?.json?.configs?.exhibitor?.enableCollection &&
        !!dataTable?.json?.configs?.exhibitor?.enableQuizTips &&
        Array.isArray(dataTable?.json?.configs?.exhibitor?.quizActivityIds) &&
        dataTable.json.configs.exhibitor.quizActivityIds.length > 0;

    const tableColumns = [
        {
            Header: "Logo",
            accessor: "logo",
            Cell: (cell) => {
                if (cell.value) {
                    return (
                        <a className="img-table-components" onClick={(e) => { e.preventDefault(); setShowImageModal({ url: `${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.value}`, show: true }) }} rel="noreferrer"><img src={`${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.value}`} alt=""></img></a>
                    )
                } else {
                    return ""
                }
            },
            Filter: false,
        },
        {
            Header: "Nome",
            accessor: "name",
            sortDescFirst: false // This column will sort ascending first when clicked
        },
        {
            Header: "Descrição",
            accessor: "description",
        },
        {
            Header: "Categorias",
            accessor: "categoriesStr"
        },
        {
            Header: "Usuário associado",
            accessor: "userName"
        },
        ...(showQuizAssociationColumn ? [{
            Header: 'Status da questão',
            accessor: 'quizAssociationStatusLabel',
            Cell: (cell) => {
                return (
                    <Badge bg={cell.row.original.quizAssociationStatus ? 'success' : 'danger'}>
                        {cell.row.original.quizAssociationStatus ? 'Questão associada' : 'Não associado'}
                    </Badge>
                );
            }
        }] : []),
        {

            Header: 'Quantia de vezes "Coletado"',
            accessor: "total_collected",
            Cell: (cell) => {
                return cell.row.original.total_collected || 0;
            }
        },
        {
            Header: 'Quantia de vezes "Favoritado"',
            accessor: "favorite_count",
            Cell: (cell) => {
                return cell.row.original.favorite_count || 0;
            }
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                // Defensive check to ensure we have the expected data structure
                if (!cell.row.original || !cell.row.original.id) {
                    return null;
                }
                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteExhibitor(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                        {cell.row.original.user_id && (
                            <OverlayTrigger overlay={<Tooltip>Baixar Código QR</Tooltip>}>
                                <Download
                                    role="button"
                                    className="align-middle cursor-pointer me-2"
                                    onClick={() => {
                                        handleDownloadExhibitorQRCode(cell.row.original);
                                    }}
                                    size={18}
                                />
                            </OverlayTrigger>
                        )}
                        <OverlayTrigger overlay={<Tooltip>Ver coletados</Tooltip>}>
                            <Users
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => setShowCollectedModal({ show: true, data: cell.row.original })}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer"
                                onClick={() => handleDataExhibitor(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                    </>
                );
            },
        },
    ];

    const addExhibitor = async () => {
        const json = jsonComponents(selectedValue.value);
        const modalDataLoaded = await fetchExhibitorModalData();

        if (!modalDataLoaded) {
            return;
        }

        setShowEditModal({ show: true, data: json });
    };

    const handleDataExhibitor = async (exhibitorData) => {
        const json = jsonComponents(selectedValue.value);
        const normalizedJson = fillMissingProperties(exhibitorData.json, json);
        const normalizedExhibitorData = {
            ...exhibitorData,
            json: normalizedJson,
        };
        const modalDataLoaded = await fetchExhibitorModalData(normalizedExhibitorData);

        if (!modalDataLoaded) {
            return;
        }

        setShowEditModal({ show: true, data: { id: exhibitorData.id, user_id: exhibitorData.user_id, email: exhibitorData.email, access_code: exhibitorData.access_code, user_type: exhibitorData.user_type, ...normalizedJson } });
    };

    const deleteExhibitor = (exhibitorData) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description={Number(exhibitorData?.user_id) > 0
                            ? <>Deseja excluir esse expositor? Todos os dados relacionados a ele serão excluídos. <br />A conta associada será alterada para Gestor.</>
                            : <>Deseja excluir esse expositor? Todos os dados relacionados a ele serão excluídos.</>}
                        action={handleDeleteExhibitor}
                        onClose={onClose}
                        param={exhibitorData}
                    />
                );
            },
        });
    }

    function handleDeleteExhibitor(exhibitorData) {
        setLoading(true);
        axios.delete(`/api/event/plataformaEventos/component`, {
            data: {
                id: exhibitorData?.id,
                event_id: dataTable.event_id,
                component_type: 'expositores',
                user_id: exhibitorData?.user_id || null,
            }
        })
            .then(function (response) {
                setLoading(false);
                notyf.open({
                    type: "success",
                    message: 'Expositor excluído com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                // Refresh component data
                setDataTableUpdate((prevCount) => prevCount + 1);
            })
            .catch(function (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: error?.response?.data?.message || 'Houve um erro ao excluir o expositor',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    function handleExportCollectedUsers(exhibitorData) {
        if (!exhibitorData || !exhibitorData.collectedUsers || exhibitorData.collectedUsers.length === 0) {
            notyf.open({
                type: "danger",
                message: "Nenhum participante coletado",
                ripple: true,
                dismissible: true,
            });
            return;
        }

        setLoading(true);

        try {
            let headers = [];
            dataTable.json.form.fields.forEach((element) => {
                headers.push({ value: element.label, inputID: element.inputID });
            });

            const data = exhibitorData.collectedUsers;
            const filename = `${dataTable.titulo} - ${exhibitorData.json?.name || 'Expositor'} (Coleta)`;

            getExcelFromObject({ filename, headers, data });

            notyf.open({
                type: "success",
                message: "Exportação realizada com sucesso",
                ripple: true,
                dismissible: true,
            });
        } catch (error) {
            notyf.open({
                type: "danger",
                message: "Houve um erro na exportação",
                ripple: true,
                dismissible: true,
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de expositores ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    const qrReadyExhibitors = (componentData || []).filter(
                                        (exhibitor) => Number(exhibitor.user_id) > 0,
                                    );

                                    if (qrReadyExhibitors.length === 0) {
                                        notyf.open({
                                            type: "danger",
                                            message: 'Associe uma conta aos expositores antes de exportar os códigos QR.',
                                            ripple: true,
                                            dismissible: true,
                                        });
                                        return;
                                    }

                                    if (qrReadyExhibitors.length !== (componentData || []).length) {
                                        notyf.open({
                                            type: "default",
                                            message: `${(componentData || []).length - qrReadyExhibitors.length} expositor(es) sem conta associada foram ignorados na exportação.`,
                                            ripple: true,
                                            dismissible: true,
                                        });
                                    }

                                    const transformedData = qrReadyExhibitors.map(exhibitor => ({
                                        exhibitor_id: exhibitor.id,
                                        exhibitor_name: exhibitor.name || exhibitor.json?.name || `Expositor ${exhibitor.id}`,
                                        type: 2,
                                        email: exhibitor.email,
                                    }));
                                    batchQRCodeDownload(setZipIsReady, transformedData, dataTable.title, dataTable.token, notyf, 2)
                                }}
                                disabled={!zipIsReady}
                            >
                                {zipIsReady ? 'Exportar Códigos QR\'s' : 'Gerando códigos QR...'}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addExhibitor()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie os expositores que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={componentData}
                        title={`${dataTable.title} - Expositores`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'name',
                                    desc: false // false = ascending, true = descending
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-fourth" : "",
                            style: {
                                textAlign: cellinfo.column.id === "logo" ? "center" : "",
                                width: cellinfo.column.id === "logo" ? "40px" : "",
                            }
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />}
            </div>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Row className="mb-3 mx-0">
                <Col md={12} className="mt-3">
                    <Form.Group className="mb-3">
                        <Form.Check
                            className="w-auto"
                            checked={dataTable.json.configs.exhibitor.enableCollection ? true : false}
                            type="checkbox"
                            name="json.configs.exhibitor.enableCollection"
                            label="Habilitar coleta de expositores"
                            onChange={(e) => {
                                setFieldValue(
                                    "json.configs.exhibitor.enableCollection",
                                    dataTable.json.configs.exhibitor.enableCollection ? false : true
                                );
                            }}
                        />
                        {dataTable.json.configs.exhibitor.enableCollection && (
                            <Form.Check
                                className="w-auto"
                                checked={dataTable.json.configs.exhibitor.enableQuizTips ? true : false}
                                type="checkbox"
                                name="json.configs.exhibitor.enableQuizTips"
                                label="Habilitar dinâmica de dicas do expositor no quiz"
                                onChange={() => {
                                    setFieldValue(
                                        'json.configs.exhibitor.enableQuizTips',
                                        dataTable.json.configs.exhibitor.enableQuizTips ? false : true
                                    );
                                }}
                            />
                        )}
                    </Form.Group>
                    {dataTable.json.configs.exhibitor.enableCollection && dataTable.json.configs.exhibitor.enableQuizTips && (
                        <Form.Group className="mb-3">
                            <Form.Label>Quizzes para dinâmica de dicas do expositor</Form.Label>
                            <Select
                                isMulti
                                options={(dataAddForm.allActivities || []).map((a) => ({
                                    value: a.id,
                                    label: a.title || 'Sem título',
                                }))}
                                value={getActiveExhibitorQuizActivityIds()
                                    .map((id) => {
                                        const act = (dataAddForm.allActivities || []).find(
                                            (a) => Number(a.id) === Number(id)
                                        );
                                        return act ? { value: act.id, label: act.title || 'Sem título' } : null;
                                    })
                                    .filter(Boolean)
                                }
                                onChange={(selected) => {
                                    setFieldValue(
                                        'json.configs.exhibitor.quizActivityIds',
                                        (selected || []).map((o) => Number(o.value))
                                    );
                                }}
                                placeholder="Selecione os quizzes..."
                                isClearable
                                noOptionsMessage={() => 'Nenhuma atividade de quiz disponível'}
                            />
                            <Form.Text className="text-muted">
                                Somente os quizzes selecionados aqui aparecerão na dinâmica de dicas do expositor para os participantes.
                            </Form.Text>
                        </Form.Group>
                    )}
                </Col>
            </Row>

            <Modal
                show={showEditModal.show}
                size={"lg"}
                onHide={() => setShowEditModal((prevState) => ({
                    ...prevState,
                    show: false
                }))}
                fullscreen={'sm-down'}
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Formik
                    enableReinitialize
                    onSubmit={registerExhibitor}
                    validate={validateExhibitorAccount}
                    validationSchema={schemaComponents('expositores', getExhibitorValidationDataTable())}
                    initialValues={{
                        id: showEditModal.data.id || null,
                        user_id: showEditModal.data.user_id || null,
                        quiz_tips: Array.isArray(showEditModal.data.quiz_tips)
                            ? showEditModal.data.quiz_tips
                            : showEditModal.data.quiz_tip
                                ? [showEditModal.data.quiz_tip]
                                : [],
                        name: showEditModal.data.name || '',
                        description: showEditModal.data.description || '',
                        logo: showEditModal.data.logo || '',
                        location: showEditModal.data.location || '',
                        about: showEditModal.data.about || '',
                        categories: showEditModal.data.categories && Array.isArray(showEditModal.data.categories) ? showEditModal.data.categories.join(", ") : ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        submitCount,
                        setFieldValue,
                        setFieldTouched,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{values.id ? 'Editar expositor' : 'Adicionar expositor'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Informações</h6>
                                        </div>
                                    </div>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                            isValid={touched.name && !errors.name}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="description"
                                            value={values.description}
                                            onChange={handleChange}
                                            isInvalid={!!errors.description}
                                            isValid={touched.description && !errors.description}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.description}
                                        </Form.Control.Feedback>
                                    </Form.Group>


                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Categorias</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="categories"
                                            value={values.categories}
                                            onChange={handleChange}
                                            isInvalid={!!errors.categories}
                                            isValid={touched.categories && !errors.categories}
                                            placeholder="Ex: Tecnologia, Saúde, Educação"
                                        />
                                        <Form.Text className="text-muted">
                                            Separe as categorias por vírgula (,)
                                        </Form.Text>
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.categories}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                        md={"6"}
                                    >
                                        <Form.Label>Logo</Form.Label>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <div className="text-center mb-3">
                                                    <div className="d-flex justify-content-center mb-3">
                                                        <Form.Label>Tamanho máximo (820px - 420px)
                                                            <FontAwesomeIcon icon={faExclamationTriangle} className="ms-1 pointer shake-icon-auto" size="lg" onClick={() => {
                                                                setModal((prevState) => ({
                                                                    ...prevState,
                                                                    showRecommendedSizeModal: true
                                                                }));
                                                            }} /></Form.Label>
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="hidden"
                                                    name="logo"
                                                    value={values.logo}
                                                    onChange={(e) => {
                                                        setFieldValue("logo", e.target.value);
                                                    }}
                                                    isInvalid={!!errors?.logo}
                                                    isValid={touched?.logo && !errors?.logo}
                                                />
                                                <div className="imagesUpload">
                                                    <img
                                                        className={`h-100 img-thumbnail ${!!errors?.logo ? "is-invalid" : ""}`}
                                                        src={
                                                            values.logo !== "" && values.logo !== null
                                                                ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.logo
                                                                : domainConfig.imageServer + "/empty-background.png"
                                                        }
                                                        alt="Imagem preview"
                                                    />
                                                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.logo}
                                                    </Form.Control.Feedback>
                                                </div>
                                                <DropzoneComponent
                                                    className="mt-3 dropzoneComp"
                                                    type="image"
                                                    handlePreviewSuccess={handlePreviewSuccess}
                                                    handlePreviewError={handlePreviewError}
                                                    setFieldValue={setFieldValue}
                                                    folder="plataforma-eventos"
                                                    id={dataTable.event_id}
                                                    field="logo"
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Localização</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="location"
                                            value={values.location}
                                            onChange={handleChange}
                                            isInvalid={!!errors.location}
                                            isValid={touched.location && !errors.location}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.location}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Sobre</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="about"
                                            value={values.about}
                                            onChange={handleChange}
                                            isInvalid={!!errors.about}
                                            isValid={touched.about && !errors.about}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.about}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        sm={"12"}
                                    >
                                        <Form.Label>Redes Sociais</Form.Label>
                                        <SocialMediaComponent
                                            dataAddForm={dataAddForm}
                                            setDataAddForm={setDataAddForm}
                                            setModal={setModal}
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        sm={"12"}
                                    >
                                        <GalleryDisplay
                                            dataTable={dataTable}
                                            dataAddForm={dataAddForm}
                                            setDataAddForm={setDataAddForm}
                                            modal={modal}
                                            setModal={setModal}
                                            handlePreviewError={handlePreviewError}
                                        />
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <hr></hr>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Conta</h6>
                                        </div>
                                    </div>
                                    <Form.Group
                                        as={Col}
                                        md="8"
                                        sm="12"
                                        className={"mb-3"}>
                                        <Form.Label>Associar conta<OverlayTrigger overlay={<Tooltip>Selecione uma conta Expositor disponível para associar ao expositor</Tooltip>}>
                                            <HelpTooltip icon={faExclamationCircle} />
                                        </OverlayTrigger></Form.Label>
                                        <Select
                                            className="px-0"
                                            options={getExhibitorAccountOptions(values)}
                                            getOptionLabel={(option) => option.email || 'Sem e-mail'}
                                            getOptionValue={(option) => option.user_id}
                                            value={getSelectedExhibitorAccount(values)}
                                            onChange={(option) => setFieldValue('user_id', option?.user_id || null)}
                                            placeholder={'Clique para selecionar...'}
                                            noOptionsMessage={() => 'Nenhuma conta disponível para associação'}
                                        />
                                        <Form.Text className="text-muted">
                                            Apenas contas do tipo Expositor disponíveis podem ser associadas.
                                        </Form.Text>
                                        {errors.user_id && submitCount > 0 && (
                                            <div className="invalid-feedback d-block">
                                                {errors.user_id}
                                            </div>
                                        )}
                                    </Form.Group>

                                    {values.user_id && <Form.Group
                                        as={Col}
                                        md="4"
                                        sm="12"
                                        className={"mb-3"}>
                                        <Form.Label>Código de Acesso</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                value={getSelectedExhibitorAccount(values)?.access_code || ''}
                                                disabled
                                            />
                                            <OverlayTrigger overlay={<Tooltip>Copiar código de acesso</Tooltip>}>
                                                <InputGroup.Text onClick={(e) => {
                                                    const accessCode = getSelectedExhibitorAccount(values)?.access_code || '';
                                                    if (accessCode) {
                                                        navigator.clipboard.writeText(accessCode);
                                                        notyf.open({
                                                            type: "success",
                                                            message: 'Código de acesso copiado!',
                                                            ripple: true,
                                                            dismissible: true,
                                                        });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faCopy} />
                                                </InputGroup.Text>
                                            </OverlayTrigger>
                                        </InputGroup>
                                    </Form.Group>}
                                </Row>
                                {dataTable.json.configs?.exhibitor?.enableCollection && dataTable.json.configs?.exhibitor?.enableQuizTips && (
                                    <Row className="mb-3">
                                        <hr></hr>
                                        {(() => {
                                            const activeQuizActivityIds = getActiveExhibitorQuizActivityIds();
                                            const visibleQuizActivities = getVisibleExhibitorQuizActivities();
                                            const quizTipDiagnostics = getExhibitorQuizTipDiagnostics(values);
                                            const showQuizTipsError = (!!touched.quiz_tips || submitCount > 0) && !!errors.quiz_tips;
                                            let availabilityMessage = '';

                                            if (activeQuizActivityIds.length === 0) {
                                                availabilityMessage = 'Nenhum quiz válido selecionado para esta dinâmica. Configure os quizzes na seção "Configurações adicionais" do evento.';
                                            } else if (visibleQuizActivities.length === 0) {
                                                availabilityMessage = 'Os quizzes selecionados não possuem questões disponíveis para este expositor. Revise as associações existentes ou selecione outros quizzes.';
                                            } else if (quizTipDiagnostics.unavailableActivities.length > 0) {
                                                availabilityMessage = `Alguns quizzes selecionados não possuem questões disponíveis para este expositor: ${quizTipDiagnostics.unavailableActivities.join(', ')}.`;
                                            }

                                            return (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div className="mb-3">
                                                            <h6 className="mb-0">Dicas do Quiz</h6>
                                                            <Form.Text className="text-muted">
                                                                Associe uma questão de cada quiz a este expositor. Somente os quizzes habilitados na configuração de coleta do evento são exibidos.
                                                            </Form.Text>
                                                        </div>
                                                    </div>
                                                    {showQuizTipsError && typeof errors.quiz_tips === 'string' && (
                                                        <Col sm="12" className="mb-2">
                                                            <Form.Text className="text-danger d-block">
                                                                {errors.quiz_tips}
                                                            </Form.Text>
                                                        </Col>
                                                    )}
                                                    {availabilityMessage && (
                                                        <Col sm="12" className="mb-2">
                                                            <Form.Text className={activeQuizActivityIds.length === 0 ? 'text-muted d-block' : 'text-danger d-block'}>
                                                                {availabilityMessage}
                                                            </Form.Text>
                                                        </Col>
                                                    )}
                                                </>
                                            );
                                        })()}
                                        {getVisibleExhibitorQuizActivities().map((activity) => {
                                            const showQuizTipsError = (!!touched.quiz_tips || submitCount > 0) && !!errors.quiz_tips;
                                            const currentTip = (values.quiz_tips || []).find(
                                                (t) => Number(t.activity_id) === Number(activity.id)
                                            );
                                            const selectedQuestion = currentTip?.question_id
                                                ? (activity.questions || []).find(q => Number(q.question_id) === Number(currentTip.question_id))
                                                : null;
                                            const hasActivityQuizTipError = showQuizTipsError && !selectedQuestion;
                                            return (
                                                <Form.Group as={Col} md="12" sm="12" className="mb-3" key={`quiz_activity_${activity.id}`}>
                                                    <Form.Label>
                                                        {activity.title || 'Sem título'}
                                                        <span className="text-muted fw-normal ms-1 small">— questão do expositor nesse quiz</span>
                                                    </Form.Label>
                                                    <Select
                                                        className={`px-0 ${hasActivityQuizTipError ? 'is-invalid' : ''}`}
                                                        options={(activity.questions || []).map(q => ({
                                                            value: q.question_id,
                                                            label: q.question || `Questão ${q.question_id}`
                                                        }))}
                                                        value={selectedQuestion
                                                            ? { value: selectedQuestion.question_id, label: selectedQuestion.question || `Questão ${selectedQuestion.question_id}` }
                                                            : null
                                                        }
                                                        onChange={(option) => {
                                                            const updated = (values.quiz_tips || []).filter(
                                                                (t) => Number(t.activity_id) !== Number(activity.id)
                                                            );
                                                            if (option) {
                                                                updated.push({ activity_id: Number(activity.id), question_id: Number(option.value) });
                                                            }
                                                            setFieldValue('quiz_tips', updated);
                                                        }}
                                                        onBlur={() => setFieldTouched('quiz_tips', true, false)}
                                                        placeholder={'Não associado a este quiz'}
                                                        isClearable
                                                    />
                                                    {hasActivityQuizTipError && (
                                                        <div className="invalid-feedback d-block">
                                                            Selecione uma questão para este quiz.
                                                        </div>
                                                    )}
                                                    {selectedQuestion && Array.isArray(selectedQuestion.correctAnswers) && selectedQuestion.correctAnswers.length > 0 && (
                                                        <div className="mt-2">
                                                            <Form.Text className="text-muted d-block">
                                                                {selectedQuestion.correctAnswers.length > 1 ? 'Respostas corretas:' : 'Resposta correta:'}
                                                            </Form.Text>
                                                            {selectedQuestion.correctAnswers.map((answer, answerIndex) => (
                                                                <div className="small text-success" key={`quiz_correct_answer_${activity.id}_${answer.order ?? answerIndex}`}>
                                                                    {answer.text}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            );
                                        })}
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                {showEditModal.data.id && <Button
                                    variant="danger"
                                    type="button"
                                    className="float-end me-2"
                                    onClick={() => {
                                        deleteExhibitor(showEditModal.data);
                                    }}
                                >
                                    Excluir
                                </Button>}
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={isSubmitting}
                                    onClick={() => logBlockedExhibitorSave(values, errors)}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
            <GalleryItemForm
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                modal={modal}
                setModal={setModal}
                dataTable={dataTable}
                handlePreviewError={handlePreviewError}
            />
            <RecommendedSizeModal
                modal={modal}
                setModal={setModal}
            />
            <SocialMediaType
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                modal={modal}
                setModal={setModal}
            />

            {/* Collected Users Modal */}
            <Modal
                show={showCollectedModal.show}
                onHide={() => setShowCollectedModal({ show: false, data: null })}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex justify-content-between align-items-center w-100 pe-3">
                        <div>
                            Coleta de expositor
                            {showCollectedModal.data && (
                                <><br /><small className="text-muted"><b>Expositor:</b> {showCollectedModal.data.json?.name}</small></>
                            )}
                        </div>
                        {dataTable.json.configs.exhibitor.enableCollection && showCollectedModal.data && (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => handleExportCollectedUsers(showCollectedModal.data)}
                                title="Exportar participantes coletados"
                            >
                                <Download size={16} className="me-1" />
                                Exportar
                            </Button>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showCollectedModal.data && showCollectedModal.data.collectedUsers && showCollectedModal.data.collectedUsers.length > 0 ? (
                        <div className="list-group mb-3">
                            {showCollectedModal.data.collectedUsers.map((user, index) => (
                                <div key={user.user_id} className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        {dataTable.json.form.fieldsToShow && dataTable.json.form.fieldsToShow.map((inputID, fieldIndex) => {
                                            const field = dataTable.json.form.fields.find(field => field.inputID === inputID);
                                            const fieldData = user?.json?.[field?.inputID];
                                            const fieldValue = getJsonFieldValue(fieldData);
                                            if (field && fieldData !== undefined && fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                                                if (fieldIndex === 0) {
                                                    return (
                                                        <h6 key={'participantFields' + fieldIndex} className="mb-0 fw-bold">{fieldValue}</h6>
                                                    )
                                                } else {
                                                    return (
                                                        <p className="mb-0 text-muted" key={'participantFields' + fieldIndex}>{fieldValue}</p>
                                                    )
                                                }
                                            }
                                            return null;
                                        })}
                                        <p className="mt-2 mb-0 text-muted">{user.email}</p>
                                        <small className="text-muted">Coletado em: {user.date_collected}</small>
                                    </div>
                                    <span className="itemCountBadge">{index + 1}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Nenhum participante coletou este expositor ainda.</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

const TabSpeakers = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [modal, setModal] = useState({ showSocialMediaForm: false });
    const [triggerExport, setTriggerExport] = useState(false);

    const registerSpeaker = (props, actions) => {
        setLoading(true)

        // Create a deep copy to avoid mutating the original props
        const updatedValues = JSON.parse(JSON.stringify(props));

        let id = null;
        if (updatedValues.id) {
            id = updatedValues.id;
        }

        // Transform schedule_events from Select format {label, value} to just array of IDs
        let schedule_events = (updatedValues.schedule_events || []).map(event => event.value);

        delete updatedValues.id;
        delete updatedValues.schedule_events;
        updatedValues.social_media = dataAddForm.socialMedia;
        let json = JSON.stringify(updatedValues);
        if (id) {
            axios.put(`/api/event/plataformaEventos/component`, {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'palestrantes',
                json: json,
                schedule_events: schedule_events
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Palestrante registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do palestrante',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            // Create new speaker
            axios.post("/api/event/plataformaEventos/component", {
                event_id: dataTable.event_id,
                component_type: 'palestrantes',
                json: json,
                schedule_events: schedule_events
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    // Refresh component data
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Palestrante registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do palestrante',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    };

    const tableColumns = [
        {
            Header: "Foto",
            accessor: "speakerImage",
            Cell: (cell) => {
                if (cell.row.original.speakerImage) {
                    return (
                        <a className="img-table-components" onClick={(e) => { e.preventDefault(); setShowImageModal({ url: `${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.speakerImage}`, show: true }) }} rel="noreferrer"><img src={`${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.speakerImage}`} alt=""></img></a>
                    )
                } else {
                    return ""
                }
            },
            Filter: false,
        },
        {
            Header: "Nome",
            accessor: "speakerName",
            sortDescFirst: false // This column will sort ascending first when clicked
        },
        {
            Header: "Cargo",
            accessor: "speakerRole"
        },
        {
            Header: "Empresa",
            accessor: "speakerCompany"
        },
        {
            Header: 'Quantia de vezes "Favoritado"',
            accessor: "favoriteCount"
        },
        {
            Header: "Total de eventos associados",
            accessor: "scheduleEventsCount"
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteSpeaker(cell.row.original.id)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer"
                                onClick={() => handleDataSpeaker(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                    </>
                );
            },
        },
    ];

    const addSpeaker = () => {
        let json = jsonComponents(selectedValue.value);
        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false,
            socialMedia: []
        }));
        setShowEditModal({
            show: true,
            data: {
                ...json,
                schedule_events: []
            }
        });
    };

    const handleDataSpeaker = (speakerData) => {
        let json = jsonComponents(selectedValue.value);
        speakerData.json = fillMissingProperties(speakerData.json, json);

        // Transform schedule_events from the server format to Select component format
        // Now the server returns {id, title} format which matches what Select expects as {value, label}
        const transformedScheduleEvents = (speakerData.schedule_events || []).map(scheduleEvent => ({
            label: scheduleEvent.title,
            value: scheduleEvent.id
        }));

        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false,
            socialMedia: speakerData.json.social_media || []
        }));
        setShowEditModal({
            show: true,
            data: {
                id: speakerData.id,
                schedule_events: transformedScheduleEvents,
                ...speakerData.json
            }
        });
    };

    const deleteSpeaker = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja excluir esse palestrante? Todos os dados relacionados a ele serão excluídos."
                        action={handleDelete}
                        onClose={onClose}
                        param={id}
                    />
                );
            },
        });
    }

    function handleDelete(id) {
        setLoading(true);
        axios.delete(`/api/event/plataformaEventos/component`, {
            data: {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'palestrantes',
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Palestrante exclúido com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao excluir palestrante',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de palestrantes ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addSpeaker()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie os palestrantes que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={componentData}
                        title={`${dataTable.title} - Palestrantes`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'json.name',
                                    desc: false // false = ascending, true = descending
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-triple" : "",
                            style: {
                                textAlign: cellinfo.column.id === "json.image" ? "center" : "",
                                width: cellinfo.column.id === "json.image" ? "40px" : "",
                            }
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />}
            </div>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Col md={12} className="mt-3">
                <Form.Group className="mx-3 mb-3">
                    <Form.Check
                        className="w-auto"
                        checked={dataTable.json.configs?.speakers?.useCompany ? true : false}
                        type="checkbox"
                        name="json.configs.speakers.useCompany"
                        label="Exibir empresa ao invés da profissão para palestrantes"
                        onChange={() => {
                            setFieldValue(
                                "json.configs.speakers.useCompany",
                                dataTable.json.configs?.speakers?.useCompany ? false : true,
                            );
                        }}
                    />
                </Form.Group>
            </Col>
            <Modal
                show={showEditModal.show}
                size={"lg"}
                onHide={() => setShowEditModal((prevState) => ({
                    ...prevState,
                    show: false
                }))}
                fullscreen={'sm-down'}
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Formik
                    enableReinitialize
                    onSubmit={registerSpeaker}
                    validationSchema={schemaComponents('palestrantes', dataTable)}
                    initialValues={{
                        id: showEditModal.data.id || null,
                        name: showEditModal.data.name || '',
                        role: showEditModal.data.role || '',
                        image: showEditModal.data.image || '',
                        company: showEditModal.data.company || '',
                        about: showEditModal.data.about || '',
                        schedule_events: showEditModal.data.schedule_events || []
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {values.id ? "Editar palestrante" : "Adicionar palestrante"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                            isValid={touched.name && !errors.name}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"6"}
                                    >
                                        <Form.Label>Cargo</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="role"
                                            value={values.role}
                                            onChange={handleChange}
                                            isInvalid={!!errors.role}
                                            isValid={touched.role && !errors.role}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.role}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"6"}
                                    >
                                        <Form.Label>Empresa</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="company"
                                            value={values.company}
                                            onChange={handleChange}
                                            isInvalid={!!errors.company}
                                            isValid={touched.company && !errors.company}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.company}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                        md={"6"}
                                    >
                                        <Form.Label>Foto</Form.Label>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <div className="text-center mb-3">
                                                    <div className="d-flex justify-content-center mb-3">
                                                        <Form.Label>Tamanho máximo (560px - 420px)
                                                            <FontAwesomeIcon icon={faExclamationTriangle} className="ms-1 pointer shake-icon-auto" size="lg" onClick={() => {
                                                                setModal((prevState) => ({
                                                                    ...prevState,
                                                                    showRecommendedSizeModal: true
                                                                }));
                                                            }} />
                                                        </Form.Label>
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="hidden"
                                                    name="image"
                                                    value={values.image}
                                                    onChange={(e) => {
                                                        setFieldValue("image", e.target.value);
                                                    }}
                                                    isInvalid={!!errors?.image}
                                                    isValid={touched?.image && !errors?.image}
                                                />
                                                <div className="imagesUpload">
                                                    <img
                                                        className={`h-100 img-thumbnail ${!!errors?.image ? "is-invalid" : ""}`}
                                                        src={
                                                            values.image !== "" && values.image !== null
                                                                ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.image
                                                                : domainConfig.imageServer + "/empty-background.png"
                                                        }
                                                        alt="Imagem preview"
                                                    />
                                                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.image}
                                                    </Form.Control.Feedback>
                                                </div>
                                                <DropzoneComponent
                                                    className="mt-3 dropzoneComp"
                                                    type="image"
                                                    handlePreviewSuccess={handlePreviewSuccess}
                                                    handlePreviewError={handlePreviewError}
                                                    setFieldValue={setFieldValue}
                                                    folder="plataforma-eventos"
                                                    id={dataTable.event_id}
                                                    field="image"
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Eventos associados ao palestrante
                                            <OverlayTrigger overlay={<Tooltip>Selecione os eventos que o palestrante irá participar</Tooltip>}>
                                                <HelpTooltip icon={faExclamationCircle} />
                                            </OverlayTrigger>
                                        </Form.Label>
                                        <Select
                                            isMulti
                                            name="schedule_events"
                                            placeholder="Selecione os eventos..."
                                            value={values.schedule_events}
                                            onChange={(selectedOptions) => {
                                                setFieldValue("schedule_events", selectedOptions || []);
                                            }}
                                            options={dataAddForm.allEvents.map(event => ({
                                                label: event.title,
                                                value: event.id
                                            }))}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                        />
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Sobre</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="about"
                                            value={values.about}
                                            onChange={handleChange}
                                            isInvalid={!!errors.about}
                                            isValid={touched.about && !errors.about}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.about}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        sm={"12"}
                                    >
                                        <Form.Label>Redes Sociais</Form.Label>
                                        <SocialMediaComponent
                                            dataAddForm={dataAddForm}
                                            setDataAddForm={setDataAddForm}
                                            setModal={setModal}
                                        />
                                    </Form.Group>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {showEditModal.data.id && <Button
                                    variant="danger"
                                    type="button"
                                    className="float-end me-2"
                                    onClick={() => {
                                        deleteSpeaker(showEditModal.data.id);
                                        setShowEditModal((prevState) => ({
                                            ...prevState,
                                            show: false
                                        }));
                                    }}
                                >
                                    Excluir
                                </Button>}
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={isSubmitting}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal >
            <RecommendedSizeModal
                modal={modal}
                setModal={setModal}
            />
            <SocialMediaType
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                modal={modal}
                setModal={setModal}
            />
        </>
    )
}

const TabSponsors = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [modal, setModal] = useState({ showTierManagementForm: false });
    const [triggerExport, setTriggerExport] = useState(false);

    const registerSponsor = (props, actions) => {
        setLoading(true)

        // Create a deep copy to avoid mutating the original props
        const updatedValues = JSON.parse(JSON.stringify(props));

        let id = null;
        if (updatedValues.id) {
            id = updatedValues.id;
        }

        // Extract the tier_id before deleting updatedValues.id
        const tier_id = updatedValues.tier_id;

        delete updatedValues.id;
        delete updatedValues.tier_id;

        let json = JSON.stringify(updatedValues);
        if (id) {
            axios.put(`/api/event/plataformaEventos/component`, {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'patrocinadores',
                json: json,
                tier_id: tier_id
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Patrocinador registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do patrocinador',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            // Create new sponsor
            axios.post("/api/event/plataformaEventos/component", {
                event_id: dataTable.event_id,
                component_type: 'patrocinadores',
                json: json,
                tier_id: tier_id
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    // Refresh component data
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Patrocinador registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do patrocinador',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    };

    const tableColumns = [
        {
            Header: "Imagem",
            accessor: "sponsorImage",
            Cell: (cell) => {
                if (cell.row.original.sponsorImage) {
                    return (
                        <a className="img-table-components" onClick={(e) => { e.preventDefault(); setShowImageModal({ url: `${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.sponsorImage}`, show: true }) }} rel="noreferrer"><img src={`${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.sponsorImage}`} alt=""></img></a>
                    )
                } else {
                    return ""
                }
            },
            Filter: false,
        },
        {
            Header: "Nome",
            accessor: "sponsorName",
            sortDescFirst: false
        },
        {
            Header: "Categoria",
            accessor: "sponsorCategory"
        },
        {
            Header: "Nível",
            accessor: "tierName"
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteSponsor(cell.row.original.id)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer"
                                onClick={() => handleDataSponsor(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                    </>
                );
            },
        },
    ];

    const addSponsor = () => {
        let json = jsonComponents(selectedValue.value);
        setShowEditModal({
            show: true,
            data: {
                ...json,
                tier_id: ''
            }
        });
    };

    const handleDataSponsor = (sponsorData) => {
        let json = jsonComponents(selectedValue.value);
        sponsorData.json = fillMissingProperties(sponsorData.json, json);

        setShowEditModal({
            show: true,
            data: {
                id: sponsorData.id,
                ...sponsorData.json,
                tier_id: sponsorData.tier_id || ''
            }
        });
    };

    const deleteSponsor = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja excluir esse patrocinador?"
                        action={handleDelete}
                        onClose={onClose}
                        param={id}
                    />
                );
            },
        });
    }

    function handleDelete(id) {
        setLoading(true);
        axios.delete(`/api/event/plataformaEventos/component`, {
            data: {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'patrocinadores',
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Patrocinador excluído com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao excluir patrocinador',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de patrocinadores ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addSponsor()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie os patrocinadores que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={componentData}
                        title={`${dataTable.title} - Patrocinadores`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'json.name',
                                    desc: false
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-triple" : "",
                            style: {
                                textAlign: cellinfo.column.id === "json.image" ? "center" : "",
                                width: cellinfo.column.id === "json.image" ? "40px" : "",
                            }
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />}
            </div>

            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Configurações adicionais</h5>
            </Form.Group>
            <Row className="mb-3 mx-0 mt-3">
                <TierManagementComponent
                    dataAddForm={dataAddForm}
                    setDataAddForm={setDataAddForm}
                    setModal={setModal}
                    componentData={componentData}
                    dataTable={dataTable}
                    setDataTableUpdate={setDataTableUpdate}
                />
            </Row>

            <Modal
                show={showEditModal.show}
                size={"lg"}
                onHide={() => setShowEditModal((prevState) => ({
                    ...prevState,
                    show: false
                }))}
                fullscreen={'sm-down'}
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Formik
                    enableReinitialize
                    onSubmit={registerSponsor}
                    validationSchema={schemaComponents('patrocinadores', dataTable)}
                    initialValues={{
                        id: showEditModal.data.id || null,
                        name: showEditModal.data.json?.name || showEditModal.data.name || '',
                        category: showEditModal.data.json?.category || showEditModal.data.category || '',
                        image: showEditModal.data.json?.image || showEditModal.data.image || '',
                        tier_id: showEditModal.data.tier_id || '',
                        link: showEditModal.data.json?.link || showEditModal.data.link || '',
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        isValid,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {values.id ? "Editar patrocinador" : "Adicionar patrocinador"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                            isValid={touched.name && !errors.name}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Palavras-chave
                                            <OverlayTrigger overlay={<Tooltip>Adicione palavras-chave relacionadas ao patrocinador para facilitar a busca, separado por vírgulas</Tooltip>}>
                                                <HelpTooltip icon={faExclamationCircle} />
                                            </OverlayTrigger>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="category"
                                            value={values.category}
                                            onChange={handleChange}
                                            isInvalid={!!errors.category}
                                            isValid={touched.category && !errors.category}
                                            placeholder="Ex: tecnologia, inovação, aeronáutica..."
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.category}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                        md={"6"}
                                    >
                                        <Form.Label>Logo</Form.Label>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <div className="text-center mb-3">
                                                    <div className="d-flex justify-content-center mb-3">
                                                        <Form.Label>Tamanho máximo (725px - 360px)
                                                            <FontAwesomeIcon icon={faExclamationTriangle} className="ms-1 pointer shake-icon-auto" size="lg" onClick={() => {
                                                                setModal((prevState) => ({
                                                                    ...prevState,
                                                                    showRecommendedSizeModal: true
                                                                }));
                                                            }} />
                                                        </Form.Label>
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="hidden"
                                                    name="image"
                                                    value={values.image}
                                                    onChange={(e) => {
                                                        setFieldValue("image", e.target.value);
                                                    }}
                                                    isInvalid={!!errors?.image}
                                                    isValid={touched?.image && !errors?.image}
                                                />
                                                <div className="imagesUpload">
                                                    <img
                                                        className={`h-100 img-thumbnail ${!!errors?.image ? "is-invalid" : ""}`}
                                                        src={
                                                            values.image !== "" && values.image !== null
                                                                ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.image
                                                                : domainConfig.imageServer + "/empty-background.png"
                                                        }
                                                        alt="Imagem preview"
                                                    />
                                                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.image}
                                                    </Form.Control.Feedback>
                                                </div>
                                                <DropzoneComponent
                                                    className="mt-3 dropzoneComp"
                                                    type="image"
                                                    handlePreviewSuccess={handlePreviewSuccess}
                                                    handlePreviewError={handlePreviewError}
                                                    setFieldValue={setFieldValue}
                                                    folder="plataforma-eventos"
                                                    id={dataTable.event_id}
                                                    field="image"
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Nível do patrocinador</Form.Label>
                                        <Form.Select
                                            name="tier_id"
                                            value={values.tier_id}
                                            onChange={handleChange}
                                            isInvalid={!!errors.tier_id}
                                            isValid={touched.tier_id && !errors.tier_id}
                                        >
                                            <option value="">Selecione um nível</option>
                                            {dataAddForm.allAvailableTiers?.map((tier) => (
                                                <option key={tier.id} value={tier.id}>
                                                    {tier.name} (Prioridade: {tier.priority})
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.tier_id}
                                        </Form.Control.Feedback>
                                        {(!dataAddForm.allAvailableTiers || dataAddForm.allAvailableTiers.length === 0) && (
                                            <Form.Text className="text-muted">
                                                Nenhum nível disponível. Crie níveis na seção "Configurações adicionais" abaixo.
                                            </Form.Text>
                                        )}
                                    </Form.Group>

                                    <Form.Group
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Link externo (opcional)</Form.Label>
                                        <Form.Control
                                            type="url"
                                            name="link"
                                            value={values.link}
                                            onChange={handleChange}
                                            isInvalid={!!errors.link}
                                            isValid={touched.link && !errors.link}
                                            placeholder="https://exemplo.com"
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.link}
                                        </Form.Control.Feedback>
                                        <Form.Text className="text-muted">
                                            URL para redirecionamento quando o usuário clicar no patrocinador
                                        </Form.Text>
                                    </Form.Group>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {showEditModal.data.id && <Button
                                    variant="danger"
                                    type="button"
                                    className="float-end me-2"
                                    onClick={() => {
                                        deleteSponsor(showEditModal.data.id);
                                        setShowEditModal((prevState) => ({
                                            ...prevState,
                                            show: false
                                        }));
                                    }}
                                >
                                    Excluir
                                </Button>}
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={isSubmitting}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
            <RecommendedSizeModal
                modal={modal}
                setModal={setModal}
            />
            <TierManagementForm
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                modal={modal}
                setModal={setModal}
                dataTable={dataTable}
                setDataTableUpdate={setDataTableUpdate}
            />
        </>
    )
}

const TierManagementComponent = ({ dataAddForm, setDataAddForm, setModal, componentData, dataTable, setDataTableUpdate }) => {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const { setLoading } = useLayout();
    const notyf = useContext(NotyfContext);

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (index) => {
        if (draggedIndex === index) return;

        const updatedTiers = [...dataAddForm.allAvailableTiers];
        const [draggedItem] = updatedTiers.splice(draggedIndex, 1);
        updatedTiers.splice(index, 0, draggedItem);

        // Update priorities based on new positions
        updatedTiers.forEach((tier, idx) => {
            tier.priority = idx + 1;
        });

        setDraggedIndex(index);
        setDataAddForm((prevDataAddForm) => {
            return {
                ...prevDataAddForm,
                allAvailableTiers: updatedTiers
            }
        });
    };

    const handleDragEnd = () => {
        if (draggedIndex !== null) {
            // Sync priority changes with API
            updateTierPriorities();
        }
        setDraggedIndex(null);
    };

    const updateTierPriorities = async () => {
        setLoading(true);
        try {
            // Update all tier priorities in the backend
            const updatePromises = dataAddForm.allAvailableTiers.map(tier =>
                axios.put('/api/event/plataformaEventos/sponsor-tier', {
                    event_id: dataTable.event_id,
                    id: tier.id,
                    name: tier.name,
                    priority: tier.priority,
                    column: tier.column
                })
            );

            await Promise.all(updatePromises);

            // Refresh component data to update sponsors order
            setDataTableUpdate((prevCount) => prevCount + 1);

            notyf.open({
                type: "success",
                message: 'Ordem dos níveis atualizada com sucesso',
                ripple: true,
                dismissible: true,
            });
        } catch (error) {
            // Revert local changes on error
            setDataTableUpdate((prevCount) => prevCount + 1);
            notyf.open({
                type: "danger",
                message: 'Erro ao atualizar ordem dos níveis',
                ripple: true,
                dismissible: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form.Group
            as={Col}
            className={"mb-3"}
            sm={"12"}
        >
            <Form.Label>Gerenciar Níveis
                <OverlayTrigger overlay={<Tooltip>Quanto mais alto o nível, mais visibilidade o patrocinador recebe</Tooltip>}>
                    <HelpTooltip icon={faExclamationCircle} />
                </OverlayTrigger>
            </Form.Label>
            <Card className="mb-0 formCard col-md-12 px-0">
                <Card.Body>
                    <Col className="text-center mb-2">
                        {dataAddForm.allAvailableTiers && dataAddForm.allAvailableTiers.length > 0 && <small className="text-center opacity-75">(Clique e arraste para ordenar prioridade)</small>}
                    </Col>
                    {dataAddForm.allAvailableTiers && dataAddForm.allAvailableTiers.length > 0 ? (
                        <Row>
                            {dataAddForm.allAvailableTiers.map((tier, index) => {
                                const sponsorCount = componentData?.filter(sponsor => sponsor.tier_id === tier.id.toString()).length || 0;
                                return (
                                    <Col
                                        key={'tier-' + tier.id}
                                        className="mb-3"
                                        md={4}
                                        sm={6}
                                        xs={12}>
                                        <Button
                                            style={{ height: "80px" }}
                                            variant="secondary"
                                            className={`w-100 b-15 text-start`}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragOver={(e) => {
                                                e.preventDefault();
                                                handleDragOver(index);
                                            }}
                                            onClick={() => {
                                                setDataAddForm((prevState) => ({
                                                    ...prevState,
                                                    addFieldData: tier
                                                }));
                                                setModal((prevState) => ({
                                                    ...prevState,
                                                    showTierManagementForm: true
                                                }));
                                            }}
                                            onDragEnd={handleDragEnd}
                                        >
                                            <div>
                                                {tier.name} ({tier.priority}º)
                                                <br />
                                                <small>{sponsorCount} patrocinador{sponsorCount !== 1 ? 'es' : ''}</small>
                                            </div>
                                        </Button>
                                    </Col>
                                );
                            })}
                        </Row>
                    ) : (
                        <>
                            <p className="text-center opacity-75">Nenhum nível cadastrado ainda</p>
                        </>
                    )}
                </Card.Body>
                <Col className="mb-3 text-center">
                    <Button
                        variant="primary"
                        className="btn-sm"
                        onClick={() => {
                            setDataAddForm((prevState) => ({
                                ...prevState,
                                addFieldData: false
                            }));
                            setModal((prevState) => ({
                                ...prevState,
                                showTierManagementForm: true
                            }));
                        }}
                    >
                        Adicionar nível
                    </Button>
                </Col>
            </Card>
        </Form.Group>
    )
}

const TierManagementForm = ({ dataAddForm, setDataAddForm, modal, setModal, dataTable, setDataTableUpdate }) => {
    const { setLoading } = useLayout();
    const notyf = useContext(NotyfContext);

    // Validation schema for tier management
    const tierValidationSchema = Yup.object().shape({
        name: Yup.string()
            .required('O nome é obrigatório')
            .min(2, 'O nome deve ter pelo menos 2 caracteres')
            .max(50, 'O nome deve ter no máximo 50 caracteres'),
        column: Yup.number()
            .required('A coluna é obrigatória')
            .oneOf([12, 6, 4], 'Selecione um tamanho de coluna válido')
    });

    const addTier = async (values, actions) => {
        setLoading(true);

        try {
            // If editing existing tier
            if (values.id) {
                await axios.put('/api/event/plataformaEventos/sponsor-tier', {
                    event_id: dataTable.event_id,
                    id: values.id,
                    name: values.name,
                    priority: values.priority,
                    column: values.column
                });

                // Update local state
                setDataAddForm((prevDataAddForm) => {
                    const updatedTiers = prevDataAddForm.allAvailableTiers.map(tier =>
                        tier.id === values.id
                            ? { ...tier, name: values.name, column: values.column }
                            : tier
                    );
                    return {
                        ...prevDataAddForm,
                        allAvailableTiers: updatedTiers
                    }
                });

                notyf.open({
                    type: "success",
                    message: 'Nível registrado com sucesso',
                    ripple: true,
                    dismissible: true,
                });
            } else {
                // Creating new tier
                const newPriority = (dataAddForm.allAvailableTiers?.length || 0) + 1;

                const response = await axios.post('/api/event/plataformaEventos/sponsor-tier', {
                    event_id: dataTable.event_id,
                    name: values.name,
                    priority: newPriority,
                    column: values.column
                });

                // Add to local state
                const newTier = {
                    id: response.data.tier_id,
                    name: values.name,
                    priority: newPriority,
                    column: values.column
                };

                setDataAddForm((prevDataAddForm) => ({
                    ...prevDataAddForm,
                    allAvailableTiers: [...(prevDataAddForm.allAvailableTiers || []), newTier]
                }));

                notyf.open({
                    type: "success",
                    message: 'Nível registrado com sucesso',
                    ripple: true,
                    dismissible: true,
                });
            }

            // Close modal and reset form
            setModal((prevState) => ({
                ...prevState,
                showTierManagementForm: false
            }));
            setDataAddForm((prevState) => ({
                ...prevState,
                addFieldData: false
            }));

            // Refresh component data to update sponsors
            setDataTableUpdate((prevCount) => prevCount + 1);

        } catch (error) {
            notyf.open({
                type: "danger",
                message: values.id ? 'Houve um erro ao registrar o nível' : 'Houve um erro ao registrar o nível',
                ripple: true,
                dismissible: true,
            });
        } finally {
            setLoading(false);
        }
    }; const removeTier = async (tierId) => {
        setLoading(true);

        try {
            // First delete the tier
            await axios.delete('/api/event/plataformaEventos/sponsor-tier', {
                data: {
                    event_id: dataTable.event_id,
                    id: tierId
                }
            });

            // Update local state and reorder priorities
            const updatedTiers = dataAddForm.allAvailableTiers
                .filter(tier => tier.id !== tierId)
                .map((tier, index) => ({ ...tier, priority: index + 1 }));

            // Update priorities in database for remaining tiers
            if (updatedTiers.length > 0) {
                const updatePromises = updatedTiers.map(tier =>
                    axios.put('/api/event/plataformaEventos/sponsor-tier', {
                        event_id: dataTable.event_id,
                        id: tier.id,
                        name: tier.name,
                        priority: tier.priority,
                        column: tier.column
                    })
                );
                await Promise.all(updatePromises);
            }

            // Update local state
            setDataAddForm((prevDataAddForm) => ({
                ...prevDataAddForm,
                allAvailableTiers: updatedTiers
            }));

            setModal((prevState) => ({
                ...prevState,
                showTierManagementForm: false
            }));
            setDataAddForm((prevState) => ({
                ...prevState,
                addFieldData: false
            }));

            // Refresh component data to update sponsors
            setDataTableUpdate((prevCount) => prevCount + 1);

            notyf.open({
                type: "success",
                message: 'Nível removido com sucesso',
                ripple: true,
                dismissible: true,
            });
        } catch (error) {
            if (error.response?.status === 409) {
                notyf.open({
                    type: "danger",
                    message: error.response.data.message || 'Não é possível remover um nível que está sendo usado por patrocinadores',
                    ripple: true,
                    dismissible: true,
                });
            } else {
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao remover o nível',
                    ripple: true,
                    dismissible: true,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                show={modal.showTierManagementForm}
                size={"sm"}
                onHide={(e) => {
                    setModal((prevState) => ({
                        ...prevState,
                        showTierManagementForm: false
                    }));
                    setDataAddForm((prevState) => ({
                        ...prevState,
                        addFieldData: false
                    }));
                }}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Formik
                    enableReinitialize
                    onSubmit={addTier}
                    validationSchema={tierValidationSchema}
                    initialValues={{
                        id: dataAddForm.addFieldData?.id || null,
                        name: dataAddForm.addFieldData?.name || '',
                        priority: dataAddForm.addFieldData?.priority || ((dataAddForm.allAvailableTiers?.length || 0) + 1),
                        column: dataAddForm.addFieldData?.column || 12,
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        isValid,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{dataAddForm.addFieldData ? 'Editar nível' : 'Adicionar nível'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="mb-3">
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                            isValid={touched.name && !errors.name}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                    >
                                        <Form.Label>Prioridade</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="priority"
                                            value={values.priority}
                                            onChange={handleChange}
                                            disabled={true}
                                            className="bg-light"
                                        />
                                        <Form.Text className="text-muted">
                                            A prioridade é controlada pela posição na lista. Use arrastar e soltar para reordenar.
                                        </Form.Text>
                                    </Form.Group>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {dataAddForm.addFieldData && <Button
                                    variant="danger"
                                    type="button"
                                    className="float-end me-2"
                                    onClick={() => {
                                        removeTier(values.id);
                                    }}
                                >
                                    Excluir
                                </Button>}
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={isSubmitting || !isValid}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

// Streaming URL processing utilities
const processStreamingUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return { type: null, embedUrl: '', error: 'URL inválida' };
    }

    // Basic URL validation
    try {
        new URL(url);
    } catch {
        return { type: null, embedUrl: '', error: 'Formato de URL inválido' };
    }

    // YouTube detection and conversion
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch) {
        const videoId = youtubeMatch[1];
        return {
            type: 'video',
            embedUrl: `https://www.youtube.com/embed/${videoId}`,
            error: null
        };
    }

    // Vimeo detection and conversion
    const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/;
    const vimeoMatch = url.match(vimeoRegex);
    if (vimeoMatch) {
        const videoId = vimeoMatch[1];
        return {
            type: 'video',
            embedUrl: `https://player.vimeo.com/video/${videoId}`,
            error: null
        };
    }

    // Twitch detection and conversion
    const twitchVideoRegex = /(?:https?:\/\/)?(?:www\.)?twitch\.tv\/videos\/(\d+)/;
    const twitchChannelRegex = /(?:https?:\/\/)?(?:www\.)?twitch\.tv\/([a-zA-Z0-9_]+)$/;
    const twitchVideoMatch = url.match(twitchVideoRegex);
    const twitchChannelMatch = url.match(twitchChannelRegex);

    if (twitchVideoMatch) {
        const videoId = twitchVideoMatch[1];
        return {
            type: 'video',
            embedUrl: `https://player.twitch.tv/?video=${videoId}&parent=${window.location.hostname}`,
            error: null
        };
    } else if (twitchChannelMatch) {
        const channel = twitchChannelMatch[1];
        return {
            type: 'video',
            embedUrl: `https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}`,
            error: null
        };
    }

    // Dailymotion detection and conversion
    const dailymotionRegex = /(?:https?:\/\/)?(?:www\.)?dailymotion\.com\/video\/([a-zA-Z0-9]+)/;
    const dailymotionMatch = url.match(dailymotionRegex);
    if (dailymotionMatch) {
        const videoId = dailymotionMatch[1];
        return {
            type: 'video',
            embedUrl: `https://www.dailymotion.com/embed/video/${videoId}`,
            error: null
        };
    }

    // Facebook Video detection and conversion
    const facebookVideoRegex = /(?:https?:\/\/)?(?:www\.)?facebook\.com\/.*\/videos\/(\d+)/;
    const facebookVideoMatch = url.match(facebookVideoRegex);
    if (facebookVideoMatch) {
        return {
            type: 'video',
            embedUrl: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=560`,
            error: null
        };
    }

    // Wistia detection and conversion
    const wistiaRegex = /(?:https?:\/\/)?(?:.*\.)?wistia\.(?:com|net)\/(?:medias|embed)\/([a-zA-Z0-9]+)/;
    const wistiaMatch = url.match(wistiaRegex);
    if (wistiaMatch) {
        const videoId = wistiaMatch[1];
        return {
            type: 'video',
            embedUrl: `https://fast.wistia.net/embed/iframe/${videoId}`,
            error: null
        };
    }

    // JW Player detection (if URL contains jwplayer or has specific patterns)
    if (url.includes('jwplayer') || url.includes('jwplatform')) {
        return {
            type: 'video',
            embedUrl: url,
            error: null
        };
    }

    // Direct embed URLs (if URL already contains /embed/ or is from known video platforms)
    const embedRegex = /\/embed\//;
    if (embedRegex.test(url)) {
        return {
            type: 'video',
            embedUrl: url,
            error: null
        };
    }

    // Meeting platforms detection
    const meetingPlatforms = [
        'meet.google.com',
        'zoom.us',
        'teams.microsoft.com',
        'webex.com',
        'gotomeeting.com',
        'meet.jit.si'
    ];

    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();

    for (const platform of meetingPlatforms) {
        if (hostname.includes(platform)) {
            return {
                type: 'meeting',
                embedUrl: url,
                error: null
            };
        }
    }

    // Live streaming platforms that don't support embedding but are recognized
    const liveStreamingPlatforms = [
        'instagram.com',
        'linkedin.com',
        'tiktok.com',
        'periscope.tv'
    ];

    for (const platform of liveStreamingPlatforms) {
        if (hostname.includes(platform)) {
            return {
                type: 'external',
                embedUrl: url,
                error: null
            };
        }
    }

    // Default to external link if it's a valid URL
    return {
        type: 'external',
        embedUrl: url,
        error: null
    };
};

const getMeetingPlatform = (url) => {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();

    if (hostname.includes('meet.google.com')) return 'Google Meet';
    if (hostname.includes('zoom.us')) return 'Zoom';
    if (hostname.includes('teams.microsoft.com')) return 'Microsoft Teams';
    if (hostname.includes('webex.com')) return 'Webex';
    if (hostname.includes('gotomeeting.com')) return 'GoToMeeting';
    if (hostname.includes('meet.jit.si')) return 'Jitsi Meet';

    return 'Meeting';
};

// File utility functions
const getFileIcon = (filename) => {
    const extension = filename.split('.').pop().toLowerCase();

    switch (extension) {
        case 'pdf':
            return faFilePdf;
        case 'doc':
        case 'docx':
            return faFileWord;
        case 'txt':
            return faFileAlt;
        case 'csv':
            return faFileExcel;
        case 'zip':
        case 'rar':
        case 'tar':
        case 'gz':
            return faFileArchive;
        default:
            return faFile;
    }
};

// FilePreview component - Windows-style layout
const FilePreview = ({ files, onRemoveFile, showRemove = false, downloadBaseUrl }) => {
    if (!files || files.length === 0) {
        return null;
    }

    const handleDownload = (filename) => {
        const downloadUrl = `${downloadBaseUrl}/${filename}`;
        const anchor = document.createElement('a');
        anchor.href = downloadUrl;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.click();
    };

    return (
        <div className="file-preview-container mt-3">
            <div className="d-flex flex-wrap gap-3">
                {files.map((file, index) => {
                    const filename = typeof file === 'string' ? file : file.filename || file.name;
                    const fileIcon = getFileIcon(filename);

                    return (
                        <div key={index} className="file-preview-item text-center position-relative" style={{ width: '120px' }}>

                            {showRemove && <button
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "0px",
                                }}
                                type="button"
                                className="btn btn-sm btn-primary float-end me-0"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering handleClick
                                    onRemoveFile(index)
                                }}>
                                <FontAwesomeIcon icon={faTrash} />
                            </button>}

                            <div
                                className="file-icon-container mb-2 pt-4 d-flex justify-content-center align-items-center"
                                style={{ height: '60px', cursor: 'pointer' }}
                                onClick={() => handleDownload(filename)}
                            >
                                <FontAwesomeIcon
                                    icon={fileIcon}
                                    size="3x"
                                    className="text-gray"
                                />
                            </div>


                            <div
                                className="file-name-container"
                                style={{ fontSize: '11px', lineHeight: '1.2' }}
                                title={filename}
                            >
                                <div
                                    className="text-truncate"
                                >
                                    {filename}
                                </div>
                            </div>

                            <div className="mt-1">
                                <Button
                                    variant="primary"
                                    size="sm"
                                    style={{ fontSize: '10px' }}
                                    onClick={() => handleDownload(filename)}
                                >
                                    <FontAwesomeIcon icon={faDownload} className="me-1" />
                                    Download
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

// StreamingPreview component
const StreamingPreview = ({ url }) => {
    const [previewType, setPreviewType] = useState(null);
    const [embedUrl, setEmbedUrl] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!url) {
            setPreviewType(null);
            setEmbedUrl('');
            setError('');
            return;
        }

        const { type, embedUrl: processedUrl, error: validationError } = processStreamingUrl(url);

        if (validationError) {
            setError(validationError);
            setPreviewType(null);
            setEmbedUrl('');
        } else {
            setError('');
            setPreviewType(type);
            setEmbedUrl(processedUrl);
        }
    }, [url]);

    if (error) {
        return (
            <Card className="bg-danger-subtle border-danger">
                <Card.Body>
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faExclamationCircle} className="text-danger me-2" />
                        <span className="text-danger">{error}</span>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    if (!previewType || !embedUrl) {
        return (
            <Card className="bg-light">
                <Card.Body>
                    <div className="text-center text-muted py-3">
                        <FontAwesomeIcon icon={faGlobe} size="2x" className="mb-2" />
                        <p className="mb-0">Adicione um link válido para ver a pré-visualização</p>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Body>
                {previewType === 'video' && (
                    <div className="ratio ratio-16x9">
                        <iframe
                            src={embedUrl}
                            title="Streaming Preview"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"

                            style={{ borderRadius: '8px' }}
                        />
                    </div>
                )}

                {previewType === 'meeting' && (
                    <div className="text-center py-4">
                        <FontAwesomeIcon icon={faVideo} size="3x" className="text-primary mb-3" />
                        <h6>Link de Reunião</h6>
                        <p className="text-muted mb-3">Este link abrirá em uma nova aba durante o evento</p>
                        <Badge bg="primary" className="px-3 py-2">
                            {getMeetingPlatform(url)} Meeting
                        </Badge>
                    </div>
                )}

                {previewType === 'external' && (
                    <div className="text-center py-4">
                        <FontAwesomeIcon icon={faExternalLinkAlt} size="3x" className="text-primary mb-3" />
                        <h6>Link Externo</h6>
                        <p className="text-muted mb-3">Este link abrirá em uma nova aba</p>
                        <Badge bg="primary" className="px-3 py-2">
                            Streaming Externo
                        </Badge>
                    </div>
                )}

                <div className="mt-3 text-center">
                    <small className="text-muted">
                        URL: <a href={url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            {url.length > 50 ? url.substring(0, 50) + '...' : url}
                        </a>
                    </small>
                </div>
            </Card.Body>
        </Card>
    );
};

const TabInterestsPoints = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [showCollectedModal, setShowCollectedModal] = useState({ show: false, data: null });
    const [modal, setModal] = useState({ showRecommendedSizeModal: false });
    const [triggerExport, setTriggerExport] = useState(false);
    const interestPointScores = (dataAddForm.availableScores || []).filter((score) => (
        score.type === 'interest_point_collection' && Number(score.is_custom) !== 1
    ));
    const defaultInterestPointScoreId = Number(interestPointScores[0]?.id) || '';

    const registerInterestPoint = (props, actions) => {
        setLoading(true)

        // Create a deep copy to avoid mutating the original props
        const updatedValues = JSON.parse(JSON.stringify(props));

        let id = null;
        if (updatedValues.id) {
            id = updatedValues.id;
        }

        const scoreId = Number(updatedValues.score_id) || null;
        delete updatedValues.id;
        delete updatedValues.score_id;
        delete updatedValues.value;
        let json = JSON.stringify(updatedValues);

        if (id) {
            axios.put(`/api/event/plataformaEventos/component`, {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'pontos-de-interesse',
                json: json,
                score_id: scoreId,
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Ponto de interesse registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do ponto de interesse',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            // Create new interest point
            axios.post("/api/event/plataformaEventos/component", {
                event_id: dataTable.event_id,
                component_type: 'pontos-de-interesse',
                json: json,
                score_id: scoreId,
            })
                .then(function (response) {
                    setShowEditModal((prevState) => ({
                        ...prevState,
                        show: false
                    }))
                    // Refresh component data
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Ponto de interesse registrado com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false)
                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro no registro do ponto de interesse',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    };

    const createCode = (id) => {
        const code = 'interest_point=' + id
        return window.btoa(code); // Make sure it's 'exhibitor='
    }

    const tableColumns = [
        {
            Header: "Imagem",
            accessor: "interestPointImage",
            Cell: (cell) => {
                if (cell.row.original.interestPointImage) {
                    return (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a className="img-table-components" onClick={(e) => { e.preventDefault(); setShowImageModal({ url: `${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.interestPointImage}`, show: true }) }} rel="noreferrer"><img src={`${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}/${cell.row.original.interestPointImage}`} alt=""></img></a>
                    )
                } else {
                    return ""
                }
            },
            Filter: false,
        },
        {
            Header: "Título",
            accessor: "interestPointTitle",
            sortDescFirst: false
        },
        {
            Header: "Dica",
            accessor: "interestPointTip"
        },
        {
            Header: "Valor",
            accessor: "interestPointValue"
        },
        {
            Header: 'Quantia de vezes "Coletado"',
            accessor: "totalCollected"
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteInterestPoint(cell.row.original.id)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Baixar Código QR</Tooltip>}>
                            <Download
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => {
                                    downloadQRCode(`${domainConfig.eventos}/?token=${encodeURIComponent(dataTable.token)}&addCode=${encodeURIComponent(createCode(cell.row.original.id))}`, cell.row.original.interestPointTitle);
                                }}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Ver participantes</Tooltip>}>
                            <Users
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => setShowCollectedModal({ show: true, data: cell.row.original })}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer"
                                onClick={() => handleDataInterestPoint(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                    </>
                );
            }
        }
    ];

    const addInterestPoint = () => {
        let json = jsonComponents('pontos-de-interesse');
        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false
        }));
        setShowEditModal({
            show: true,
            data: {
                ...json,
                score_id: defaultInterestPointScoreId,
            }
        });
    };

    const handleDataInterestPoint = (interestPointData) => {
        let json = jsonComponents('pontos-de-interesse');
        interestPointData.json = fillMissingProperties(interestPointData.json, json);

        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false
        }));
        setShowEditModal({
            show: true,
            data: {
                id: interestPointData.id,
                score_id: Number(interestPointData.score_id) || defaultInterestPointScoreId,
                ...interestPointData.json
            }
        });
    };

    const deleteInterestPoint = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja excluir esse ponto de interesse? Todos os dados relacionados a ele serão excluídos"
                        action={handleDelete}
                        onClose={onClose}
                        param={id}
                    />
                );
            },
        });
    }

    function handleDelete(id) {
        setLoading(true);
        axios.delete(`/api/event/plataformaEventos/component`, {
            data: {
                id: id,
                event_id: dataTable.event_id,
                component_type: 'pontos-de-interesse',
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Ponto de interesse excluído com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao excluir ponto de interesse',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de pontos de interesse ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addInterestPoint()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie os pontos de interesse que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={componentData}
                        title={`${dataTable.title} - Pontos de Interesse`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'json.title',
                                    desc: false
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-fourth" : "",
                            style: {
                                textAlign: cellinfo.column.id === "json.image" ? "center" : "",
                                width: cellinfo.column.id === "json.image" ? "40px" : "",
                            }
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />
                }
            </div>

            <Modal
                show={showEditModal.show}
                size={"lg"}
                onHide={() => setShowEditModal((prevState) => ({
                    ...prevState,
                    show: false
                }))}
                fullscreen={'sm-down'}
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop">
                <Modal.Header closeButton>
                    <Modal.Title>{showEditModal.data && showEditModal.data.id ? 'Editar Ponto de Interesse' : 'Novo Ponto de Interesse'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{
                            id: showEditModal.data?.id || '',
                            title: showEditModal.data?.title || '',
                            tip: showEditModal.data?.tip || '',
                            score_id: Number(showEditModal.data?.score_id) || defaultInterestPointScoreId,
                            image: showEditModal.data?.image || ''
                        }}
                        validationSchema={schemaComponents('pontos-de-interesse', dataTable)}
                        onSubmit={(values, actions) => {
                            registerInterestPoint(values, actions);
                        }}
                        enableReinitialize
                    >
                        {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                value={values.title}
                                                onChange={handleChange}
                                                isInvalid={touched.title && errors.title}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.title}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Regra de pontuação</Form.Label>
                                            <Form.Select
                                                name="score_id"
                                                value={values.score_id || ''}
                                                onChange={(event) => setFieldValue('score_id', event.target.value ? Number(event.target.value) : null)}
                                                disabled={interestPointScores.length === 0}
                                            >
                                                <option value="">Usar a regra padrão do evento</option>
                                                {interestPointScores.map((score) => (
                                                    <option key={score.id} value={score.id}>
                                                        {score.description} ({score.value} pontos)
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Text className="text-muted">
                                                Somente regras já salvas neste evento podem ser selecionadas.
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dica</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="tip"
                                                value={values.tip}
                                                onChange={handleChange}
                                                isInvalid={touched.tip && errors.tip}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.tip}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Form.Group
                                        as={Col}
                                        className={"mb-3"}
                                        sm={"12"}
                                        md={"6"}
                                    >
                                        <Form.Label>Imagem</Form.Label>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <div className="text-center mb-3">
                                                    <div className="d-flex justify-content-center mb-3">
                                                        <Form.Label>Tamanho recomendado (350px x 350px)
                                                            <FontAwesomeIcon icon={faExclamationTriangle} className="ms-1 pointer shake-icon-auto" size="lg" onClick={() => {
                                                                setModal((prevState) => ({
                                                                    ...prevState,
                                                                    showRecommendedSizeModal: true
                                                                }));
                                                            }} />
                                                        </Form.Label>
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="hidden"
                                                    name="image"
                                                    value={values.image}
                                                    onChange={(e) => {
                                                        setFieldValue("image", e.target.value);
                                                    }}
                                                    isInvalid={!!errors?.image}
                                                    isValid={touched?.image && !errors?.image}
                                                />
                                                <div className="imagesUpload">
                                                    <img
                                                        className={`h-100 img-thumbnail ${!!errors?.image ? "is-invalid" : ""}`}
                                                        src={
                                                            values.image !== "" && values.image !== null
                                                                ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.image
                                                                : domainConfig.imageServer + "/empty-background.png"
                                                        }
                                                        alt="Imagem preview"
                                                    />
                                                    <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.image}
                                                    </Form.Control.Feedback>
                                                </div>
                                                <DropzoneComponent
                                                    className="mt-3 dropzoneComp"
                                                    type="image"
                                                    handlePreviewSuccess={handlePreviewSuccess}
                                                    handlePreviewError={handlePreviewError}
                                                    setFieldValue={setFieldValue}
                                                    folder="plataforma-eventos"
                                                    id={dataTable.event_id}
                                                    field="image"
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Form.Group>
                                </Row>
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        variant="primary"
                                        onClick={() => setShowEditModal({ show: false, data: {} })}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button variant="primary" type="submit">
                                        Salvar
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
            <RecommendedSizeModal
                modal={modal}
                setModal={setModal}
            />

            {/* Collected Users Modal */}
            <Modal
                show={showCollectedModal.show}
                onHide={() => setShowCollectedModal({ show: false, data: null })}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Coleta de ponto de interesse
                        {showCollectedModal.data && (
                            <><br /><small className="text-muted"><b>Ponto de interesse:</b> {showCollectedModal.data.json?.title}</small></>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showCollectedModal.data && showCollectedModal.data.collectedUsers && showCollectedModal.data.collectedUsers.length > 0 ? (
                        <div className="list-group mb-3">
                            {showCollectedModal.data.collectedUsers.map((user, index) => (
                                <div key={user.user_id} className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        {dataTable.json.form.fieldsToShow && dataTable.json.form.fieldsToShow.map((inputID, fieldIndex) => {
                                            const field = dataTable.json.form.fields.find(field => field.inputID === inputID);
                                            const fieldData = user?.json?.[field?.inputID];
                                            const fieldValue = getJsonFieldValue(fieldData);
                                            if (field && fieldData !== undefined && fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                                                if (fieldIndex === 0) {
                                                    return (
                                                        <h6 key={'participantFields' + fieldIndex} className="mb-0 fw-bold">{fieldValue}</h6>
                                                    )
                                                } else {
                                                    return (
                                                        <p className="mb-0 text-muted" key={'participantFields' + fieldIndex}>{fieldValue}</p>
                                                    )
                                                }
                                            }
                                            return null;
                                        })}
                                        <p className="mt-2 mb-0 text-muted">{user.email}</p>
                                        <small className="text-muted">Coletado em: {user.date_collected}</small>
                                    </div>
                                    <span className="itemCountBadge">{index + 1}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Nenhum participante coletou este ponto de interesse ainda.</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

const getActivityStatusVariant = (status) => getActivityStatusBadgeClass(status).replace('bg-', '');

const getScheduleItemStatusMeta = (startDateStr, endDateStr) => {
    try {
        const now = new Date();
        if (!startDateStr) {
            return { label: 'Em espera', bg: getActivityStatusVariant(0), className: 'text-white' };
        }

        const start = parse(startDateStr, 'dd/MM/yyyy HH:mm', new Date());
        if (Number.isNaN(start.getTime())) {
            return { label: 'Em espera', bg: getActivityStatusVariant(0), className: 'text-white' };
        }

        let end = null;
        if (endDateStr) {
            end = parse(endDateStr, 'dd/MM/yyyy HH:mm', new Date());
        }

        if (now < start) {
            return { label: 'Em espera', bg: getActivityStatusVariant(0), className: 'text-white' };
        } else if (end && !Number.isNaN(end.getTime()) && now > end) {
            return { label: 'Encerrado', bg: getActivityStatusVariant(2), className: 'text-white' };
        } else {
            return { label: 'Em andamento', bg: getActivityStatusVariant(1), className: 'text-white' };
        }
    } catch (e) {
        return { label: 'Em espera', bg: getActivityStatusVariant(0), className: 'text-white' };
    }
};

const TabSchedule = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [showVacancyModal, setShowVacancyModal] = useState({ show: false, data: null });
    const [modal, setModal] = useState({ showGalleryItemForm: false, showStreamingChannelForm: false, showStreamingReportModal: false, showStreamingLoadTestModal: false });
    const [streamingLoadTestInProgress, setStreamingLoadTestInProgress] = useState(false);
    const [streamingLoadTestRefreshKey, setStreamingLoadTestRefreshKey] = useState(0);
    const [triggerExport, setTriggerExport] = useState(false);

    useEffect(() => {
        let isMounted = true;

        if (!dataTable?.event_id) return undefined;

        setDataAddForm((prevState) => ({
            ...prevState,
            availableStreamingUsers: []
        }));

        axios.get(`/api/event/participants/${dataTable.event_id}`, {
            params: { platform: 2 }
        }).then((res) => {
            if (!isMounted) return;

            setDataAddForm((prevState) => ({
                ...prevState,
                availableStreamingUsers: (res.data.participants || []).filter(
                    (u) => Number(u.type) === 1
                )
            }));
        }).catch(() => { });

        return () => {
            isMounted = false;
        };
    }, [dataTable?.event_id, setDataAddForm]);

    const scheduleRows = Array.isArray(componentData) ? componentData : [];
    const scheduleOptions = scheduleRows.map((schedule) => ({
        value: Number(schedule.id),
        label: schedule.scheduleTitle || schedule.json?.title || `Agenda #${schedule.id}`,
        startDate: convertDateToDisplayA(schedule.startDateFormatted || schedule.start_date, 0) || ''
    })).filter((option) => Number.isInteger(option.value) && option.value > 0);
    const allScheduleStreamings = scheduleRows.flatMap((schedule) => (
        Array.isArray(schedule.streamings)
            ? schedule.streamings.map((streaming) => ({
                ...streaming,
                schedule_id: streaming.schedule_id || schedule.id,
                scheduleTitle: schedule.scheduleTitle || schedule.json?.title || `Agenda #${schedule.id}`
            }))
            : []
    ));

    const persistScheduleStreamings = async (scheduleId) => {
        const streamings = (dataAddForm.scheduleStreamings || [])
            .map((streaming, index) => ({ ...streaming, position: Number(streaming.position || index + 1) }))
            .sort((a, b) => Number(a.position || 0) - Number(b.position || 0));
        const deletedIds = (dataAddForm.deletedScheduleStreamings || [])
            .filter(isPersistedStreamingId)
            .map((id) => Number(id));
        let persistedStreamings = [];

        for (const streamingId of deletedIds) {
            await axios.delete('/api/event/plataformaEventos/schedule-streaming', {
                data: {
                    event_id: dataTable.event_id,
                    id: streamingId
                }
            });
        }

        for (const [index, streaming] of streamings.entries()) {
            const persistedId = isPersistedStreamingId(streaming.id);
            const lockedByStatus = persistedId && Number(streaming.status || 0) === 2;
            if (lockedByStatus) {
                persistedStreamings.push({
                    ...streaming,
                    schedule_id: Number(scheduleId),
                    position: index + 1
                });
                continue;
            }

            const payload = buildScheduleStreamingPayload(streaming, dataTable.event_id, scheduleId, index + 1);
            const response = persistedId
                ? await axios.put('/api/event/plataformaEventos/schedule-streaming', payload)
                : await axios.post('/api/event/plataformaEventos/schedule-streaming', payload);
            persistedStreamings.push(response.data.streaming);
        }

        const orderedPersistedStreamings = persistedStreamings
            .filter((streaming) => isPersistedStreamingId(streaming?.id))
            .map((streaming, index) => ({ id: Number(streaming.id), position: index + 1 }));

        if (orderedPersistedStreamings.length > 0) {
            const response = await axios.put('/api/event/plataformaEventos/schedule-streaming/order', {
                event_id: dataTable.event_id,
                schedule_id: scheduleId,
                streamings: orderedPersistedStreamings
            });
            return response.data.data || persistedStreamings;
        }

        return persistedStreamings;
    };

    const registerSchedule = async (props, actions) => {
        setLoading(true)

        // Create a deep copy to avoid mutating the original props
        const updatedValues = JSON.parse(JSON.stringify(props));

        let id = null;
        if (updatedValues.id) {
            id = updatedValues.id;
        }

        // Transform speakers from Select format {label, value} to just array of IDs
        let speakers = (updatedValues.speakers || []).map(speaker => speaker.value);
        let activities = (updatedValues.activities || []).map(activity => activity.value);
        delete updatedValues.id;
        delete updatedValues.speakers;

        // Add gallery and files data to the updatedValues before stringifying
        updatedValues.gallery = dataAddForm.gallery;
        updatedValues.files = dataAddForm.files || [];
        updatedValues.activities = activities

        if (updatedValues.vacancySystem?.status && updatedValues.timeLimit) {
            const formattedDate2 = parse(updatedValues.timeLimit, "dd/MM/yyyy HH:mm", new Date());
            // Convert from Brasília time to UTC (this will add 3 hours)
            const endDateUTC = zonedTimeToUtc(formattedDate2, "America/Sao_Paulo");
            updatedValues.timeLimit = formatInTimeZone(endDateUTC, "UTC", "yyyy-MM-dd HH:mm");
        }
        let json = JSON.stringify(updatedValues);

        try {
            const payload = {
                event_id: dataTable.event_id,
                component_type: 'agenda',
                json: json,
                start_date: updatedValues.startDate,
                end_date: updatedValues.endDate,
                speakers: speakers
            };
            const response = id
                ? await axios.put(`/api/event/plataformaEventos/component`, { ...payload, id })
                : await axios.post("/api/event/plataformaEventos/component", payload);
            const scheduleId = Number(id || response.data?.id || response.data?.schedule_id);

            let savedStreamings = dataAddForm.scheduleStreamings || [];
            if (scheduleId) {
                savedStreamings = await persistScheduleStreamings(scheduleId);
            }

            setDataAddForm((prevState) => ({
                ...prevState,
                scheduleStreamings: savedStreamings,
                deletedScheduleStreamings: []
            }));
            setShowEditModal((prevState) => ({
                ...prevState,
                show: false
            }))
            setDataTableUpdate((prevCount) => prevCount + 1);
            notyf.open({
                type: "success",
                message: 'Evento da agenda registrado com sucesso',
                ripple: true,
                dismissible: true,
            });
            actions.setSubmitting(false)
            setLoading(false)
        } catch (error) {
            setLoading(false);
            actions.setSubmitting(false);
            notyf.open({
                type: "danger",
                message: error.response?.data?.message || (id ? 'Houve um erro ao atualizar o evento da agenda' : 'Houve um erro ao registrar o evento da agenda'),
                ripple: true,
                dismissible: true,
            });
        }
    };

    const tableColumns = [
        {
            Header: "Título",
            accessor: "scheduleTitle",
            sortDescFirst: false,
        },
        {
            Header: "Status",
            accessor: "status",
            disableSortBy: true,
            Cell: (cell) => {
                const startDate = cell.row.original.startDateFormatted;
                const endDate = cell.row.original.endDateFormatted;
                const statusBadge = getScheduleItemStatusMeta(startDate, endDate);

                return (
                    <Badge bg={statusBadge.bg} className={statusBadge.className}>
                        {statusBadge.label}
                    </Badge>
                );
            }
        },
        {
            Header: "Data de Início",
            accessor: "startDateFormatted"
        },
        {
            Header: "Data de Término",
            accessor: "endDateFormatted"
        },
        {
            Header: "Sistema de vagas",
            accessor: "vacancySystemText",
            Cell: (cell) => {
                const vacancyText = cell.row.original.vacancySystemText;

                if (vacancyText) {
                    return (
                        <span>
                            {vacancyText}
                        </span>
                    );
                } else {
                    return "";
                }
            }
        },
        {
            Header: 'Quantia de vezes "Destacado"',
            accessor: "interestedCountDisplay"
        },
        {
            Header: "Total de palestrantes associados",
            accessor: "speakersCount"
        },
        {
            Header: "Total de atividades associadas",
            accessor: "activitiesCount"
        },
        {
            Header: "Total de transmissões",
            accessor: "streamingsCount"
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteSchedule(cell.row.original.id)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Ver participantes</Tooltip>}>
                            <Users
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => setShowVacancyModal({ show: true, data: cell.row.original })}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer"
                                onClick={() => handleDataSchedule(cell.row.original)}
                                size={18}
                            />
                        </OverlayTrigger>
                    </>
                );
            },
        },
    ];

    const addSchedule = () => {
        let json = jsonComponents('agenda');

        // Initialize empty gallery and files for new schedule
        setDataAddForm((prevState) => ({
            ...prevState,
            gallery: [],
            files: [],
            scheduleStreamings: [],
            deletedScheduleStreamings: []
        }));

        setShowEditModal({
            show: true,
            data: {
                ...json,
                speakers: [],
                activities: []
            }
        });
    };

    const handleDataSchedule = (scheduleData) => {
        let json = jsonComponents('agenda');
        scheduleData.json = fillMissingProperties(scheduleData.json, json);

        // Extract gallery and files from scheduleData.json and assign to dataAddForm
        if (scheduleData.json && scheduleData.json.gallery) {
            setDataAddForm((prevState) => ({
                ...prevState,
                gallery: scheduleData.json.gallery || [],
                files: scheduleData.json.files || [],
                scheduleStreamings: scheduleData.streamings || [],
                deletedScheduleStreamings: []
            }));
        } else {
            setDataAddForm((prevState) => ({
                ...prevState,
                gallery: [],
                files: [],
                scheduleStreamings: scheduleData.streamings || [],
                deletedScheduleStreamings: []
            }));
        }

        const transformedSpeakers = (scheduleData.speakers || []).map(speaker => ({
            label: speaker.name,
            value: speaker.id
        }));

        // Transform activities from JSON array of IDs to Select component format
        // scheduleData.json.activities contains array of activity IDs: [1, 2, 3]
        // We need to match them with dataAddForm.allActivities to get full objects
        const transformedActivities = (scheduleData.json.activities || [])
            .map(activityId => {
                // Find the activity object from allActivities using the ID
                const activity = dataAddForm.allActivities?.find(act => act.id === activityId);
                if (activity) {
                    return {
                        label: activity.title || 'Sem título',
                        value: activity.id
                    };
                }
                return null;
            })
            .filter(Boolean); // Remove any null entries
        let formattedData = {
            id: scheduleData.id,
            ...scheduleData.json,
            timeLimit: convertDateToDisplayA(scheduleData.json.timeLimit, 0),
            startDate: convertDateToDisplayA(scheduleData.start_date, 0),
            endDate: convertDateToDisplayA(scheduleData.end_date, 0),
            speakers: transformedSpeakers,
            activities: transformedActivities
        };

        setShowEditModal({ show: true, data: formattedData });
    };

    const deleteSchedule = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja excluir esse evento da agenda? Todos os dados relacionados a ele serão excluídos."
                        action={handleDeleteSchedule}
                        onClose={onClose}
                        param={id}
                    />
                );
            },
        });
    }

    function handleDeleteSchedule(id) {
        setLoading(true)
        axios.delete("/api/event/plataformaEventos/component", {
            data: {
                event_id: dataTable.event_id,
                component_type: 'agenda',
                id: id
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Evento da agenda excluído com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false)
            })
            .catch(function (error) {
                setLoading(false)
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao excluir o evento da agenda',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    return (
        <>
            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de eventos da agenda ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addSchedule()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie os eventos da agenda que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={componentData}
                        title={`${dataTable.title} - Agenda`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'start_date',
                                    desc: false
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-triple" : "",
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />}
            </div>

            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Transmissões ({allScheduleStreamings.length})</h5>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie as transmissões disponíveis no evento
            </h6>
            <ScheduleStreamingManagementComponent
                scheduleId={null}
                dataTable={dataTable}
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                setModal={setModal}
                setDataTableUpdate={setDataTableUpdate}
                streamings={allScheduleStreamings}
                emptyMessage="Nenhuma transmissão disponível"
                globalMode
            />

            <Modal
                show={showEditModal.show}
                size={"lg"}
                onHide={() => setShowEditModal((prevState) => ({
                    ...prevState,
                    show: false
                }))}
                fullscreen={'sm-down'}
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Formik
                    enableReinitialize
                    onSubmit={registerSchedule}
                    validationSchema={schemaComponents('agenda', dataTable)}
                    initialValues={{
                        id: showEditModal.data.id,
                        title: showEditModal.data.title,
                        location: showEditModal.data.location,
                        about: showEditModal.data.about,
                        startDate: showEditModal.data.startDate,
                        endDate: showEditModal.data.endDate,
                        timeLimit: showEditModal.data.timeLimit,
                        showEndDate: showEditModal.data.showEndDate,
                        showInterest: showEditModal.data.showInterest,
                        vacancySystem: showEditModal.data.vacancySystem,
                        speakers: showEditModal.data.speakers || [],
                        activities: showEditModal.data.activities || [],
                        streamingUrl: showEditModal.data.streamingUrl || ''
                    }}>
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => {
                        const statusBadge = getScheduleItemStatusMeta(values.startDate, values.endDate);
                        const scheduleReadOnly = false;
                        return (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {values.id ? "Editar evento da agenda" : "Adicionar evento da agenda"}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row>
                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"12"}
                                        >
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                value={values.title}
                                                onChange={handleChange}
                                                isInvalid={!!errors.title}
                                                isValid={touched.title && !errors.title}
                                                disabled={scheduleReadOnly}
                                            />
                                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.title}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            xs="auto"
                                        >
                                            <Form.Label>Status</Form.Label>
                                            <div style={{ height: "38px" }}>
                                                <Badge bg={statusBadge.bg} className={statusBadge.className}>
                                                    {statusBadge.label}
                                                </Badge>
                                            </div>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"4"}
                                        >
                                            <Form.Label>Data de Início</Form.Label>
                                            <div className={`position-relative ${errors.startDate ? 'is-invalid' : touched.startDate && !errors.startDate ? 'is-valid' : ''}`}>
                                                <Datetime
                                                    value={values.startDate}
                                                    onChange={(date) => {
                                                        if (date && typeof date === 'object' && date._isValid !== false) {
                                                            const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm');
                                                            setFieldValue('startDate', formattedDate);
                                                        } else {
                                                            setFieldValue('startDate', typeof date === 'string' ? date : '');
                                                        }
                                                    }}
                                                    dateFormat="DD/MM/YYYY"
                                                    timeFormat="HH:mm"
                                                    inputProps={{
                                                        placeholder: 'dd/MM/yyyy HH:mm',
                                                        className: `form-control ${errors.startDate ? 'is-invalid' :
                                                            touched.startDate && !errors.startDate ? 'is-valid' : ''
                                                            }`
                                                    }}
                                                    locale="pt-br"
                                                />
                                            </div>
                                            {touched.startDate && !errors.startDate && (
                                                <div className="valid-feedback d-block"></div>
                                            )}
                                            {errors.startDate && (
                                                <div className="invalid-feedback d-block">
                                                    {errors.startDate}
                                                </div>
                                            )}
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"4"}
                                        >
                                            <Form.Label>Data de Término</Form.Label>
                                            <div className={`position-relative ${errors.endDate ? 'is-invalid' : touched.endDate && !errors.endDate ? 'is-valid' : ''}`}>
                                                <Datetime
                                                    value={values.endDate}
                                                    onChange={(date) => {
                                                        if (date && typeof date === 'object' && date._isValid !== false) {
                                                            const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm');
                                                            setFieldValue('endDate', formattedDate);
                                                        } else {
                                                            setFieldValue('endDate', typeof date === 'string' ? date : '');
                                                        }
                                                    }}
                                                    dateFormat="DD/MM/YYYY"
                                                    timeFormat="HH:mm"
                                                    inputProps={{
                                                        placeholder: 'dd/MM/yyyy HH:mm',
                                                        className: `form-control ${errors.endDate ? 'is-invalid' :
                                                            touched.endDate && !errors.endDate ? 'is-valid' : ''
                                                            }`
                                                    }}
                                                    locale="pt-br"
                                                    isValidDate={(current) => {
                                                        // Only allow dates >= startDate if startDate is set
                                                        if (values.startDate) {
                                                            try {
                                                                const startDate = parse(values.startDate, 'dd/MM/yyyy HH:mm', new Date());
                                                                if (isValid(startDate)) {
                                                                    return isAfter(current.toDate(), startOfDay(startDate)) ||
                                                                        isSameDay(current.toDate(), startDate);
                                                                }
                                                            } catch {
                                                                return true;
                                                            }
                                                        }
                                                        return true;
                                                    }}
                                                />
                                            </div>
                                            {touched.endDate && !errors.endDate && (
                                                <div className="valid-feedback d-block"></div>
                                            )}
                                            {errors.endDate && (
                                                <div className="invalid-feedback d-block">
                                                    {errors.endDate}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"12"}
                                        >
                                            <Form.Label>Localização</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="location"
                                                value={values.location}
                                                onChange={handleChange}
                                                isInvalid={!!errors.location}
                                                isValid={touched.location && !errors.location}
                                                disabled={scheduleReadOnly}
                                            />
                                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.location}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"12"}
                                        >
                                            <Form.Label>Sobre</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="about"
                                                value={values.about}
                                                onChange={handleChange}
                                                isInvalid={!!errors.about}
                                                isValid={touched.about && !errors.about}
                                                disabled={scheduleReadOnly}
                                            />
                                            <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.about}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            sm={"12"}
                                        >
                                            <Form.Check
                                                type="checkbox"
                                                name="showEndDate"
                                                label="Mostrar data de término do evento"
                                                checked={values.showEndDate}
                                                onChange={handleChange}
                                                disabled={scheduleReadOnly}
                                            />

                                            <Form.Check
                                                type="checkbox"
                                                name="showInterest"
                                                label={<>Habilitar botões de "Mostrar interesse" <OverlayTrigger overlay={<Tooltip>O sistema de "mostrar interesse" possibilidade o destaque do evento para o usuário</Tooltip>}>
                                                    <HelpTooltip icon={faExclamationCircle} />
                                                </OverlayTrigger></>}
                                                checked={values.showInterest}
                                                onChange={handleChange}
                                                disabled={scheduleReadOnly}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                name="vacancySystem.status"
                                                label={<>Habilitar sistema de vagas<OverlayTrigger overlay={<Tooltip>O sistema de vagas permite gerenciar a disponibilidade de participantes para o evento</Tooltip>}>
                                                    <HelpTooltip icon={faExclamationCircle} />
                                                </OverlayTrigger></>}
                                                checked={values.vacancySystem?.status || false}
                                                onChange={handleChange}
                                                disabled={scheduleReadOnly}
                                            />
                                            {values.vacancySystem?.status && (
                                                <>
                                                    <Form.Group
                                                        as={Col}
                                                        sm={"6"}
                                                        className={"mb-2"}
                                                    >
                                                        <Form.Label>Número de vagas</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            name="vacancySystem.slots"
                                                            value={values.vacancySystem?.slots || 0}
                                                            onChange={handleChange}
                                                            isInvalid={!!errors.vacancySystem?.slots}
                                                            isValid={touched.vacancySystem?.slots && !errors.vacancySystem?.slots}
                                                            disabled={scheduleReadOnly}
                                                        />
                                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vacancySystem?.slots}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Col}
                                                        className={"mb-3"}
                                                        sm={"4"}
                                                    >
                                                        <Form.Label>Data limite para Reserva</Form.Label>
                                                        <div className={`position-relative ${errors.timeLimit ? 'is-invalid' : touched.timeLimit && !errors.timeLimit ? 'is-valid' : ''}`}>
                                                            <Datetime
                                                                value={values.timeLimit}
                                                                onChange={(date) => {
                                                                    if (date && typeof date === 'object' && date._isValid !== false) {
                                                                        const formattedDate = format(new Date(date), 'dd/MM/yyyy HH:mm');
                                                                        setFieldValue('timeLimit', formattedDate);
                                                                    } else {
                                                                        setFieldValue('timeLimit', typeof date === 'string' ? date : '');
                                                                    }
                                                                }}
                                                                dateFormat="DD/MM/YYYY"
                                                                timeFormat="HH:mm"
                                                                inputProps={{
                                                                    placeholder: 'dd/MM/yyyy HH:mm',
                                                                    className: `form-control ${errors.timeLimit ? 'is-invalid' :
                                                                        touched.timeLimit && !errors.timeLimit ? 'is-valid' : ''
                                                                        }`
                                                                }}
                                                                locale="pt-br"
                                                                isValidDate={(current) => {
                                                                    // Only allow dates between event creation_date and end_date
                                                                    if (dataTable?.creation_date && dataTable?.end_date) {
                                                                        try {
                                                                            const eventStart = parse(dataTable.creation_date, 'dd/MM/yyyy HH:mm', new Date());
                                                                            const eventEnd = parse(dataTable.end_date, 'dd/MM/yyyy HH:mm', new Date());
                                                                            if (isValid(eventStart) && isValid(eventEnd)) {
                                                                                return (isAfter(current.toDate(), startOfDay(eventStart)) ||
                                                                                    isSameDay(current.toDate(), eventStart)) &&
                                                                                    (isBefore(current.toDate(), endOfDay(eventEnd)) ||
                                                                                        isSameDay(current.toDate(), eventEnd));
                                                                            }
                                                                        } catch {
                                                                            return true;
                                                                        }
                                                                    }
                                                                    return true;
                                                                }}
                                                            />
                                                        </div>
                                                        {touched.timeLimit && !errors.timeLimit && (
                                                            <div className="valid-feedback d-block"></div>
                                                        )}
                                                        {errors.timeLimit && (
                                                            <div className="invalid-feedback d-block">
                                                                {errors.timeLimit}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </>
                                            )}
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            sm={"12"}
                                        >
                                            <hr></hr>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <h6>Atividades</h6>
                                                    <Form.Label>Associe atividades a este evento
                                                        <OverlayTrigger overlay={<Tooltip>Selecione as atividades que irão ocorrer durante este evento da agenda</Tooltip>}>
                                                            <HelpTooltip icon={faExclamationCircle} />
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                </div>
                                            </div>
                                            <Row className="mb-3">
                                                <Form.Group
                                                    as={Col}
                                                    className={"mb-3"}
                                                    sm={"12"}
                                                >
                                                    <Select
                                                        isMulti
                                                        name="activities"
                                                        placeholder="Selecione as atividades..."
                                                        value={values.activities || []}
                                                        onChange={(selectedOptions) => {
                                                            setFieldValue("activities", selectedOptions || []);
                                                        }}
                                                        options={dataAddForm.allActivities ? dataAddForm.allActivities.map(activity => ({
                                                            label: activity.title || 'Sem título',
                                                            value: activity.id,
                                                            subtitle: getActivityDisplayName(activity)
                                                        })) : []}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        isDisabled={scheduleReadOnly}
                                                        formatOptionLabel={(option) => (
                                                            <div>
                                                                <div>{option.label}</div>
                                                                {option.subtitle && <small className="text-muted">{option.subtitle}</small>}
                                                            </div>
                                                        )}
                                                    />
                                                    {(!dataAddForm.allActivities || dataAddForm.allActivities.length === 0) && (
                                                        <Form.Text className="text-muted">
                                                            Nenhuma atividade disponível. Crie atividades primeiro no componente"Atividades" do evento.
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Row>
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            sm={"12"}
                                        >
                                            <hr></hr>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <h6>Transmissão</h6>
                                                    <Form.Label>Gerencie canais de transmissão, links e chat</Form.Label>
                                                </div>
                                            </div>
                                            <ScheduleStreamingManagementComponent
                                                scheduleId={values.id}
                                                dataTable={dataTable}
                                                dataAddForm={dataAddForm}
                                                setDataAddForm={setDataAddForm}
                                                setModal={setModal}
                                                setDataTableUpdate={setDataTableUpdate}
                                                disabled={scheduleReadOnly}
                                            />
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            sm={"12"}
                                        >
                                            <hr></hr>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="mb-3">
                                                    <h6>Palestrantes</h6>
                                                    <Form.Label>Palestrantes associados ao evento
                                                        <OverlayTrigger overlay={<Tooltip>Selecione os palestrantes que irão participar deste evento da agenda</Tooltip>}>
                                                            <HelpTooltip icon={faExclamationCircle} />
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                </div>
                                            </div>
                                            <Select
                                                isMulti
                                                name="speakers"
                                                placeholder="Selecione os palestrantes..."
                                                value={values.speakers}
                                                onChange={(selectedOptions) => {
                                                    setFieldValue("speakers", selectedOptions || []);
                                                }}
                                                options={dataAddForm.allSpeakers.map(speaker => ({
                                                    label: speaker.name,
                                                    value: speaker.id
                                                }))}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                isDisabled={scheduleReadOnly}
                                            />
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            sm={"12"}
                                        >
                                            <hr></hr>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <h6>Arquivos ({dataAddForm.files?.length || 0}/4)</h6>
                                                    <Form.Label>Disponibilize arquivos para os usuários
                                                        <OverlayTrigger overlay={<Tooltip>
                                                            Formatos aceitos: PDF, DOC, DOCX, TXT, CSV, ZIP, RAR, TAR, GZ (máximo 50MB)
                                                        </Tooltip>}>
                                                            <HelpTooltip icon={faExclamationCircle} />
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                </div>
                                            </div>
                                            <Row className="mb-3">
                                                <Form.Group
                                                    as={Col}
                                                    sm={"12"}
                                                >
                                                    <Card>
                                                        <Card.Body>

                                                            {dataAddForm.files && dataAddForm.files.length > 0 ? <>
                                                                <FilePreview
                                                                    files={dataAddForm.files}
                                                                    showRemove={!scheduleReadOnly}
                                                                    onRemoveFile={(index) => {
                                                                        setDataAddForm((prevState) => ({
                                                                            ...prevState,
                                                                            files: prevState.files.filter((_, i) => i !== index)
                                                                        }));
                                                                    }}
                                                                    downloadBaseUrl={`${domainConfig.imageServer}/plataforma-eventos/${dataTable.event_id}`}
                                                                />
                                                            </> : <p className="opacity-75 text-center my-5">Nenhum arquivo adicionado</p>}
                                                        </Card.Body>
                                                    </Card>
                                                    <MultipleDropzoneComponent
                                                        className={`mt-4 dropzoneComp ${scheduleReadOnly ? 'd-none' : ''}`}
                                                        type="documents"
                                                        handlePreviewSuccessMultiple={(uploadedFiles) => {
                                                            const currentFilesCount = dataAddForm.files?.length || 0;
                                                            const maxFiles = 4;
                                                            const availableSlots = maxFiles - currentFilesCount;

                                                            if (availableSlots <= 0) {
                                                                if (currentFilesCount === maxFiles) {
                                                                    handlePreviewError('Limite máximo de 4 arquivos atingido');
                                                                } else {
                                                                    handlePreviewError(`Este evento já possui ${currentFilesCount} arquivo(s). Remova alguns arquivos para adicionar novos (limite: 4 arquivos)`);
                                                                }
                                                                return;
                                                            }

                                                            // Limit the upload results to available slots
                                                            const limitedResults = uploadedFiles.slice(0, availableSlots);

                                                            if (limitedResults.length < uploadedFiles.length) {
                                                                handlePreviewError(`Apenas ${limitedResults.length} arquivo(s) foram adicionados devido ao limite de 4 arquivos`);
                                                            }

                                                            setDataAddForm((prevState) => ({
                                                                ...prevState,
                                                                files: [
                                                                    ...(prevState.files || []),
                                                                    ...limitedResults.map(file => ({
                                                                        filename: file.filename,
                                                                        id: file.id
                                                                    }))
                                                                ]
                                                            }));
                                                        }}
                                                        handlePreviewError={handlePreviewError}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                    />
                                                </Form.Group>
                                            </Row>
                                        </Form.Group>
                                        <GalleryDisplay
                                            dataTable={dataTable}
                                            dataAddForm={dataAddForm}
                                            setDataAddForm={setDataAddForm}
                                            modal={modal}
                                            setModal={setModal}
                                            handlePreviewError={handlePreviewError}
                                            disabled={scheduleReadOnly}
                                        />
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    {showEditModal.data.id && !scheduleReadOnly && <Button
                                        variant="danger"
                                        type="button"
                                        className="float-end me-2"
                                        onClick={() => {
                                            deleteSchedule(showEditModal.data.id);
                                            setShowEditModal((prevState) => ({
                                                ...prevState,
                                                show: false
                                            }));
                                        }}
                                    >
                                        Excluir
                                    </Button>}
                                    {!scheduleReadOnly && (
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="float-end"
                                            disabled={isSubmitting}
                                        >
                                            Salvar
                                        </Button>
                                    )}
                                </Modal.Footer>
                            </Form>
                        );
                    }}
                </Formik>
            </Modal >
            <ScheduleStreamingChannelForm
                modal={modal}
                setModal={setModal}
                dataTable={dataTable}
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                setDataTableUpdate={setDataTableUpdate}
                handlePreviewError={handlePreviewError}
                scheduleOptions={scheduleOptions}
                availableStreamings={allScheduleStreamings}
            />
            <ScheduleStreamingReportModal
                modal={modal}
                setModal={setModal}
                dataTable={dataTable}
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                setDataTableUpdate={setDataTableUpdate}
                isStreamingLoadTestInProgress={streamingLoadTestInProgress}
                streamingLoadTestRefreshKey={streamingLoadTestRefreshKey}
                setShowStreamingLoadTestModal={(show) => setModal((current) => ({ ...current, showStreamingLoadTestModal: show }))}
                returnToStreamingEditorOnClose
            />
            <StreamingLoadTestModal
                show={modal.showStreamingLoadTestModal}
                onHide={() => setModal((current) => ({ ...current, showStreamingLoadTestModal: false }))}
                origin="streamingReport"
                onTestRunningChange={setStreamingLoadTestInProgress}
                onTerminal={() => setStreamingLoadTestRefreshKey((current) => current + 1)}
                context={{
                    eventId: dataTable?.event_id,
                    scheduleId: dataAddForm.streamingReportData?.schedule_id,
                    streamingId: dataAddForm.streamingReportData?.id,
                }}
            />

            {/* Vacancy Users Modal */}
            <Modal
                show={showVacancyModal.show}
                onHide={() => setShowVacancyModal({ show: false, data: null })}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Participantes com vagas reservadas
                        {showVacancyModal.data && (
                            <><br /><small className="text-muted"><b>Evento da agenda:</b> {showVacancyModal.data.json?.title}</small></>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showVacancyModal.data && showVacancyModal.data.vacancyUsers && showVacancyModal.data.vacancyUsers.length > 0 ? (
                        <div className="list-group mb-3">
                            {showVacancyModal.data.vacancyUsers.map((user, index) => (
                                <div key={user.user_id} className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        {dataTable.json.form.fieldsToShow && dataTable.json.form.fieldsToShow.map((inputID, index) => {
                                            const field = dataTable.json.form.fields.find(field => field.inputID === inputID);
                                            const fieldData = user?.json?.[field?.inputID];
                                            const fieldValue = getJsonFieldValue(fieldData);
                                            if (field && fieldData !== undefined && fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                                                if (index === 0) {
                                                    return (
                                                        <h6 key={'participantFields' + index} className="mb-0 fw-bold">{fieldValue}</h6>
                                                    )
                                                } else {
                                                    return (
                                                        <p className="mb-0 text-muted" key={'participantFields' + index}>{fieldValue}</p>
                                                    )
                                                }
                                            }
                                            return null;
                                        })}
                                        <p className="mt-2 mb-0 text-muted" key={'participantFields' + index}>{user.email}</p>
                                        <small className="text-muted">Reservado em: {user.created_at}</small>
                                    </div>
                                    <span className="itemCountBadge">{index + 1}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Nenhum participante reservou vaga para este evento ainda.</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <GalleryItemForm
                modal={modal}
                setModal={setModal}
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                dataTable={dataTable}
                handlePreviewError={handlePreviewError}
            />
        </>
    )
};

const getScheduleStreamingStatusMeta = (status) => {
    const activityStatusVariant = getActivityStatusVariant(status);
    switch (Number(status)) {
        case 1:
            return { label: 'Em andamento', bg: activityStatusVariant, className: 'text-black' };
        case 2:
            return { label: 'Encerrado', bg: activityStatusVariant, className: 'text-white' };
        case 0:
        default:
            return { label: 'Em espera', bg: activityStatusVariant, className: 'text-white' };
    }
};

const getScheduleStreamingStatusBadge = (status, dataTable) => {
    return getScheduleStreamingStatusMeta(status);
};

const getScheduleStreamingShareOptions = (publicUrl) => {
    return [
        {
            key: 'public',
            label: 'Compartilhar link de acesso',
            description: 'Abre a página pública com o player e os recursos da transmissão.',
            url: publicUrl,
            type: 'public',
        },
        {
            key: 'embed',
            label: 'Copiar link para utilizar em embed',
            description: 'Use este endereço no atributo src de um iframe para carregar a versão básica.',
            url: `${publicUrl}${publicUrl.includes('?') ? '&' : '?'}embed=1`,
            type: 'embed',
        },
    ];
};

const getDefaultStreamingStartDate = () => (
    formatInTimeZone(new Date(Date.now() + 60 * 60 * 1000), "America/Sao_Paulo", "dd/MM/yyyy HH:mm")
);

const getStreamingPreviewFallbackUrl = () => `${domainConfig.imageServer}/empty-background.png`;

const getStreamingPreviewUrl = (eventId, previewImage) => {
    if (!previewImage) return getStreamingPreviewFallbackUrl();
    if (String(previewImage).startsWith('http')) return previewImage;
    return `${domainConfig.imageServer}/plataforma-eventos/${eventId}/${previewImage}`;
};

const formatStreamingDateForForm = (value) => {
    if (!value) return '';
    if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(String(value))) return value;
    return convertDateToDisplayA(value, 0) || '';
};

const normalizeStreamingDateForSubmit = (value) => {
    if (!value) return null;
    const parsedDate = parse(value, "dd/MM/yyyy HH:mm", new Date());
    if (Number.isNaN(parsedDate.getTime())) return value;
    const utcDate = zonedTimeToUtc(parsedDate, "America/Sao_Paulo");
    return formatInTimeZone(utcDate, "UTC", "yyyy-MM-dd HH:mm");
};

const getStreamingStatusFromStartDate = (value) => {
    if (!value) return 0;
    const parsedDate = parse(value, "dd/MM/yyyy HH:mm", new Date());
    if (Number.isNaN(parsedDate.getTime())) return 0;
    const utcDate = zonedTimeToUtc(parsedDate, "America/Sao_Paulo");
    return utcDate.getTime() <= Date.now() ? 1 : 0;
};

const STREAMING_LINK_PROVIDERS = [
    { value: '', label: 'Automático' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'vimeo', label: 'Vimeo' },
    { value: 'twitch', label: 'Twitch' },
    { value: 'kick', label: 'Kick' },
    { value: 'hls', label: 'HLS (.m3u8)' },
    { value: 'direct', label: 'Arquivo direto (MP4/WebM)' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'dailymotion', label: 'Dailymotion' },
    { value: 'wistia', label: 'Wistia' },
    { value: 'custom', label: 'Personalizado' },
];

const STREAMING_LINK_PROVIDER_HELP = {
    '': {
        tooltip: 'Use Automático para links de plataformas conhecidas. O servidor tenta identificar o provedor pelo endereço.',
        description: 'Informe o link público da transmissão. O sistema tentará identificar a plataforma automaticamente.'
    },
    youtube: {
        tooltip: 'Use para links públicos de vídeos ou lives do YouTube.',
        description: 'Aceita links como youtube.com/watch?v=... ou youtu.be/...'
    },
    vimeo: {
        tooltip: 'Use para vídeos hospedados no Vimeo.',
        description: 'Informe o link público do vídeo do Vimeo.'
    },
    twitch: {
        tooltip: 'Use para um canal ou vídeo da Twitch.',
        description: 'Informe o link público do canal ou vídeo da Twitch.'
    },
    kick: {
        tooltip: 'Use para um canal ou vídeo da Kick.',
        description: 'Informe o link público do canal ou vídeo da Kick.'
    },
    hls: {
        tooltip: 'Use quando você tiver uma playlist HLS com extensão .m3u8.',
        description: 'A URL .m3u8 precisa estar acessível pelo navegador do participante.'
    },
    direct: {
        tooltip: 'Use para um arquivo de vídeo acessível diretamente pela internet.',
        description: 'Informe uma URL direta para um arquivo MP4 ou WebM.'
    },
    facebook: {
        tooltip: 'Use para vídeos ou lives publicados no Facebook.',
        description: 'Informe o link público do vídeo ou live do Facebook.'
    },
    dailymotion: {
        tooltip: 'Use para vídeos hospedados no Dailymotion.',
        description: 'Informe o link público do vídeo do Dailymotion.'
    },
    wistia: {
        tooltip: 'Use para vídeos hospedados no Wistia.',
        description: 'Informe o link público do vídeo do Wistia.'
    },
    custom: {
        tooltip: 'Use para outra plataforma ou quando o link não se encaixar nas opções anteriores.',
        description: 'Informe uma URL HTTPS válida fornecida pela sua plataforma de transmissão.'
    }
};

const STREAMING_LINK_EMBED_HELP = {
    tooltip: 'Use quando a plataforma fornecer um código de iframe ou uma URL de embed específica.',
    description: 'Cole o valor do atributo src do iframe ou o iframe completo. O servidor extrairá o src antes de salvar.',
    example: 'https://www.youtube.com/embed/VIDEO_ID ou <iframe src="https://.../embed/VIDEO_ID"></iframe>'
};

const STREAMING_LINK_URL_MODE_HELP = {
    tooltip: 'Use este modo quando você tiver o link público da transmissão, como uma página do YouTube, Vimeo ou Twitch.',
    description: 'Informe o link público da transmissão. O sistema usará o provedor selecionado ou tentará identificá-lo automaticamente.',
    example: 'https://www.youtube.com/watch?v=VIDEO_ID ou https://youtu.be/VIDEO_ID'
};

const getStreamingLinkModeHelp = (useEmbedUrl) => (
    useEmbedUrl ? STREAMING_LINK_EMBED_HELP : STREAMING_LINK_URL_MODE_HELP
);

const getStreamingLinkProviderHelp = (provider) => (
    STREAMING_LINK_PROVIDER_HELP[provider] || STREAMING_LINK_PROVIDER_HELP['']
);

const getStreamingLinkFieldError = (errors, index, field) => (
    Array.isArray(errors.links) && errors.links[index] && typeof errors.links[index] === 'object'
        ? errors.links[index][field]
        : null
);

const getStreamingLinkRowError = (errors, index) => (
    Array.isArray(errors.links) && typeof errors.links[index] === 'string'
        ? errors.links[index]
        : null
);

const getStreamingLinkTouched = (touched, index, field) => (
    Array.isArray(touched.links) && touched.links[index] && typeof touched.links[index] === 'object'
        ? touched.links[index][field]
        : false
);

const getStreamingTouchedFields = (links = []) => ({
    schedule_id: true,
    title: true,
    description: true,
    user_id: true,
    links: (Array.isArray(links) ? links : []).map(() => ({
        title: true,
        provider: true,
        url: true,
        embed_url: true,
        status: true,
        json: {
            use_embed_url: true
        }
    }))
});

const getFirstStreamingValidationMessage = (errors) => {
    if (errors.schedule_id) return errors.schedule_id;
    if (errors.title) return errors.title;
    if (errors.user_id) return errors.user_id;
    if (errors.description) return errors.description;
    if (typeof errors.links === 'string') return errors.links;

    if (Array.isArray(errors.links)) {
        for (let index = 0; index < errors.links.length; index++) {
            const linkError = errors.links[index];
            if (!linkError) continue;
            if (typeof linkError === 'string') return `Link ${index + 1}: ${linkError}`;
            if (linkError.url) return `Link ${index + 1}: ${linkError.url}`;
            if (linkError.embed_url) return `Link ${index + 1}: ${linkError.embed_url}`;
            if (linkError.title) return `Link ${index + 1}: ${linkError.title}`;
            if (linkError.provider) return `Link ${index + 1}: ${linkError.provider}`;
            if (linkError.status) return `Link ${index + 1}: ${linkError.status}`;
        }
    }

    return 'Verifique os campos obrigatórios antes de salvar a transmissão.';
};

const getDefaultStreamingChannel = (scheduleId, position = 1) => ({
    id: null,
    schedule_id: scheduleId || '',
    chat_id: null,
    title: '',
    description: '',
    status: 0,
    chat_enabled: 1,
    user_id: null,
    position,
    preview_image: '',
    scheduled_start_at: getDefaultStreamingStartDate(),
    json: {},
    links: [
        {
            title: 'Link 1',
            url: '',
            provider: '',
            embed_url: '',
            position: 1,
            status: 1,
            json: {
                use_embed_url: 0
            }
        }
    ]
});

const normalizeStreamingLinksForForm = (links = []) => {
    const normalized = Array.isArray(links) && links.length > 0 ? links : getDefaultStreamingChannel().links;
    return normalized
        .map((link, index) => ({
            id: link.id || null,
            title: link.title || `Link ${index + 1}`,
            url: link.url || '',
            provider: link.provider || '',
            embed_url: link.embed_url || '',
            position: Number(link.position || index + 1),
            status: Number(link.status ?? 1),
            json: {
                ...(link.json || {}),
                use_embed_url: Number(link.json?.use_embed_url || 0) === 1 ? 1 : 0
            }
        }))
        .sort((a, b) => Number(a.position || 0) - Number(b.position || 0))
        .map((link, index) => ({ ...link, position: index + 1 }));
};

const normalizeStreamingChannelForForm = (channel, scheduleId, position = 1) => {
    const defaults = getDefaultStreamingChannel(scheduleId, position);
    return {
        ...defaults,
        ...(channel || {}),
        schedule_id: channel?.schedule_id || scheduleId || '',
        chat_enabled: Number(channel?.chat_enabled ?? defaults.chat_enabled),
        user_id: Number(channel?.user_id) > 0 ? Number(channel.user_id) : null,
        status: Number(channel?.status ?? defaults.status),
        position: Number(channel?.position || position),
        preview_image: channel?.preview_image || '',
        scheduled_start_at: formatStreamingDateForForm(channel?.scheduled_start_at || defaults.scheduled_start_at),
        links: normalizeStreamingLinksForForm(channel?.links || defaults.links)
    };
};

const createDraftStreamingId = () => `draft-streaming-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const isDraftStreamingId = (id) => typeof id === 'string' && id.startsWith('draft-streaming-');

const isPersistedStreamingId = (id) => {
    if (isDraftStreamingId(id)) return false;
    const numberId = Number(id);
    return Number.isInteger(numberId) && numberId > 0;
};

const getStreamingUserLabel = (user) => user?.email || `Usuário ${user?.user_id}`;

const buildScheduleStreamingPayload = (streaming, eventId, scheduleId, position) => ({
    event_id: eventId,
    id: isPersistedStreamingId(streaming.id) ? Number(streaming.id) : null,
    schedule_id: scheduleId,
    title: streaming.title,
    description: streaming.description || '',
    status: Number(streaming.status || 0),
    chat_enabled: Number(streaming.chat_enabled ?? 1),
    preview_image: streaming.preview_image || '',
    scheduled_start_at: normalizeStreamingDateForSubmit(streaming.scheduled_start_at),
    position: Number(position || streaming.position || 1),
    json: streaming.json || {},
    links: normalizeStreamingLinksForForm(streaming.links),
    user_id: streaming.user_id || null
});

const streamReportRows = (rows) => Array.isArray(rows) ? rows : [];

const streamReportNumber = (value) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
};

const streamReportMetricValue = (row = {}, ...keys) => {
    const key = keys.find((candidate) => row?.[candidate] !== undefined && row?.[candidate] !== null && row?.[candidate] !== '');
    return streamReportNumber(key ? row[key] : 0);
};

const formatStreamingReportNumber = (value) => streamReportNumber(value).toLocaleString('pt-BR');

const formatStreamingReportPercent = (value) => `${streamReportNumber(value).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;

const formatStreamingReportSeconds = (value) => {
    const totalSeconds = Math.max(0, Math.floor(streamReportNumber(value)));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) return `${hours}h ${String(minutes).padStart(2, '0')}min`;
    if (minutes > 0) return `${minutes}min ${String(seconds).padStart(2, '0')}s`;
    return `${seconds}s`;
};

const formatStreamingReportScheduleVariance = (value) => {
    if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return null;
    const varianceSeconds = Math.round(Number(value));
    if (Math.abs(varianceSeconds) < 60) return 'No horário previsto';
    return varianceSeconds > 0
        ? `${formatStreamingReportSeconds(varianceSeconds)} após o previsto`
        : `${formatStreamingReportSeconds(Math.abs(varianceSeconds))} antes do previsto`;
};

const STREAMING_REPORT_TIME_ZONE = 'America/Sao_Paulo';

const parseStreamingReportDateTime = (value) => {
    if (!value) return null;
    const rawValue = String(value);
    const normalized = rawValue.includes('T') ? rawValue : rawValue.replace(' ', 'T');
    const parsedDate = new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized) ? normalized : `${normalized}Z`);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const formatStreamingReportDateTime = (value) => {
    if (!value) return '-';
    const parsedDate = parseStreamingReportDateTime(value);
    if (!parsedDate) return String(value);
    return formatInTimeZone(parsedDate, STREAMING_REPORT_TIME_ZONE, 'dd/MM/yyyy HH:mm');
};

const formatStreamingActivityDateTime = (value) => {
    return formatStreamingReportDateTime(value);
};

const compactStreamingReportDateTime = (formattedValue, includeDate = false) => {
    if (!formattedValue || formattedValue === '-') return formattedValue || '-';
    return includeDate
        ? `${formattedValue.slice(0, 5)} ${formattedValue.slice(11)}`
        : formattedValue.slice(11);
};

const STREAMING_ACTIVITY_LABELS = {
    manual_opening: 'Abertura',
    manual_speaker: 'Palestra',
    manual_panel: 'Painel',
    manual_voting: 'Votação',
    manual_quiz: 'Quiz',
    manual_qna: 'Perguntas e respostas',
    manual_break: 'Intervalo',
    manual_technical: 'Ajuste técnico',
    manual_closing: 'Encerramento',
    manual_other: 'Outro momento',
    stream_started: 'Transmissão iniciada',
    stream_closed: 'Transmissão encerrada',
    stream_status_updated: 'Status da transmissão atualizado',
    stream_updated: 'Informações atualizadas',
    stream_announcement: 'Aviso enviado',
    poll_created: 'Votação criada',
    poll_reused: 'Votação reutilizada',
    poll_expired: 'Votação expirada',
    poll_closed: 'Votação encerrada',
    poll_deleted: 'Votação excluída',
    stream_test_prepared: 'Teste da transmissão preparado',
    chat_mode: 'Modo do chat',
    chat_moderation: 'Moderação do chat',
};

const STREAMING_REPORT_HIGH_VOLUME_ACTIVITY_TYPES = new Set([
    'poll_vote',
    'viewer_join',
    'feedback',
    'reaction_burst',
]);

const normalizeStreamingReportText = (value) => String(value || '')
    .replace(/\bTransmissao\b/g, 'Transmissão')
    .replace(/\btransmissao\b/g, 'transmissão')
    .replace(/\bVotacao\b/g, 'Enquete')
    .replace(/\bvotacao\b/g, 'enquete')
    .replace(/\bAutomatico\b/g, 'Automático')
    .replace(/\bautomatico\b/g, 'automático')
    .replace(/\bTecnico\b/g, 'Técnico')
    .replace(/\btecnico\b/g, 'técnico')
    .replace(/\bInformacoes\b/g, 'Informações')
    .replace(/\binformacoes\b/g, 'informações')
    .replace(/\bAdvertencia\b/g, 'Advertência')
    .replace(/\badvertencia\b/g, 'advertência')
    .replace(/\bOpcao\b/g, 'Opção')
    .replace(/\bopcao\b/g, 'opção')
    .replace(/\bEsta\b/g, 'Está')
    .replace(/\besta\b/g, 'está');

const formatStreamingActivityMessage = (activity = {}) => {
    const type = String(activity.activity_type || '').toLowerCase();
    const message = normalizeStreamingReportText(activity.message).trim();

    if (type === 'poll_created') return message && !/^votação criada$/i.test(message) ? `Votação criada: ${message}` : STREAMING_ACTIVITY_LABELS[type];
    if (type === 'stream_announcement') return message && !/^aviso enviado$/i.test(message) ? `Aviso: ${message}` : STREAMING_ACTIVITY_LABELS[type];
    if (type.startsWith('manual_')) return message || STREAMING_ACTIVITY_LABELS[type] || 'Atividade registrada';
    if (message) return message;
    return STREAMING_ACTIVITY_LABELS[type] || 'Atividade registrada';
};

const STREAMING_ACTIVITY_COLOR_PALETTE = CHART_PALETTE;

const STREAMING_CONNECTED_PARTICIPANT_FILTER = Object.freeze({
    extraPropsParticipants: false,
    participantReportMode: 'records',
    checkin_filter: 2,
    dateRange: { startDate: null, endDate: null },
    checkinDateRange: { startDate: null, endDate: null },
    registrationWindowMinutes: 10,
});

const getStreamingConnectedParticipantInformationFields = () => [
    {
        Header: 'Acessos',
        accessor: 'stream_access_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Tempo conectado',
        accessor: 'stream_connected_seconds',
        Cell: ({ value }) => formatStreamingReportSeconds(value),
        exportValue: (_, value) => formatStreamingReportSeconds(value),
    },
    {
        Header: 'Primeira presença no período',
        accessor: 'stream_first_connected_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última entrada no período',
        accessor: 'stream_last_joined_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última presença no período',
        accessor: 'stream_last_observed_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última saída confirmada',
        accessor: 'stream_last_departed_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Acessos encerrados',
        accessor: 'stream_finalized_access_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Acessos sem encerramento confirmado',
        accessor: 'stream_unfinished_access_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Reações',
        accessor: 'stream_reaction_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Primeira reação',
        accessor: 'stream_first_reaction_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última reação',
        accessor: 'stream_last_reaction_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Mensagens no chat',
        accessor: 'stream_chat_message_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Primeira mensagem',
        accessor: 'stream_first_chat_message_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última mensagem',
        accessor: 'stream_last_chat_message_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Votos',
        accessor: 'stream_poll_vote_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Enquetes respondidas',
        accessor: 'stream_answered_poll_count',
        Cell: ({ value }) => formatStreamingReportNumber(value),
        exportValue: (_, value) => formatStreamingReportNumber(value),
    },
    {
        Header: 'Primeiro voto',
        accessor: 'stream_first_poll_vote_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Último voto',
        accessor: 'stream_last_poll_vote_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
    {
        Header: 'Última atividade',
        accessor: 'stream_last_activity_at',
        Cell: ({ value }) => formatStreamingReportDateTime(value),
        exportValue: (_, value) => formatStreamingReportDateTime(value),
    },
];

const normalizeStreamingActivityType = (activityType) => String(activityType || 'manual_other').toLowerCase();

const buildStreamingActivityColorMap = (activities = []) => {
    const types = [...new Set(streamReportRows(activities)
        .map((activity) => normalizeStreamingActivityType(activity.activity_type))
        .filter(Boolean))].sort();
    return new Map(types.map((type, index) => [
        type,
        STREAMING_ACTIVITY_COLOR_PALETTE[index % STREAMING_ACTIVITY_COLOR_PALETTE.length],
    ]));
};

const getStreamingActivityColor = (activityType, colorMap) => {
    const normalizedType = normalizeStreamingActivityType(activityType);
    return colorMap?.get(normalizedType) || STREAMING_ACTIVITY_COLOR_PALETTE[0];
};

const getStreamingActivityMeta = (activity = {}, colorMap) => {
    const type = String(activity.activity_type || 'manual').toLowerCase();
    const category = type.startsWith('poll_')
        ? 'Votações'
        : (type === 'stream_announcement' || type.startsWith('chat_'))
            ? 'Chat e moderação'
        : type === 'stream_test_prepared'
            ? 'Teste técnico'
            : type.startsWith('manual_')
                ? 'Atividades manuais'
                : type.startsWith('stream_')
                    ? 'Ciclo da transmissão'
                    : 'Interação do público';
    const dotClass = type.startsWith('poll_')
        ? 'poll'
        : (type === 'stream_announcement'
            ? 'source'
            : (type.startsWith('chat_')
                ? 'moderation'
                : category === 'Teste técnico'
                    ? 'technical'
                    : category === 'Atividades manuais'
                        ? 'manual'
                        : category === 'Ciclo da transmissão'
                            ? 'stream'
                            : 'audience'));
    const title = STREAMING_ACTIVITY_LABELS[type] || formatStreamingActivityMessage({ ...activity, message: '' });
    const detail = normalizeStreamingReportText(activity.message).trim() || title;
    return { category, color: getStreamingActivityColor(type, colorMap), detail, dotClass, title, type };
};

const normalizeStreamingActivitySearchText = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .replace(/[^a-z0-9_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const getStreamingActivitySearchText = (activity = {}) => {
    const meta = getStreamingActivityMeta(activity);
    const activityTimestamp = activity.display_start_at || activity.activity_start_at || activity.created_at;
    const type = String(activity.activity_type || '').toLowerCase();
    return [
        meta.category,
        meta.detail,
        meta.title,
        type,
        activity.message,
        formatStreamingActivityDateTime(activityTimestamp),
        formatStreamingActivityDateTime(activity.activity_start_at || activity.created_at),
        formatStreamingActivityDateTime(activity.display_end_at || activity.activity_end_at),
        type.startsWith('poll_') ? 'enquete enquetes votacao votacoes' : '',
    ].map(normalizeStreamingActivitySearchText).filter(Boolean).join(' ');
};

const getStreamingReportPrimaryColor = (dataTable) => {
    const configuredColor = dataTable?.json?.primaryColor;
    if (configuredColor) return configuredColor;
    if (typeof document !== 'undefined') {
        const themeColor = getComputedStyle(document.documentElement).getPropertyValue('--bs-primary').trim();
        if (themeColor) return themeColor;
    }
    return '#0d6efd';
};

const parseStreamingReportColor = (value) => {
    const normalized = String(value || '').trim();
    const hexMatch = normalized.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
    if (hexMatch) {
        const hex = hexMatch[1].length === 3
            ? hexMatch[1].split('').map((character) => character + character).join('')
            : hexMatch[1];
        return [0, 2, 4].map((offset) => Number.parseInt(hex.slice(offset, offset + 2), 16));
    }
    const rgbMatch = normalized.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i);
    return rgbMatch
        ? rgbMatch.slice(1, 4).map((channel) => Math.max(0, Math.min(255, Math.round(Number(channel)))))
        : null;
};

const withStreamingReportColorAlpha = (value, alpha) => {
    const rgb = parseStreamingReportColor(value);
    return rgb ? `rgba(${rgb.join(', ')}, ${alpha})` : value;
};

export const buildStreamingActivityTimeline = (activities = [], colorMap = buildStreamingActivityColorMap(activities)) => {
    const datedActivities = streamReportRows(activities).map((activity) => {
        const startDate = parseStreamingReportDateTime(activity.display_start_at || activity.activity_start_at || activity.created_at);
        const endDate = parseStreamingReportDateTime(activity.display_end_at || activity.activity_end_at) || startDate;
        const activityMeta = getStreamingActivityMeta(activity, colorMap);
        return startDate ? {
            end: Math.max(startDate.getTime() + 1, endDate?.getTime() || startDate.getTime()),
            start: startDate.getTime(),
            label: activityMeta.title,
            type: activityMeta.type,
        } : null;
    }).filter(Boolean);
    if (!datedActivities.length) return { categories: [], series: [], tooltipCategories: [] };

    const firstTimestamp = Math.min(...datedActivities.map(({ start }) => start));
    const lastTimestamp = Math.max(...datedActivities.map(({ end }) => end));
    const minimumBucket = 15 * 60 * 1000;
    const rawRange = Math.max(minimumBucket, lastTimestamp - firstTimestamp);
    const bucketSize = Math.max(minimumBucket, Math.ceil((rawRange / 24) / minimumBucket) * minimumBucket);
    const firstBucket = Math.floor(firstTimestamp / bucketSize) * bucketSize;
    const lastBucket = Math.floor(lastTimestamp / bucketSize) * bucketSize;
    const categories = [];
    const tooltipCategories = [];
    const activityTypes = [...new Set(datedActivities.map(({ type }) => type))].sort();
    const valuesByType = activityTypes.reduce((result, type) => ({ ...result, [type]: [] }), {});
    const labelsByType = Object.fromEntries(datedActivities.map(({ type, label }) => [type, label]));

    for (let timestamp = firstBucket; timestamp <= lastBucket; timestamp += bucketSize) {
        const bucketEnd = timestamp + bucketSize;
        activityTypes.forEach((type) => {
            valuesByType[type].push(datedActivities.filter(({ end, start, type: itemType }) => start < bucketEnd && end > timestamp && itemType === type).length);
        });
        const bucketDate = new Date(timestamp);
        const bucketEndDate = new Date(bucketEnd);
        categories.push(compactStreamingReportDateTime(formatStreamingReportDateTime(bucketDate), true));
        tooltipCategories.push(`${formatStreamingReportDateTime(bucketDate)} - ${formatStreamingReportDateTime(bucketEndDate)}`);
    }

    return {
        categories,
        colors: activityTypes.map((type) => getStreamingActivityColor(type, colorMap)),
        series: activityTypes.map((type) => ({ name: labelsByType[type] || type, data: valuesByType[type] })),
        tooltipCategories,
    };
};

const buildStreamingReportChartOptions = ({
    categories = [],
    isBar = false,
    tooltipCategories = categories,
    tooltipIntersect = false,
    tooltipShared = true,
    yTitle = '',
} = {}) => {
    const labelInterval = Math.max(1, Math.ceil(Math.max(1, categories.length - 1) / 7));
    return {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { ...PROJECT_CHART_PADDING } },
        legend: { position: 'bottom', labels: { fontFamily: PROJECT_CHART_FONT, fontSize: PROJECT_CHART_FONT_SIZE } },
        tooltips: {
            titleFontFamily: PROJECT_CHART_FONT,
            bodyFontFamily: PROJECT_CHART_FONT,
            footerFontFamily: PROJECT_CHART_FONT,
            titleFontSize: PROJECT_CHART_FONT_SIZE,
            bodyFontSize: PROJECT_CHART_FONT_SIZE,
            mode: tooltipShared ? 'index' : 'nearest',
            intersect: tooltipIntersect,
            callbacks: {
                title: (items) => tooltipCategories[items?.[0]?.index] || '',
                label: (tooltipItem, data) => {
                    const dataset = data.datasets?.[tooltipItem.datasetIndex];
                    const value = tooltipItem.yLabel;
                    return `${dataset?.label ? `${dataset.label}: ` : ''}${value}`;
                },
            },
        },
        scales: {
            xAxes: [{
                gridLines: { color: '#e9ecef' },
                ticks: {
                    autoSkip: false,
                    fontFamily: PROJECT_CHART_FONT,
                    fontSize: PROJECT_CHART_FONT_SIZE,
                    callback: (_value, index) => (
                        index === 0 || index === categories.length - 1 || index % labelInterval === 0
                            ? categories[index]
                            : ''
                    ),
                },
            }],
            yAxes: [{
                gridLines: { color: '#e9ecef' },
                scaleLabel: { display: Boolean(yTitle), labelString: yTitle, fontFamily: PROJECT_CHART_FONT, fontSize: PROJECT_CHART_FONT_SIZE },
                ticks: { beginAtZero: true, precision: 0, fontFamily: PROJECT_CHART_FONT, fontSize: PROJECT_CHART_FONT_SIZE },
            }],
        },
        ...(isBar ? { datasets: { bar: { barPercentage: 0.62, categoryPercentage: 0.8 } } } : {}),
    };
};

const STREAMING_RESET_CONFIRMATION_MESSAGE = 'O relatório da execução encerrada será preservado. Uma nova execução limpa será criada e as gravações antigas ficarão bloqueadas. Esta ação não exclui mensagens, votos, reações, presença ou moderação da execução anterior.';
const STREAMING_DELETE_CONFIRMATION_MESSAGE = 'Esta exclusão é permanente. Ela remove o ID da transmissão, todas as execuções e os dados históricos associados. A transmissão precisará ser cadastrada novamente para ser usada outra vez.';
const STREAMING_RUN_STATUS_LABELS = {
    allocated: 'Preparada',
    live: 'Ao vivo',
    closed: 'Encerrada',
    abandoned: 'Interrompida',
};

export const ScheduleStreamingManagementComponent = ({ scheduleId, dataTable, dataAddForm, setDataAddForm, setModal, disabled = false, streamings: streamingsProp, globalMode = false, emptyMessage }) => {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [shareModal, setShareModal] = useState({ show: false, title: '', options: [], selectedKey: 'public' });
    const notyf = useContext(NotyfContext);
    const streamings = Array.isArray(streamingsProp)
        ? streamingsProp
        : (Array.isArray(dataAddForm.scheduleStreamings) ? dataAddForm.scheduleStreamings : []);
    const canReorder = !disabled && !globalMode;

    const openChannelForm = (streaming = false) => {
        if (disabled) return;
        setDataAddForm((prevState) => ({
            ...prevState,
            streamingEditorMode: globalMode ? 'global' : 'schedule',
            streamingChannelData: streaming || getDefaultStreamingChannel(globalMode ? '' : scheduleId, globalMode ? 1 : streamings.length + 1)
        }));
        setModal((prevState) => ({
            ...prevState,
            showStreamingChannelForm: true
        }));
    };

    const openReportModal = (streaming, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!streaming?.id) return;
        setDataAddForm((prevState) => ({
            ...prevState,
            streamingReportData: streaming,
            streamingReportEditorMode: globalMode ? 'global' : 'schedule'
        }));
        setModal((prevState) => ({
            ...prevState,
            showStreamingReportModal: true
        }));
    };

    const openShareModal = (streaming, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!isPersistedStreamingId(streaming?.id)) return;

        const publicUrl = `${domainConfig.eventos}/agenda/transmissao/${streaming.id}?token=${dataTable.token}`;
        setShareModal({
            show: true,
            title: streaming.title || 'Transmissão',
            options: getScheduleStreamingShareOptions(publicUrl),
            selectedKey: 'public',
        });
    };

    const selectedShareOption = shareModal.options.find((option) => option.key === shareModal.selectedKey);

    const copySelectedShareOption = () => {
        if (!selectedShareOption?.url) return;
        handleShare(selectedShareOption.url, notyf);
        setShareModal((current) => ({ ...current, show: false }));
    };

    const updateLocalOrder = (fromIndex, toIndex) => {
        if (!canReorder) return;
        if (fromIndex === toIndex || fromIndex === null) return;
        const updated = [...streamings];
        const [draggedItem] = updated.splice(fromIndex, 1);
        updated.splice(toIndex, 0, draggedItem);
        const reordered = updated.map((streaming, index) => ({ ...streaming, position: index + 1 }));

        setDraggedIndex(toIndex);
        setDataAddForm((prevState) => ({
            ...prevState,
            scheduleStreamings: reordered
        }));
    };

    const persistOrder = async () => {
        if (!canReorder) return;
        setDraggedIndex(null);
    };


    return (
        <Row className="mb-3 mx-0">
            <Card className="mb-3 formCard col-md-12 px-0">
                <Card.Body>
                    {streamings.length > 0 ? (
                        <>
                            <Col className="text-center mb-2">
                                <small className="text-center opacity-75">{globalMode ? 'Transmissões agrupadas por evento da agenda' : disabled ? 'Transmissões bloqueadas para edição' : '(Clique e arraste para ordenar os canais)'}</small>
                            </Col>
                            <Row>
                                {streamings.map((streaming, index) => {
                                    const statusBadge = getScheduleStreamingStatusBadge(streaming.status, dataTable);
                                    const linkCount = Number(streaming.links_count || streaming.links?.length || 0);
                                    const scheduledStartAt = formatStreamingDateForForm(
                                        globalMode ? (streaming.schedule_start_date || streaming.scheduled_start_at) : streaming.scheduled_start_at
                                    );
                                    const chatEnabled = Number(streaming.chat_enabled ?? 1) === 1;
                                    const isPersisted = isPersistedStreamingId(streaming.id);
                                    // Find responsible user email
                                    const responsibleUser = (dataAddForm.availableStreamingUsers || []).find(
                                        (u) => Number(u.user_id) === Number(streaming.user_id)
                                    );
                                    const responsibleLabel = responsibleUser
                                        ? getStreamingUserLabel(responsibleUser)
                                        : (streaming.user_id ? `Usuário ${streaming.user_id}` : 'Sem responsável');
                                    const previewSource = streaming.preview_image
                                        ? getStreamingPreviewUrl(dataTable.event_id, streaming.preview_image)
                                        : imageNotFound;
                                    return (
                                        <Col key={`schedule-streaming-channel-${streaming.id}`} className="mb-3" md={6} lg={4}>
                                            <div
                                                style={{ cursor: disabled ? 'default' : 'pointer' }}
                                                className="schedule-streaming-card btn btn-secondary d-flex flex-column w-100 b-15 text-start text-white position-relative"
                                                draggable={canReorder}
                                                onDragStart={() => {
                                                    if (canReorder) setDraggedIndex(index);
                                                }}
                                                onDragOver={(event) => {
                                                    if (!canReorder) return;
                                                    event.preventDefault();
                                                    updateLocalOrder(draggedIndex, index);
                                                }}
                                                onDragEnd={persistOrder}
                                                onClick={() => openChannelForm(streaming)}
                                            >
                                                <div className="schedule-streaming-card-actions d-flex justify-content-between align-items-center gap-2 mt-3 order-2">
                                                    <div className="schedule-streaming-card-meta-item d-flex align-items-center gap-2">
                                                        <FontAwesomeIcon icon={faLink} />
                                                        <small>{linkCount} {linkCount === 1 ? 'link' : 'links'}</small>
                                                    </div>
                                                    {isPersisted && (
                                                        <div className="d-flex gap-2 ms-auto">
                                                            <OverlayTrigger overlay={<Tooltip>Ver relatórios</Tooltip>}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={(e) => openReportModal(streaming, e)}
                                                                    aria-label="Ver relatórios"
                                                                >
                                                                    <FontAwesomeIcon icon={faChartLine} />
                                                                </button>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger overlay={<Tooltip>Compartilhar</Tooltip>}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={(e) => {
                                                                        openShareModal(streaming, e);
                                                                    }}
                                                                    aria-label="Compartilhar"
                                                                >
                                                                    <FontAwesomeIcon icon={faShare} />
                                                                </button>
                                                            </OverlayTrigger>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex flex-column flex-grow-1 w-100 gap-3 order-1">
                                                    <div className="d-flex align-items-start gap-3">
                                                        <img
                                                            className="schedule-streaming-card-preview flex-shrink-0"
                                                            src={previewSource}
                                                            alt="Prévia da transmissão"
                                                            onError={(event) => {
                                                                event.currentTarget.onerror = null;
                                                                event.currentTarget.src = imageNotFound;
                                                            }}
                                                        />
                                                        <div className="schedule-streaming-card-title flex-grow-1">
                                                            <small className="text-uppercase opacity-75">{globalMode ? (streaming.scheduleTitle || `Agenda #${streaming.schedule_id}`) : `Canal #${index + 1}`}</small>
                                                            <span className="fw-bold text-truncate d-block">{streaming.title || 'Transmissão'}</span>
                                                            <Badge bg={statusBadge.bg} style={statusBadge.style} className={`${statusBadge.className || ''} mt-2`}>
                                                                {statusBadge.label}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-streaming-card-meta d-grid gap-2 mt-auto">
                                                        <div className="schedule-streaming-card-meta-item d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon={faUser} />
                                                            <small>{responsibleLabel}</small>
                                                        </div>
                                                        <div className="schedule-streaming-card-meta-item d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon={faCalendarDays} />
                                                            <small>{scheduledStartAt || 'Sem data de início'}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </>
                    ) : (
                        <p className="text-center opacity-75 my-4">{emptyMessage || 'Nenhum canal de transmissão cadastrado'}</p>
                    )}
                </Card.Body>
                {!disabled && (
                    <Col className="mb-3 text-center">
                        <Button
                            variant="primary"
                            className="btn-sm"
                            onClick={() => openChannelForm(false)}
                        >
                            Adicionar transmissão
                        </Button>
                    </Col>
                )}
            </Card>
            <Modal
                show={shareModal.show}
                onHide={() => setShareModal((current) => ({ ...current, show: false }))}
                centered
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="d-block">Compartilhar transmissão</span>
                        <small className="d-block text-muted mt-1">{shareModal.title}</small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted mb-3">
                        Selecione o tipo de link que deseja copiar.
                    </p>
                    <div className="d-grid gap-3">
                        {shareModal.options.map((option) => (
                            <Form.Check
                                key={option.key}
                                type="radio"
                                name={`schedule-streaming-share-${shareModal.title}`}
                                id={`schedule-streaming-share-${option.key}`}
                                checked={shareModal.selectedKey === option.key}
                                onChange={() => setShareModal((current) => ({ ...current, selectedKey: option.key }))}
                                label={(
                                    <>
                                        <span className="fw-bold d-block">{option.label}</span>
                                        <small className="text-muted">{option.description}</small>
                                    </>
                                )}
                            />
                        ))}
                    </div>
                    {selectedShareOption?.url && (
                        <InputGroup className="mt-4">
                            <Form.Control
                                value={selectedShareOption.url}
                                readOnly
                                aria-label={selectedShareOption.label}
                            />
                            <Button variant="primary" onClick={copySelectedShareOption}>
                                <FontAwesomeIcon icon={faCopy} className="me-2" />
                                Copiar
                            </Button>
                        </InputGroup>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShareModal((current) => ({ ...current, show: false }))}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Row>
    );
};

export const ScheduleStreamingChannelForm = ({ modal, setModal, dataTable, dataAddForm, setDataAddForm, setDataTableUpdate, handlePreviewError, scheduleOptions = [], availableStreamings = [] }) => {
    const { setLoading } = useLayout();
    const notyf = useContext(NotyfContext);
    const [draggedLinkIndex, setDraggedLinkIndex] = useState(null);
    const currentChannel = dataAddForm.streamingChannelData || false;
    const scheduleId = currentChannel?.schedule_id || null;
    const isGlobalEditor = dataAddForm.streamingEditorMode === 'global';
    const currentPosition = currentChannel?.position || ((dataAddForm.scheduleStreamings?.length || 0) + 1);
    const responsibleUserOptions = (dataAddForm.availableStreamingUsers || []).map((user) => ({
        value: Number(user.user_id),
        label: getStreamingUserLabel(user)
    }));

    const validationSchema = Yup.object().shape({
        schedule_id: isGlobalEditor
            ? Yup.number().required('Selecione um evento da agenda').min(1, 'Selecione um evento da agenda')
            : Yup.mixed(),
        title: Yup.string()
            .required('O título é obrigatório')
            .max(150, 'Máximo de 150 caracteres'),
        description: Yup.string()
            .max(500, 'Máximo de 500 caracteres'),
        scheduled_start_at: Yup.string()
            .nullable(),
        status: Yup.number().oneOf([0, 1, 2]),
        chat_enabled: Yup.number().oneOf([0, 1]),
        user_id: Yup.number()
            .nullable()
            .typeError('Selecione um usuário responsável')
            .required('O usuário responsável é obrigatório')
            .min(1, 'Selecione um usuário responsável'),
        links: Yup.array()
            .of(Yup.object().shape({
                title: Yup.string().max(120, 'Máximo de 120 caracteres'),
                url: Yup.string().url('URL inválida').nullable(),
                provider: Yup.string().max(80, 'Máximo de 80 caracteres'),
                embed_url: Yup.string()
                    .transform((value) => value === '' ? null : value)
                    .nullable()
                    .test('embed-url-format', 'URL inválida', (value) => (
                        !value
                        || /^https?:\/\//i.test(value)
                        || /<iframe[^>]+src=["']https?:\/\//i.test(value)
                    )),
                status: Yup.number().oneOf([0, 1]),
                json: Yup.object().shape({
                    use_embed_url: Yup.number().oneOf([0, 1])
                })
            }).test('streaming-link-url-mode', 'Informe a URL do link ou a URL de embed', (link) => {
                if (Number(link?.json?.use_embed_url || 0) === 1) {
                    return Boolean(link?.embed_url);
                }
                return Boolean(link?.url);
            }))
            .min(1, 'Adicione pelo menos um link')
            .test('active-link', 'Adicione pelo menos um link ativo', (links) => Array.isArray(links) && links.some((link) => Number(link.status ?? 1) === 1))
    });

    const closeModal = () => {
        setModal((prevState) => ({
            ...prevState,
            showStreamingChannelForm: false
        }));
        setDataAddForm((prevState) => ({
            ...prevState,
            streamingChannelData: false,
            streamingEditorMode: false
        }));
        setDraggedLinkIndex(null);
    };

    const updateStoredStreamings = (streaming) => {
        if (!streaming) return;
        setDataAddForm((prevState) => {
            const current = prevState.scheduleStreamings || [];
            const exists = current.some((item) => String(item.id) === String(streaming.id));
            const next = exists
                ? current.map((item) => String(item.id) === String(streaming.id) ? streaming : item)
                : [...current, streaming];
            return {
                ...prevState,
                streamingChannelData: prevState.streamingChannelData
                    && String(prevState.streamingChannelData.id) === String(streaming.id)
                    ? { ...prevState.streamingChannelData, ...streaming }
                    : prevState.streamingChannelData,
                scheduleStreamings: next
                    .map((item, index) => ({ ...item, position: Number(item.position || index + 1) }))
                    .sort((a, b) => Number(a.position || 0) - Number(b.position || 0))
            };
        });
    };

    const buildStreamingStatusPayload = (streaming, status) => ({
        event_id: dataTable.event_id,
        id: Number(streaming.id),
        schedule_id: streaming.schedule_id,
        title: streaming.title,
        description: streaming.description || '',
        status,
        chat_enabled: Number(streaming.chat_enabled ?? 1),
        preview_image: streaming.preview_image || '',
        scheduled_start_at: normalizeStreamingDateForSubmit(formatStreamingDateForForm(streaming.scheduled_start_at)),
        position: Number(streaming.position),
        json: streaming.json || {},
        links: normalizeStreamingLinksForForm(streaming.links),
        user_id: streaming.user_id || null,
    });

    const updateStreamingStatus = async ({ streaming, status, successMessage, errorFallback }) => {
        setLoading(true);
        try {
            const response = await axios.put(
                '/api/event/plataformaEventos/schedule-streaming',
                buildStreamingStatusPayload(streaming, status)
            );
            updateStoredStreamings({
                ...streaming,
                ...(response.data?.streaming || {}),
                status,
            });
            setDataTableUpdate((prevCount) => prevCount + 1);
            notyf.open({
                type: 'success',
                message: successMessage,
                ripple: true,
                dismissible: true,
            });
        } catch (error) {
            notyf.open({
                type: 'danger',
                message: error.response?.data?.message || errorFallback,
                ripple: true,
                dismissible: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const confirmStreamingStatusChange = ({ streaming, event, status, title, description, successMessage, errorFallback }) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!isPersistedStreamingId(streaming?.id)) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title={title}
                    description={description}
                    action={async () => {
                        try {
                            await updateStreamingStatus({ streaming, status, successMessage, errorFallback });
                        } finally {
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const startStreamingInline = (streaming, event) => confirmStreamingStatusChange({
        streaming,
        event,
        status: 1,
        title: 'Iniciar transmissão',
        description: 'Deseja iniciar esta transmissão?',
        successMessage: 'Transmissão iniciada com sucesso',
        errorFallback: 'Houve um erro ao iniciar a transmissão',
    });

    const endStreamingInline = (streaming, event) => confirmStreamingStatusChange({
        streaming,
        event,
        status: 2,
        title: 'Encerrar transmissão',
        description: 'Deseja encerrar esta transmissão?',
        successMessage: 'Transmissão encerrada com sucesso',
        errorFallback: 'Houve um erro ao encerrar a transmissão',
    });

    const resetStreaming = (streaming) => {
        if (!isPersistedStreamingId(streaming?.id) || Number(streaming?.status) !== 2) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Resetar transmissão"
                    description={STREAMING_RESET_CONFIRMATION_MESSAGE}
                    action={async () => {
                        setLoading(true);
                        try {
                            const response = await axios.post('/api/event/plataformaEventos/schedule-streaming/reset', {
                                event_id: dataTable.event_id,
                                streaming_id: Number(streaming.id),
                            });
                            updateStoredStreamings({
                                ...streaming,
                                status: 0,
                                scheduled_start_at: response.data?.new_stream_run?.scheduled_start_at || streaming.scheduled_start_at,
                                started_at: null,
                                ended_at: null,
                                peak_viewers: 0,
                            });
                            setDataTableUpdate((prevCount) => prevCount + 1);
                            notyf.open({
                                type: 'success',
                                message: 'Transmissão resetada. A nova execução está pronta para iniciar.',
                                ripple: true,
                                dismissible: true,
                            });
                        } catch (error) {
                            notyf.open({
                                type: 'danger',
                                message: error.response?.data?.message || 'Houve um erro ao resetar a transmissão',
                                ripple: true,
                                dismissible: true,
                            });
                        } finally {
                            setLoading(false);
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const submitStreaming = async (values, actions) => {
        setLoading(true);
        try {
            const persistedId = isPersistedStreamingId(values.id);
            const normalizedLinks = normalizeStreamingLinksForForm(values.links);
            const targetScheduleId = Number(values.schedule_id || scheduleId || 0);
            const nextPosition = !persistedId && isGlobalEditor
                ? availableStreamings.filter((streaming) => Number(streaming.schedule_id) === targetScheduleId).length + 1
                : Number(values.position || currentPosition);

            if (isGlobalEditor) {
                const payload = buildScheduleStreamingPayload({
                    ...values,
                    schedule_id: targetScheduleId,
                    position: nextPosition,
                    links: normalizedLinks
                }, dataTable.event_id, targetScheduleId, nextPosition);
                await (persistedId
                    ? axios.put('/api/event/plataformaEventos/schedule-streaming', payload)
                    : axios.post('/api/event/plataformaEventos/schedule-streaming', payload));

                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: persistedId ? 'Transmissão atualizada com sucesso' : 'Transmissão criada com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                actions.setSubmitting(false);
                closeModal();
                return;
            }

            const localStreaming = {
                id: persistedId ? Number(values.id) : (values.id || createDraftStreamingId()),
                schedule_id: values.schedule_id || scheduleId || '',
                title: values.title,
                description: values.description || '',
                status: Number(values.status || 0),
                chat_enabled: Number(values.chat_enabled ?? 1),
                preview_image: values.preview_image || '',
                scheduled_start_at: values.scheduled_start_at,
                position: Number(values.position || currentPosition),
                json: values.json || {},
                links: normalizedLinks,
                links_count: normalizedLinks.length,
                user_id: values.user_id || null,
                is_draft: !persistedId
            };

            updateStoredStreamings(localStreaming);
            notyf.open({
                type: "success",
                message: values.id ? 'Transmissão atualizada. Salve o evento da agenda para aplicar.' : 'Transmissão adicionada. Salve o evento da agenda para aplicar.',
                ripple: true,
                dismissible: true,
            });
            actions.setSubmitting(false);
            closeModal();
        } catch (error) {
            actions.setSubmitting(false);
            notyf.open({
                type: "danger",
                message: error.response?.data?.message || 'Houve um erro ao preparar a transmissão',
                ripple: true,
                dismissible: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const removeStreaming = (streamingId) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Confirmar ação"
                    description="Deseja excluir esta transmissão?"
                    action={async () => {
                        setLoading(true);
                        try {
                            if (isGlobalEditor && isPersistedStreamingId(streamingId)) {
                                await axios.delete('/api/event/plataformaEventos/schedule-streaming', {
                                    data: {
                                        event_id: dataTable.event_id,
                                        id: Number(streamingId)
                                    }
                                });
                                setDataTableUpdate((prevCount) => prevCount + 1);
                                notyf.open({
                                    type: "success",
                                    message: 'Transmissão excluída com sucesso',
                                    ripple: true,
                                    dismissible: true,
                                });
                                closeModal();
                                return;
                            }

                            setDataAddForm((prevState) => {
                                const deleted = isPersistedStreamingId(streamingId)
                                    ? [...(prevState.deletedScheduleStreamings || []), Number(streamingId)]
                                    : (prevState.deletedScheduleStreamings || []);
                                return {
                                    ...prevState,
                                    deletedScheduleStreamings: deleted,
                                    scheduleStreamings: (prevState.scheduleStreamings || [])
                                        .filter((item) => String(item.id) !== String(streamingId))
                                        .map((item, index) => ({ ...item, position: index + 1 })),
                                    streamingChannelData: false
                                };
                            });
                            notyf.open({
                                type: "success",
                                message: 'Transmissão removida. Salve o evento da agenda para aplicar.',
                                ripple: true,
                                dismissible: true,
                            });
                            closeModal();
                        } catch (error) {
                            notyf.open({
                                type: "danger",
                                message: error.response?.data?.message || 'Houve um erro ao preparar a remoção da transmissão',
                                ripple: true,
                                dismissible: true,
                            });
                        } finally {
                            setLoading(false);
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const openReportModal = (streaming) => {
        if (!streaming?.id) return;
        setDataAddForm((prevState) => ({
            ...prevState,
            streamingReportData: streaming,
            streamingReportEditorMode: isGlobalEditor ? 'global' : 'schedule'
        }));
        setModal((prevState) => ({
            ...prevState,
            showStreamingReportModal: true
        }));
    };

    const reorderLinks = (links, fromIndex, toIndex, setFieldValue) => {
        if (fromIndex === null || fromIndex === toIndex) return;
        const nextLinks = [...links];
        const [draggedLink] = nextLinks.splice(fromIndex, 1);
        nextLinks.splice(toIndex, 0, draggedLink);
        setDraggedLinkIndex(toIndex);
        setFieldValue('links', nextLinks.map((link, index) => ({ ...link, position: index + 1 })));
    };

    return (
        <Modal
            show={modal.showStreamingChannelForm}
            size="lg"
            onHide={closeModal}
            fullscreen
            centered
            backdrop="static"
            className="schedule-streaming-channel-form-modal"
            style={{ zIndex: 1062 }}
            backdropClassName="nested-modal-backdrop-lv2"
        >
            <Formik
                enableReinitialize
                onSubmit={submitStreaming}
                validationSchema={validationSchema}
                validateOnChange={false}
                validateOnBlur={true}
                initialValues={normalizeStreamingChannelForForm(currentChannel, scheduleId, currentPosition)}
            >
                {({
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    errors,
                    isSubmitting,
                    setFieldValue,
                    setTouched,
                    submitCount,
                    submitForm,
                    validateForm,
                }) => {
                    const hasPersistedId = isPersistedStreamingId(currentChannel?.id);
                    const persistedStatus = hasPersistedId ? Number(currentChannel.status ?? 0) : null;
                    const isScheduled = hasPersistedId && persistedStatus === 0;
                    const isLive = persistedStatus === 1;
                    const isClosed = persistedStatus === 2;
                    const fieldsLocked = isClosed;
                    const canSave = !isClosed;
                    const statusBadge = getScheduleStreamingStatusBadge(values.status, dataTable);
                    const links = normalizeStreamingLinksForForm(values.links);
                    const showFieldError = (field) => Boolean(errors[field] && (touched[field] || submitCount > 0));
                    const showLinkFieldError = (index, field) => Boolean(
                        getStreamingLinkFieldError(errors, index, field)
                        && (submitCount > 0 || getStreamingLinkTouched(touched, index, field))
                    );
                    const showLinkRowError = (index) => Boolean(getStreamingLinkRowError(errors, index) && (submitCount > 0 || touched.links));
                    const updateScheduledStartAt = (value) => {
                        setFieldValue('scheduled_start_at', value);
                        setFieldValue('status', getStreamingStatusFromStartDate(value));
                    };
                    const handleStreamingSubmit = async (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        const formErrors = await validateForm();

                        if (Object.keys(formErrors).length > 0) {
                            setTouched(getStreamingTouchedFields(links), false);
                            notyf.open({
                                type: "danger",
                                message: getFirstStreamingValidationMessage(formErrors),
                                ripple: true,
                                dismissible: true,
                            });
                            return;
                        }

                        submitForm();
                    };
                    const updateLink = (index, field, value) => {
                        setFieldValue('links', links.map((link, linkIndex) => (
                            linkIndex === index ? { ...link, [field]: value } : link
                        )));
                    };
                    const updateLinkJson = (index, field, value) => {
                        setFieldValue('links', links.map((link, linkIndex) => (
                            linkIndex === index
                                ? { ...link, json: { ...(link.json || {}), [field]: value } }
                                : link
                        )));
                    };
                    const addLink = () => {
                        setFieldValue('links', [
                            ...links,
                            {
                                title: `Link ${links.length + 1}`,
                                url: '',
                                provider: '',
                                embed_url: '',
                                position: links.length + 1,
                                status: 1,
                                json: {
                                    use_embed_url: 0
                                }
                            }
                        ]);
                    };
                    const removeLink = (index) => {
                        if (links.length <= 1) return;
                        setFieldValue('links', links.filter((_, linkIndex) => linkIndex !== index).map((link, linkIndex) => ({ ...link, position: linkIndex + 1 })));
                    };
                    return (
                        <Form noValidate onSubmit={handleStreamingSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{values.id ? 'Editar transmissão' : 'Adicionar transmissão'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Título</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={values.title}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={showFieldError('title')}
                                            isValid={touched.title && !errors.title}
                                            maxLength={150}
                                            disabled={fieldsLocked}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
                                    </Form.Group>
                                    {isGlobalEditor && (
                                        <Form.Group as={Col} md={12} className="mb-3">
                                            <Form.Label>Evento da agenda</Form.Label>
                                            <Select
                                                options={scheduleOptions}
                                                value={scheduleOptions.find((option) => Number(option.value) === Number(values.schedule_id)) || null}
                                                onChange={(option) => setFieldValue('schedule_id', option?.value || '')}
                                                placeholder="Selecione o evento da agenda"
                                                noOptionsMessage={() => 'Nenhum evento da agenda disponível'}
                                                isDisabled={hasPersistedId || fieldsLocked}
                                                formatOptionLabel={(option) => (
                                                    <div>
                                                        <div>{option.label}</div>
                                                        {option.startDate && <small className="text-muted">{option.startDate}</small>}
                                                    </div>
                                                )}
                                            />
                                            {showFieldError('schedule_id') && (
                                                <div className="invalid-feedback d-block">{errors.schedule_id}</div>
                                            )}
                                        </Form.Group>
                                    )}
                                    <Form.Group as={Col} md={12} className="mb-3">
                                        <Form.Label>Usuário responsável</Form.Label>
                                        <Select
                                            options={responsibleUserOptions}
                                            value={responsibleUserOptions.find((option) => Number(option.value) === Number(values.user_id)) || null}
                                            onChange={(opt) => setFieldValue('user_id', opt?.value ? Number(opt.value) : null)}
                                            isClearable
                                            placeholder="Selecione um usuário"
                                            noOptionsMessage={() => 'Nenhum usuário disponível'}
                                            isDisabled={fieldsLocked}
                                        />
                                        {errors.user_id && (touched.user_id || submitCount > 0) && (
                                            <div className="invalid-feedback d-block">{errors.user_id}</div>
                                        )}
                                    </Form.Group>
                                    {isPersistedStreamingId(values.id) && (
                                        <Form.Group className="col-auto mb-3">
                                            <Form.Label>Status</Form.Label>
                                            <div>
                                                <Badge bg={statusBadge.bg} style={statusBadge.style} className={statusBadge.className}>
                                                    {statusBadge.label}
                                                </Badge>
                                            </div>
                                        </Form.Group>
                                    )}
                                    <Form.Group as={Col} md={4} className="mb-3">
                                        <Form.Label>Data de início</Form.Label>
                                        <Datetime
                                            value={values.scheduled_start_at || ''}
                                            onChange={(date) => {
                                                if (date && typeof date.format === 'function') {
                                                    updateScheduledStartAt(date.format('DD/MM/YYYY HH:mm'));
                                                } else {
                                                    updateScheduledStartAt('');
                                                }
                                            }}
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="HH:mm"
                                            inputProps={{
                                                placeholder: 'dd/mm/aaaa hh:mm',
                                                className: 'form-control'
                                            }}
                                            locale="pt-br"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={12} className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="description"
                                            value={values.description || ''}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={showFieldError('description')}
                                            maxLength={500}
                                            style={{ height: 90 }}
                                            disabled={fieldsLocked}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} sm={12} className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="schedule-streaming-chat-enabled"
                                            label="Chat disponível para usuários"
                                            checked={Number(values.chat_enabled ?? 1) === 1}
                                            onChange={(event) => setFieldValue('chat_enabled', event.target.checked ? 1 : 0)}
                                            disabled={fieldsLocked}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={12} className="mb-3">
                                        <Form.Label>Imagem de preview</Form.Label>
                                        <Card>
                                            <Card.Body>
                                                <Form.Control
                                                    type="hidden"
                                                    name="preview_image"
                                                    value={values.preview_image || ''}
                                                />
                                                <div className="imagesUpload">
                                                    <img
                                                        className="h-100 img-thumbnail"
                                                        src={getStreamingPreviewUrl(dataTable.event_id, values.preview_image)}
                                                        alt="Preview"
                                                        style={{ maxHeight: 220, objectFit: 'contain' }}
                                                        onError={(event) => {
                                                            const fallbackUrl = getStreamingPreviewFallbackUrl();
                                                            if (event.currentTarget.src !== fallbackUrl) {
                                                                event.currentTarget.src = fallbackUrl;
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {!fieldsLocked && (
                                                    <DropzoneComponent
                                                        className="mt-3 dropzoneComp"
                                                        type="image"
                                                        handlePreviewSuccess={handlePreviewSuccess}
                                                        handlePreviewError={handlePreviewError}
                                                        setFieldValue={setFieldValue}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                        field="preview_image"
                                                    />
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Form.Group>
                                    <Col sm={12} className="mb-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="fw-bold mb-0">Links da transmissão</h6>
                                                <small className="opacity-75">{fieldsLocked ? 'Links bloqueados pelo status atual.' : 'Arraste os links para definir a prioridade de exibição.'}</small>
                                            </div>
                                            <Button type="button" size="sm" onClick={addLink} disabled={fieldsLocked}>
                                                <FontAwesomeIcon icon={faPlus} />
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col sm={12}>
                                        {typeof errors.links === 'string' && (
                                            <div className="invalid-feedback d-block mb-2">{errors.links}</div>
                                        )}
                                        {links.map((link, index) => {
                                            const useEmbedUrl = Number(link.json?.use_embed_url || 0) === 1;
                                            const modeHelp = getStreamingLinkModeHelp(useEmbedUrl);
                                            const providerHelp = getStreamingLinkProviderHelp(link.provider);

                                            return (
                                            <Card
                                                key={`streaming-link-row-${index}`}
                                                className="mb-3 bg-transparent border rounded shadow-none"
                                                draggable={!fieldsLocked}
                                                onDragStart={() => {
                                                    if (!fieldsLocked) setDraggedLinkIndex(index);
                                                }}
                                                onDragOver={(event) => {
                                                    if (fieldsLocked) return;
                                                    event.preventDefault();
                                                    reorderLinks(links, draggedLinkIndex, index, setFieldValue);
                                                }}
                                                onDragEnd={() => setDraggedLinkIndex(null)}
                                            >
                                                <Card.Body>
                                                    {showLinkRowError(index) && (
                                                        <div className="invalid-feedback d-block mb-3">
                                                            {getStreamingLinkRowError(errors, index)}
                                                        </div>
                                                    )}
                                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
                                                        <div className="d-flex align-items-center gap-2 min-w-0">
                                                            <FontAwesomeIcon icon={faArrowsAlt} className="opacity-75" />
                                                            <strong className="text-truncate">{link.title || `Link ${index + 1}`}</strong>
                                                        </div>
                                                        <Button
                                                            type="button"
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => removeLink(index)}
                                                            disabled={fieldsLocked || links.length <= 1}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </Button>
                                                    </div>
                                                     <Form.Check
                                                         type="checkbox"
                                                         label={(
                                                             <span>
                                                                 Usar URL de embed/iframe
                                                                 <OverlayTrigger
                                                                     overlay={
                                                                         <Tooltip>
                                                                             {modeHelp.tooltip}
                                                                         </Tooltip>
                                                                     }
                                                                 >
                                                                     <HelpTooltip icon={faExclamationCircle} />
                                                                 </OverlayTrigger>
                                                             </span>
                                                         )}
                                                         checked={useEmbedUrl}
                                                         onChange={(event) => {
                                                             updateLinkJson(index, 'use_embed_url', event.target.checked ? 1 : 0);
                                                         }}
                                                         disabled={fieldsLocked}
                                                     />
                                                     <Form.Text className="text-muted d-block mb-3">
                                                         Exemplo: {modeHelp.example}
                                                     </Form.Text>
                                                     <Row>
                                                         <Form.Group as={Col} md={useEmbedUrl ? 9 : 5} className="mb-3">
                                                            <Form.Label>Título do link</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name={`links.${index}.title`}
                                                                value={link.title || ''}
                                                                onChange={(event) => updateLink(index, 'title', event.target.value)}
                                                                onBlur={handleBlur}
                                                                isInvalid={showLinkFieldError(index, 'title')}
                                                                maxLength={120}
                                                                disabled={fieldsLocked}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {getStreamingLinkFieldError(errors, index, 'title')}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                         {!useEmbedUrl && (
                                                             <Form.Group as={Col} md={4} className="mb-3">
                                                                 <Form.Label>
                                                                     Provider
                                                                     <OverlayTrigger
                                                                         overlay={
                                                                             <Tooltip>
                                                                                 {providerHelp.tooltip}
                                                                             </Tooltip>
                                                                         }
                                                                     >
                                                                         <HelpTooltip icon={faExclamationCircle} />
                                                                     </OverlayTrigger>
                                                                 </Form.Label>
                                                                <Form.Select
                                                                    name={`links.${index}.provider`}
                                                                    value={link.provider || ''}
                                                                    onChange={(event) => updateLink(index, 'provider', event.target.value)}
                                                                    onBlur={handleBlur}
                                                                    isInvalid={showLinkFieldError(index, 'provider')}
                                                                    disabled={fieldsLocked}
                                                                >
                                                                    {STREAMING_LINK_PROVIDERS.map((provider) => (
                                                                        <option key={`streaming-provider-${provider.value || 'auto'}`} value={provider.value}>{provider.label}</option>
                                                                    ))}
                                                                </Form.Select>
                                                                 <Form.Control.Feedback type="invalid">
                                                                     {getStreamingLinkFieldError(errors, index, 'provider')}
                                                                 </Form.Control.Feedback>
                                                              </Form.Group>
                                                         )}
                                                        <Form.Group as={Col} md={3} className="mb-3">
                                                            <Form.Label>Status</Form.Label>
                                                            <Form.Select
                                                                name={`links.${index}.status`}
                                                                value={link.status ?? 1}
                                                                onChange={(event) => updateLink(index, 'status', Number(event.target.value))}
                                                                onBlur={handleBlur}
                                                                isInvalid={showLinkFieldError(index, 'status')}
                                                                disabled={fieldsLocked}
                                                            >
                                                                <option value={1}>Ativo</option>
                                                                <option value={0}>Inativo</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                {getStreamingLinkFieldError(errors, index, 'status')}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                         {!useEmbedUrl && (
                                                             <Form.Group as={Col} md={12} className="mb-3">
                                                                 <Form.Label>
                                                                     URL
                                                                     <OverlayTrigger
                                                                         overlay={
                                                                             <Tooltip>
                                                                                 {providerHelp.tooltip}
                                                                             </Tooltip>
                                                                         }
                                                                     >
                                                                         <HelpTooltip icon={faExclamationCircle} />
                                                                     </OverlayTrigger>
                                                                 </Form.Label>
                                                                <Form.Control
                                                                    type="url"
                                                                    name={`links.${index}.url`}
                                                                    value={link.url || ''}
                                                                    onChange={(event) => updateLink(index, 'url', event.target.value)}
                                                                    onBlur={handleBlur}
                                                                    isInvalid={showLinkFieldError(index, 'url')}
                                                                    disabled={fieldsLocked}
                                                                />
                                                                 <Form.Control.Feedback type="invalid">
                                                                     {getStreamingLinkFieldError(errors, index, 'url')}
                                                                 </Form.Control.Feedback>
                                                                 <Form.Text className="text-muted">
                                                                     {modeHelp.description}
                                                                 </Form.Text>
                                                             </Form.Group>
                                                         )}
                                                         {useEmbedUrl && (
                                                             <Form.Group as={Col} md={12} className="mb-3">
                                                                 <Form.Label>
                                                                     URL de embed/iframe
                                                                     <OverlayTrigger
                                                                         overlay={
                                                                             <Tooltip>
                                                                                 {modeHelp.tooltip}
                                                                             </Tooltip>
                                                                         }
                                                                     >
                                                                         <HelpTooltip icon={faExclamationCircle} />
                                                                     </OverlayTrigger>
                                                                 </Form.Label>
                                                                <Form.Control
                                                                    type="url"
                                                                    name={`links.${index}.embed_url`}
                                                                    value={link.embed_url || ''}
                                                                    onChange={(event) => updateLink(index, 'embed_url', event.target.value)}
                                                                    onBlur={handleBlur}
                                                                    isInvalid={showLinkFieldError(index, 'embed_url')}
                                                                    disabled={fieldsLocked}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {getStreamingLinkFieldError(errors, index, 'embed_url')}
                                                                </Form.Control.Feedback>
                                                                  <Form.Text className="text-muted">{modeHelp.description}</Form.Text>
                                                             </Form.Group>
                                                         )}
                                                     </Row>
                                                </Card.Body>
                                             </Card>
                                            );
                                        })}
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {values.id && (
                                    <Button
                                        variant="danger"
                                        type="button"
                                        className="me-2"
                                        onClick={() => removeStreaming(values.id)}
                                    >
                                        Excluir
                                    </Button>
                                )}
                                {isScheduled && (
                                    <Button
                                        variant="success"
                                        type="button"
                                        className="me-2"
                                        onClick={(e) => startStreamingInline(values, e)}
                                    >
                                        Iniciar
                                    </Button>
                                )}
                                {isLive && (
                                    <Button
                                        variant="danger"
                                        type="button"
                                        className="me-2"
                                        onClick={(e) => endStreamingInline(values, e)}
                                    >
                                        Encerrar
                                    </Button>
                                )}
                                {isClosed && (
                                    <Button
                                        variant="danger"
                                        type="button"
                                        className="me-2"
                                        onClick={() => resetStreaming(values)}
                                    >
                                        Resetar transmissão
                                    </Button>
                                )}
                                {isPersistedStreamingId(values.id) && (
                                    <Button
                                        variant="primary"
                                        type="button"
                                        className="me-2"
                                        onClick={() => openReportModal(values)}
                                    >
                                        Ver relatórios
                                    </Button>
                                )}
                                {canSave && (
                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        Salvar
                                    </Button>
                                )}
                            </Modal.Footer>
                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
};

export const ScheduleStreamingReportModal = ({ modal, setModal, dataTable, dataAddForm, setDataAddForm, setDataTableUpdate, isStreamingLoadTestInProgress = false, streamingLoadTestRefreshKey = 0, setShowStreamingLoadTestModal, canManage = true, returnToStreamingEditorOnClose = false }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading: setGlobalLoading } = useLayout();
    const selectedStream = dataAddForm.streamingReportData || {};
    const selectedStreamId = selectedStream?.id;
    const requestRef = useRef(null);
    const requestSequenceRef = useRef(0);
    const globalRefreshPendingRef = useRef(false);
    const globalRefreshRequestIdRef = useRef(null);
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [lastSuccessfulFetchAt, setLastSuccessfulFetchAt] = useState(null);
    const [reloadKey, setReloadKey] = useState(0);
    const [selectedStreamRunId, setSelectedStreamRunId] = useState('');
    const [activityPage, setActivityPage] = useState(1);
    const [activitySearch, setActivitySearch] = useState('');
    const [showActivityHelpModal, setShowActivityHelpModal] = useState(false);
    const [generatingPdf, setGeneratingPdf] = useState(false);
    const [connectedParticipants, setConnectedParticipants] = useState([]);
    const [connectedParticipantsLoading, setConnectedParticipantsLoading] = useState(false);
    const [connectedParticipantsError, setConnectedParticipantsError] = useState('');
    const [connectedParticipantFields, setConnectedParticipantFields] = useState([]);
    const [triggerConnectedParticipantsExport, setTriggerConnectedParticipantsExport] = useState(false);
    const [showConnectedParticipantInformation, setShowConnectedParticipantInformation] = useState(false);

    const closeModal = useCallback(() => {
        requestSequenceRef.current += 1;
        requestRef.current?.cancel('stream-report-close');
        requestRef.current = null;
        if (globalRefreshPendingRef.current || globalRefreshRequestIdRef.current !== null) {
            globalRefreshPendingRef.current = false;
            globalRefreshRequestIdRef.current = null;
            setGlobalLoading(false);
        }
        const returnToEditor = returnToStreamingEditorOnClose && canManage && Boolean(selectedStreamId);
        setModal((current) => ({
            ...current,
            showStreamingReportModal: false,
            ...(returnToEditor ? { showStreamingChannelForm: true } : {})
        }));
        setDataAddForm((current) => {
            const shouldLoadSelectedStream = returnToEditor && !modal.showStreamingChannelForm;
            return {
                ...current,
                streamingReportData: false,
                streamingReportEditorMode: false,
                ...(shouldLoadSelectedStream ? {
                    streamingChannelData: selectedStream,
                    streamingEditorMode: current.streamingReportEditorMode || current.streamingEditorMode || 'global'
                } : {})
            };
        });
        setReport(null);
        setError('');
        setLastSuccessfulFetchAt(null);
        setSelectedStreamRunId('');
        setActivityPage(1);
        setActivitySearch('');
        setShowActivityHelpModal(false);
        setConnectedParticipants([]);
        setConnectedParticipantsError('');
        setConnectedParticipantsLoading(false);
        setTriggerConnectedParticipantsExport(false);
        setShowConnectedParticipantInformation(false);
    }, [canManage, modal.showStreamingChannelForm, returnToStreamingEditorOnClose, selectedStream, selectedStreamId, setDataAddForm, setGlobalLoading, setModal]);

    useEffect(() => {
        setSelectedStreamRunId('');
        setReport(null);
        setLastSuccessfulFetchAt(null);
        setError('');
    }, [selectedStreamId]);

    useEffect(() => {
        if (!modal.showStreamingReportModal || !selectedStreamId || !dataTable?.event_id) {
            if (globalRefreshPendingRef.current) {
                globalRefreshPendingRef.current = false;
                setGlobalLoading(false);
            }
            return undefined;
        }
        requestRef.current?.cancel('stream-report-reload');
        const source = axios.CancelToken.source();
        const requestId = requestSequenceRef.current + 1;
        requestSequenceRef.current = requestId;
        requestRef.current = source;
        const ownsGlobalLoader = globalRefreshPendingRef.current;
        globalRefreshPendingRef.current = false;
        if (ownsGlobalLoader) {
            globalRefreshRequestIdRef.current = requestId;
        }
        const isCurrentRequest = () => shouldCommitStreamingReportRequest({
            activeRequestId: requestSequenceRef.current,
            requestId,
            activeRequestSource: requestRef.current,
            requestSource: source,
        });
        const releaseGlobalLoader = () => {
            if (ownsGlobalLoader && globalRefreshRequestIdRef.current === requestId) {
                globalRefreshRequestIdRef.current = null;
                setGlobalLoading(false);
            }
        };
        setLoading(true);
        setError('');
        setActivityPage(1);
        setActivitySearch('');
        setConnectedParticipants([]);
        setConnectedParticipantsError('');
        setConnectedParticipantsLoading(true);
        setTriggerConnectedParticipantsExport(false);
        axios.get('/api/event/plataformaEventos/schedule-streaming/report', {
            params: {
                event_id: dataTable.event_id,
                streaming_id: selectedStreamId,
                ...(selectedStreamRunId ? { stream_run_id: selectedStreamRunId } : {}),
            },
            cancelToken: source.token,
        }).then((response) => {
            if (!isCurrentRequest()) return;
            const responseData = response.data || {};
            if (responseData.success === false) {
                setError(responseData.message || 'Não foi possível carregar o relatório da transmissão.');
                setConnectedParticipantsLoading(false);
                return;
            }
            const nextReport = responseData.report || null;
            if (!nextReport) {
                setError('O relatório retornou sem dados válidos. Tente atualizar novamente.');
                setConnectedParticipantsLoading(false);
                return;
            }
            setReport(nextReport);
            setLastSuccessfulFetchAt(nextReport?.data_quality?.fetched_at || new Date().toISOString());
            const defaultStreamRunId = String(nextReport?.run_selection?.selected_stream_run_id || '');
            const participantStreamRunId = selectedStreamRunId || defaultStreamRunId;
            const participantRangeStart = nextReport?.range?.start || null;
            const participantRangeEnd = nextReport?.range?.end || null;
            if (!participantRangeStart || !participantRangeEnd) {
                setConnectedParticipantsError('O período do relatório não está disponível para a lista de participantes.');
                setConnectedParticipantsLoading(false);
                return;
            }
            if (!participantStreamRunId) {
                setConnectedParticipantsError('A execução do relatório não está disponível para a lista de participantes.');
                setConnectedParticipantsLoading(false);
                return;
            }
            return axios.get(`/api/event/participants/${dataTable.event_id}`, {
                params: {
                    platform: 2,
                    streaming_id: selectedStreamId,
                    stream_run_id: participantStreamRunId,
                    start_at: participantRangeStart,
                    end_at: participantRangeEnd,
                },
                cancelToken: source.token,
            }).then((participantResponse) => {
                if (!isCurrentRequest()) return;
                const rows = Array.isArray(participantResponse.data?.participants) ? participantResponse.data.participants : [];
                const participantIds = new Set();
                setConnectedParticipants(rows.filter((participant) => {
                    if (Number(participant?.type) !== 0 || !participant?.user_id) return false;
                    const userId = String(participant.user_id);
                    if (participantIds.has(userId)) return false;
                    participantIds.add(userId);
                    return true;
                }));
            }).catch((participantError) => {
                if (axios.isCancel(participantError) || !isCurrentRequest()) return;
                setConnectedParticipantsError(
                    participantError.response?.data?.message || 'Não foi possível carregar a lista de participantes conectados.'
                );
            }).finally(() => {
                if (isCurrentRequest()) {
                    setConnectedParticipantsLoading(false);
                }
            });
        }).catch((err) => {
            if (axios.isCancel(err) || !isCurrentRequest()) return;
            setError(err?.response?.data?.message || 'Houve um erro ao carregar o relatório da transmissão.');
            setConnectedParticipantsLoading(false);
        }).finally(() => {
            if (isCurrentRequest()) {
                setLoading(false);
                releaseGlobalLoader();
            }
        });

        return () => {
            source.cancel('stream-report-unmount');
            if (isCurrentRequest()) {
                requestRef.current = null;
                releaseGlobalLoader();
            }
        };
    }, [dataTable?.event_id, modal.showStreamingReportModal, reloadKey, selectedStreamId, selectedStreamRunId, setGlobalLoading, streamingLoadTestRefreshKey]);

    const refreshReport = () => {
        if (loading) return;
        globalRefreshPendingRef.current = true;
        setGlobalLoading(true);
        setReloadKey((current) => current + 1);
    };

    useEffect(() => {
        if (!dataTable?.json?.form?.fields) {
            setConnectedParticipantFields([]);
            return;
        }

        setHeaders02(
            dataTable,
            (fields) => {
                const visibleFields = fields.filter((field) => field.accessor !== 'icons');
                const includesEmail = visibleFields.some((field) => field.accessor === 'email');
                setConnectedParticipantFields([
                    ...(includesEmail ? [] : [{
                        Header: dataTable.json.form.emailLabel || 'E-mail',
                        accessor: 'email',
                    }]),
                    ...visibleFields,
                    ...(showConnectedParticipantInformation ? getStreamingConnectedParticipantInformationFields() : []),
                ]);
            },
            () => {},
            () => {},
            STREAMING_CONNECTED_PARTICIPANT_FILTER,
            () => {},
            false,
            () => {},
        );
    }, [dataTable, showConnectedParticipantInformation]);

    const reportBelongsToStream = Boolean(report && Number(report.stream?.id) === Number(selectedStreamId));
    const runSelection = reportBelongsToStream ? (report.run_selection || {}) : {};
    const reportMatchesSelection = reportBelongsToStream
        && (!selectedStreamRunId || String(runSelection.selected_stream_run_id || '') === selectedStreamRunId);
    const stream = reportBelongsToStream ? report.stream : (selectedStream || {});
    const streamRuns = Array.isArray(runSelection.runs) ? runSelection.runs : [];
    const activeSelectedStreamRunId = selectedStreamRunId || String(runSelection.selected_stream_run_id || '');
    const selectedStreamRun = streamRuns.find((run) => String(run?.stream_run_id || '') === activeSelectedStreamRunId) || null;
    const streamConfigurationStatus = Number(runSelection.stream_status ?? selectedStream?.status);
    const streamIsLive = streamConfigurationStatus === 1
        || String(stream?.status || '').toLowerCase() === 'live';
    const canEndStreaming = canManage
        && reportMatchesSelection
        && streamIsLive
        && String(selectedStreamRun?.run_status || '').toLowerCase() === 'live';
    const canResetStreaming = canManage && streamConfigurationStatus === 2;
    const canDeleteSelectedRun = canManage
        && Boolean(selectedStreamRun?.stream_run_id)
        && String(selectedStreamRun?.run_status || '').toLowerCase() === 'closed';
    const latestStreamRun = streamRuns[0] || null;
    const canDeleteStreaming = canDeleteSelectedRun
        && !streamIsLive
        && String(latestStreamRun?.run_status || '').toLowerCase() !== 'live';

    const endStreaming = () => {
        if (!canEndStreaming || loading || !selectedStreamId) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Encerrar transmissão"
                    description="Deseja encerrar esta transmissão?"
                    action={async () => {
                        setLoading(true);
                        try {
                            const payload = {
                                event_id: dataTable.event_id,
                                id: selectedStream.id,
                                schedule_id: selectedStream.schedule_id,
                                title: selectedStream.title,
                                description: selectedStream.description || '',
                                status: 2,
                                chat_enabled: Number(selectedStream.chat_enabled ?? 1),
                                preview_image: selectedStream.preview_image || '',
                                scheduled_start_at: normalizeStreamingDateForSubmit(formatStreamingDateForForm(selectedStream.scheduled_start_at)),
                                position: Number(selectedStream.position),
                                json: selectedStream.json || {},
                                links: normalizeStreamingLinksForForm(selectedStream.links),
                                user_id: selectedStream.user_id || null,
                            };
                            const response = await axios.put('/api/event/plataformaEventos/schedule-streaming', payload);
                            const updatedStreaming = {
                                ...selectedStream,
                                ...(response.data?.streaming || {}),
                                status: 2,
                            };
                            setDataAddForm((current) => ({
                                ...current,
                                streamingReportData: updatedStreaming,
                            }));
                            setDataTableUpdate((current) => current + 1);
                            setReport(null);
                            setLastSuccessfulFetchAt(null);
                            setReloadKey((current) => current + 1);
                            notyf.open({
                                type: 'success',
                                message: 'Transmissão encerrada com sucesso',
                                ripple: true,
                                dismissible: true,
                            });
                        } catch (requestError) {
                            notyf.open({
                                type: 'danger',
                                message: requestError.response?.data?.message || 'Houve um erro ao encerrar a transmissão',
                                ripple: true,
                                dismissible: true,
                            });
                        } finally {
                            setLoading(false);
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const resetStreaming = () => {
        if (!canResetStreaming || !selectedStreamId) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Resetar transmissão"
                    description={STREAMING_RESET_CONFIRMATION_MESSAGE}
                    action={async () => {
                        setLoading(true);
                        try {
                            const response = await axios.post('/api/event/plataformaEventos/schedule-streaming/reset', {
                                event_id: dataTable.event_id,
                                streaming_id: Number(selectedStreamId),
                            });
                            const nextStreamRunId = String(response.data?.new_stream_run?.stream_run_id || '');
                            setSelectedStreamRunId(nextStreamRunId);
                            setReport(null);
                            setLastSuccessfulFetchAt(null);
                            setDataTableUpdate((current) => current + 1);
                            setReloadKey((current) => current + 1);
                            notyf.open({
                                type: 'success',
                                message: 'Transmissão resetada. A nova execução está pronta para iniciar.',
                                ripple: true,
                                dismissible: true,
                            });
                        } catch (requestError) {
                            notyf.open({
                                type: 'danger',
                                message: requestError.response?.data?.message || 'Houve um erro ao resetar a transmissão',
                                ripple: true,
                                dismissible: true,
                            });
                        } finally {
                            setLoading(false);
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const deleteSelectedStreaming = () => {
        if (!canDeleteStreaming || !selectedStreamId) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Excluir transmissão e histórico"
                    description={STREAMING_DELETE_CONFIRMATION_MESSAGE}
                    action={async () => {
                        setLoading(true);
                        try {
                            await axios.delete('/api/event/plataformaEventos/schedule-streaming', {
                                data: {
                                    event_id: dataTable.event_id,
                                    id: Number(selectedStreamId),
                                },
                            });
                            setDataTableUpdate((current) => current + 1);
                            notyf.open({
                                type: 'success',
                                message: 'A transmissão e todo o histórico foram excluídos permanentemente.',
                                ripple: true,
                                dismissible: true,
                            });
                            closeModal();
                        } catch (requestError) {
                            notyf.open({
                                type: 'danger',
                                message: requestError.response?.data?.message || 'Houve um erro ao excluir a transmissão',
                                ripple: true,
                                dismissible: true,
                            });
                        } finally {
                            setLoading(false);
                            onClose();
                        }
                    }}
                    onClose={onClose}
                />
            ),
        });
    };
    const range = report?.range || {};
    const metrics = report?.metrics || {};
    const viewerSummary = report?.viewer_summary || {};
    const playbackObservation = report?.playback_observation || {};
    const dataQuality = report?.data_quality || {};
    const pollSummary = report?.poll_summary || {};
    const programme = report?.programme || {};
    const viewerRows = Array.isArray(report?.series?.viewer_timeline) ? report.series.viewer_timeline : [];
    const playbackRows = Array.isArray(report?.series?.playback_timeline) ? report.series.playback_timeline : [];
    const reactionRows = Array.isArray(report?.series?.reaction_video) ? report.series.reaction_video : [];
    const polls = Array.isArray(report?.polls) ? report.polls : [];
    const viewerMeasurementStatus = resolveStreamingViewerMeasurementStatus(dataQuality, viewerRows);
    const viewerSnapshotStorageUnavailable = viewerMeasurementStatus === 'unavailable';
    const viewerMeasurementMissing = viewerMeasurementStatus === 'missing';
    const viewerMeasurementZero = viewerMeasurementStatus === 'measured_zero';
    const playbackCoverageStatus = String(playbackObservation.coverage_status || 'absent').toLowerCase();
    const playbackAvailable = String(playbackObservation.status || '').toLowerCase() === 'available'
        && playbackCoverageStatus === 'complete';
    const playbackCoverageMessage = resolveStreamingPlaybackCoverageMessage(playbackCoverageStatus);
    const playbackCoverageLabel = playbackObservation.coverage_percent == null
        ? STREAMING_PLAYBACK_REPORT_COPY.coverageUnknown
        : formatStreamingReportPercent(playbackObservation.coverage_percent);
    const unfinishedPresenceSessions = streamReportNumber(dataQuality.unfinished_presence_sessions);
    const activities = (Array.isArray(report?.activity_events) ? report.activity_events : [])
        .filter((activity) => !STREAMING_REPORT_HIGH_VOLUME_ACTIVITY_TYPES.has(String(activity?.activity_type || '').toLowerCase()));
    const activityDataLimit = report?.data_limits?.activity_events || {};
    const activityResultsCapped = Boolean(activityDataLimit.truncated);
    const returnedActivityCount = streamReportNumber(activityDataLimit.returned_items);
    const totalActivityCount = streamReportNumber(activityDataLimit.total_items);
    const activityColorMap = useMemo(() => buildStreamingActivityColorMap(activities), [activities]);
    const connectedParticipantTableData = useMemo(() => {
        if (!connectedParticipants.length || !dataTable?.json?.form?.fields) return [];
        return processData02(
            dataTable,
            { participants: connectedParticipants, checkins: [] },
            STREAMING_CONNECTED_PARTICIPANT_FILTER,
            { dateRange: { startDate: null, endDate: null } },
        ).participants;
    }, [connectedParticipants, dataTable]);
    const connectedParticipantsExportStreamTitle = String(stream?.title || selectedStream?.title || 'Transmissão')
        .trim()
        .replace(/[/\\?%*:|"<>]/g, '-') || 'Transmissão';
    const connectedParticipantsExportTitle = `Relatório da transmissão - ${connectedParticipantsExportStreamTitle} - Participantes conectados`;

    const totalSessions = streamReportNumber(metrics.audience_sessions);
    const registeredSessions = streamReportNumber(metrics.registered_sessions);
    const guestSessions = streamReportNumber(metrics.guest_sessions);
    const uniqueViewers = streamReportNumber(metrics.unique_viewers);
    const registeredUniqueViewers = streamReportNumber(metrics.registered_unique_viewers);
    const guestUniqueViewers = streamReportNumber(metrics.guest_unique_viewers);
    const accessesPerUniqueViewer = streamReportNumber(metrics.accesses_per_unique_viewer);
    const chatMessages = streamReportNumber(metrics.chat_messages);
    const chatParticipants = streamReportNumber(metrics.chat_participants);
    const reactionCount = streamReportNumber(metrics.reaction_count);
    const pollVotes = streamReportNumber(metrics.poll_votes);
    const totalEngagements = reactionCount + chatMessages + pollVotes;
    const engagementsPerUniqueViewer = uniqueViewers > 0 ? totalEngagements / uniqueViewers : 0;
    const programmeStartVariance = formatStreamingReportScheduleVariance(programme.start_variance_seconds);
    const programmeEndVariance = formatStreamingReportScheduleVariance(programme.end_variance_seconds);
    const isLive = Number(stream?.status) === 1 || String(stream?.status || "").toLowerCase() === "live";

    const rangeLabel = range.start || range.end
        ? `${range.start ? formatStreamingReportDateTime(range.start) : 'Sem início'} - ${range.end ? formatStreamingReportDateTime(range.end) : 'Sem fim'}`
        : 'Sem período registrado';
    const reportFetchedAt = lastSuccessfulFetchAt || dataQuality.fetched_at || null;
    const reportFetchedAtLabel = reportFetchedAt
        ? formatStreamingReportDateTime(reportFetchedAt)
        : 'Horário não informado';
    const selectedRunLabel = selectedStreamRun
        ? `Execução ${Number(selectedStreamRun.run_sequence || 0)}`
        : 'Execução selecionada';
    const connectedParticipantsExportMetadata = buildStreamingParticipantExportMetadata({
        periodLabel: rangeLabel,
        fetchedAtLabel: reportFetchedAtLabel,
        selectedRunLabel,
    });

    const filteredActivities = useMemo(() => {
        const tokens = normalizeStreamingActivitySearchText(activitySearch).split(' ').filter(Boolean);
        if (!tokens.length) return activities;
        return activities.filter((activity) => tokens.every((token) => getStreamingActivitySearchText(activity).includes(token)));
    }, [activities, activitySearch]);

    const activityPageCount = Math.max(1, Math.ceil(filteredActivities.length / 10));
    const visibleActivities = filteredActivities.slice((activityPage - 1) * 10, activityPage * 10);

    useEffect(() => {
        if (activityPage > activityPageCount) setActivityPage(activityPageCount);
    }, [activityPage, activityPageCount]);

    const viewerChartColors = CHART_PALETTE;
    const viewerChart = useMemo(() => {
        const tooltipLabels = viewerRows.map((row) => formatStreamingReportDateTime(row.bucket_at || row.bucket_minute));
        const viewerHasMultipleDates = new Set(tooltipLabels.map((label) => label.slice(0, 10))).size > 1;

        return {
            labels: tooltipLabels.map((label) => compactStreamingReportDateTime(label, viewerHasMultipleDates)),
            tooltipLabels,
            datasets: [
                {
                    label: 'Média ponderada de conexões',
                    data: viewerRows.map((row) => streamReportMetricValue(row, 'viewer_count')),
                    borderColor: withStreamingReportColorAlpha(viewerChartColors[0], 0.96),
                    backgroundColor: withStreamingReportColorAlpha(viewerChartColors[0], 0.2),
                    tension: 0.3,
                    pointRadius: viewerRows.length < 20 ? 2 : 0,
                },
                {
                    label: 'Maior valor no intervalo',
                    data: viewerRows.map((row) => streamReportMetricValue(row, 'peak_viewer_count')),
                    borderColor: withStreamingReportColorAlpha(viewerChartColors[1], 0.85),
                    backgroundColor: withStreamingReportColorAlpha(viewerChartColors[1], 0.1),
                    borderDash: [5, 5],
                    tension: 0.3,
                    pointRadius: 0,
                },
            ],
        };
    }, [viewerRows, viewerChartColors]);

    const playbackChart = useMemo(() => {
        const tooltipLabels = playbackRows.map((row) => formatStreamingReportDateTime(row.bucket_at || row.bucket_minute));
        const playbackHasMultipleDates = new Set(tooltipLabels.map((label) => label.slice(0, 10))).size > 1;

        return {
            labels: tooltipLabels.map((label) => compactStreamingReportDateTime(label, playbackHasMultipleDates)),
            tooltipLabels,
            datasets: [
                {
                    label: STREAMING_PLAYBACK_REPORT_COPY.activeSeriesLabel,
                    data: playbackRows.map((row) => streamReportMetricValue(row, 'active_playback_count')),
                    borderColor: withStreamingReportColorAlpha(CHART_PALETTE[0], 0.96),
                    backgroundColor: withStreamingReportColorAlpha(CHART_PALETTE[0], 0.16),
                    tension: 0.3,
                    pointRadius: playbackRows.length < 20 ? 2 : 0,
                },
                {
                    label: STREAMING_PLAYBACK_REPORT_COPY.backgroundSeriesLabel,
                    data: playbackRows.map((row) => streamReportMetricValue(row, 'background_playback_count')),
                    borderColor: withStreamingReportColorAlpha(CHART_PALETTE[1], 0.9),
                    backgroundColor: withStreamingReportColorAlpha(CHART_PALETTE[1], 0.12),
                    tension: 0.3,
                    pointRadius: playbackRows.length < 20 ? 2 : 0,
                },
            ],
        };
    }, [playbackRows]);

    const reactionChart = useMemo(() => {
        const bucketStarts = reactionRows.map((row) => formatStreamingReportDateTime(row.bucket_at || row.occurred_at));
        return {
            labels: bucketStarts.map((label) => compactStreamingReportDateTime(label, true)),
            tooltipLabels: reactionRows.map((row, index) => {
                const bucketEnd = row.bucket_end_at ? formatStreamingReportDateTime(row.bucket_end_at) : null;
                return bucketEnd ? `${bucketStarts[index]} - ${bucketEnd}` : bucketStarts[index];
            }),
            datasets: [
                {
                    label: 'Reações',
                    data: reactionRows.map((row) => streamReportMetricValue(row, 'count', 'reaction_count', 'value')),
                    backgroundColor: withStreamingReportColorAlpha(CHART_PALETTE[0], 0.72),
                    borderColor: withStreamingReportColorAlpha(CHART_PALETTE[0], 0.96),
                    borderWidth: 1,
                },
            ],
        };
    }, [reactionRows]);

    const activityChart = useMemo(() => {
        const timeline = buildStreamingActivityTimeline(activities, activityColorMap);
        const series = Array.isArray(timeline.series) ? timeline.series : [];
        return {
            labels: timeline.categories || [],
            tooltipLabels: timeline.tooltipCategories || [],
            datasets: series.map((item, index) => ({
                label: item.name,
                data: item.data || [],
                backgroundColor: withStreamingReportColorAlpha(timeline.colors[index], 0.78),
                borderColor: withStreamingReportColorAlpha(timeline.colors[index], 0.96),
                borderWidth: 1,
            })),
        };
    }, [activities, activityColorMap]);

    const hasViewerChartData = viewerChart.datasets.some((dataset) => (
        Array.isArray(dataset.data) && dataset.data.some((value) => streamReportNumber(value) > 0)
    ));
    const hasPlaybackChartData = playbackAvailable && playbackRows.length > 0;
    const hasReactionChartData = reactionChart.datasets.some((dataset) => (
        Array.isArray(dataset.data) && dataset.data.some((value) => streamReportNumber(value) > 0)
    ));
    const hasActivityChartData = activityChart.datasets.some((dataset) => (
        Array.isArray(dataset.data) && dataset.data.some((value) => streamReportNumber(value) > 0)
    ));

    const viewerChartOptions = useMemo(() => buildStreamingReportChartOptions({
        categories: viewerChart.labels,
        tooltipCategories: viewerChart.tooltipLabels,
        yTitle: 'Conexões médias ponderadas',
    }), [viewerChart]);

    const playbackChartOptions = useMemo(() => buildStreamingReportChartOptions({
        categories: playbackChart.labels,
        tooltipCategories: playbackChart.tooltipLabels,
        yTitle: STREAMING_PLAYBACK_REPORT_COPY.chartYAxisTitle,
    }), [playbackChart]);

    const reactionChartOptions = useMemo(() => buildStreamingReportChartOptions({
        categories: reactionChart.labels,
        isBar: true,
        tooltipCategories: reactionChart.tooltipLabels,
        tooltipIntersect: true,
        tooltipShared: false,
        yTitle: 'Reações',
    }), [reactionChart]);

    const activityChartOptions = useMemo(() => ({
        ...buildStreamingReportChartOptions({
            categories: activityChart.labels,
            isBar: true,
            tooltipCategories: activityChart.tooltipLabels,
            tooltipIntersect: true,
            tooltipShared: false,
            yTitle: 'Atividades operacionais',
        }),
    }), [activityChart]);

    const truncatedSections = streamReportNumber(report?.data_quality?.truncated_sections);
    const hasStreamingReportAlerts = Boolean(
        error
        || truncatedSections > 0
        || viewerSnapshotStorageUnavailable
        || viewerMeasurementMissing
        || viewerMeasurementZero
        || unfinishedPresenceSessions > 0
    );
    const durationRange = range.start || range.end ? (
        <div className="streaming-report-duration-range">
            {range.start && (
                <div className="streaming-report-duration-point">
                    <div className="streaming-report-duration-value">
                        <span>Início:</span>
                        <strong>{formatStreamingReportDateTime(range.start)}</strong>
                    </div>
                </div>
            )}
            {isLive && (
                <div className="streaming-report-duration-point">
                    <div className="streaming-report-duration-value">
                        <span>Fim:</span>
                        <Badge bg="primary" text="dark">Em andamento</Badge>
                    </div>
                </div>
            )}
            {!isLive && range.end && (
                <div className="streaming-report-duration-point">
                    <div className="streaming-report-duration-value">
                        <span>Fim:</span>
                        <strong>{formatStreamingReportDateTime(range.end)}</strong>
                    </div>
                </div>
            )}
        </div>
    ) : rangeLabel;

    const familiarCards = [
        { title: 'Tempo total da transmissão', value: formatStreamingReportSeconds(range.duration_seconds), subtitle: rangeLabel, icon: faClock, iconSize: 'lg', tooltip: 'Tempo acumulado entre o início e o fim do período registrado para esta transmissão.' },
        { title: 'Espectadores', value: formatStreamingReportNumber(uniqueViewers), subtitle: 'Alcance acumulado da transmissão', icon: faUsers, iconSize: 'lg', tooltip: 'Pessoas deduplicadas na transmissão. Novas entradas da mesma pessoa continuam aparecendo em Acessos, sem aumentar este total.' },
        { title: 'Chat', value: `${formatStreamingReportNumber(chatMessages)} ${chatMessages === 1 ? 'mensagem' : 'mensagens'}`, subtitle: `${formatStreamingReportNumber(chatParticipants)} ${chatParticipants === 1 ? 'participante' : 'participantes'} · ${streamReportNumber(metrics.chat_messages_per_unique_viewer).toLocaleString('pt-BR', { maximumFractionDigits: 2 })} por espectador`, icon: faComments, iconSize: 'lg', tooltip: 'Total de mensagens visíveis no chat desta transmissão, desconsiderando mensagens excluídas. A taxa é calculada por espectador único.' },
        { title: 'Reações', value: `${formatStreamingReportNumber(reactionCount)} ${reactionCount === 1 ? 'reação' : 'reações'}`, subtitle: `${streamReportNumber(metrics.reactions_per_unique_viewer).toLocaleString('pt-BR', { maximumFractionDigits: 2 })} por espectador`, icon: faFire, iconSize: 'lg', tooltip: 'Total de reações rápidas registradas durante a transmissão. A taxa é calculada por espectador único.' },
    ];

    const additionalCards = [
        { title: 'Acessos à transmissão', value: formatStreamingReportNumber(totalSessions), subtitle: 'Entradas registradas na transmissão', icon: faSignInAlt, iconSize: 'lg', tooltip: 'Quantidade de vezes que a transmissão foi acessada. Se alguém sair e entrar novamente, será contado como um novo acesso.' },
        { title: 'Pico de conexões simultâneas', value: viewerSnapshotStorageUnavailable ? '—' : formatStreamingReportNumber(viewerSummary.peak_viewers), subtitle: viewerSnapshotStorageUnavailable ? 'Indisponível para esta execução' : `${formatStreamingReportNumber(Math.round(streamReportNumber(viewerSummary.average_viewers)))} conexões em média ponderada`, icon: faChartLine, iconSize: 'lg', tooltip: 'Maior número de conexões ativas à página medido ao mesmo tempo durante a transmissão. Não confirma reprodução do vídeo.' },
        { title: 'Média de conexões simultâneas', value: viewerSnapshotStorageUnavailable ? '—' : formatStreamingReportNumber(Math.round(streamReportNumber(viewerSummary.average_viewers))), subtitle: viewerSnapshotStorageUnavailable ? 'Indisponível para esta execução' : `Começou com ${formatStreamingReportNumber(viewerSummary.start_viewers)} conexões · terminou com ${formatStreamingReportNumber(viewerSummary.end_viewers)} conexões`, icon: faUsers, iconSize: 'lg', tooltip: 'Média ponderada pelo tempo entre observações qualificadas de conexões ativas. O gráfico usa a mesma definição por intervalo. Não confirma reprodução do vídeo.' },
        { title: 'Tempo médio conectado', value: formatStreamingReportSeconds(metrics.average_connected_seconds), subtitle: 'Calculado com acessos já encerrados', icon: faClock, iconSize: 'lg', tooltip: 'Tempo médio entre a entrada e a saída da transmissão. Isso indica conexão, mas não confirma que o vídeo ficou em reprodução ou recebeu atenção.' },
    ];

    const interpretationItems = [
        'Espectadores mostra quantas pessoas diferentes acompanharam a transmissão. Cada pessoa é contada apenas uma vez.',
        'Acessos mostra o total de entradas na transmissão. A mesma pessoa pode gerar vários acessos ao sair e retornar.',
        'A média e o gráfico de conexões usam ponderação pelo tempo entre observações qualificadas. O pico mostra o maior valor observado. Esses dados não confirmam, por si só, a reprodução contínua do vídeo.',
        'Tempo médio conectado considera os acessos já encerrados e ajuda a entender por quanto tempo, em média, o público permaneceu na transmissão.',
        'Chat e reações mostram as interações realizadas pelo público. As taxas por espectador usam o total de pessoas únicas como referência.',
        'Nas enquetes, a participação considera quem estava conectado quando a pergunta foi aberta e depois votou. Votos de quem entrou depois continuam no total de votos.',
        'A programação compara os horários registrados da transmissão com a agenda. Quando não houver um horário previsto, a comparação não é exibida.',
        playbackAvailable
            ? STREAMING_PLAYBACK_REPORT_COPY.availableInterpretation
            : STREAMING_PLAYBACK_REPORT_COPY.unavailableInterpretation,
        'Os dados refletem o período exibido neste relatório. Durante uma transmissão em andamento, os números podem ser atualizados até o encerramento.',
    ];
    const pdfExportMetadata = [
        { label: 'Período do relatório', value: rangeLabel },
        { label: 'Dados atualizados em', value: reportFetchedAtLabel },
        {
            label: 'Escopo das seções',
            value: STREAMING_PLAYBACK_REPORT_COPY.pdfScope,
        },
        {
            label: 'Escopo de filtros',
            value: `Dados consolidados para ${selectedRunLabel}, sem filtros interativos aplicados ao PDF.`,
        },
    ];
    const handleDownloadPdf = async () => {
        if (generatingPdf || loading || error || !reportMatchesSelection) return;
        const reportElement = document.querySelector('.streaming-report-print');
        if (!reportElement) return;

        setGeneratingPdf(true);
        let exportWrapper = null;
        // Match the report's desktop max-width so Bootstrap keeps the same
        // four-column card layout shown in the browser before the PDF is scaled.
        const PDF_EXPORT_WIDTH_PX = 1440;
        // Pages are built explicitly so no component is cut in half by an
        // automatic canvas slicer. Keep each page within its printable body
        // height so the PDF composer can preserve the full export width.
        const PDF_MARGIN_MM = 8;
        const PDF_FOOTER_HEIGHT_PX = 56;
        const PDF_PAGE_WIDTH_MM = 297;
        const PDF_PAGE_HEIGHT_MM = 210;
        const PDF_PAGE_MAX_CONTENT_HEIGHT_PX = Math.floor(
            PDF_EXPORT_WIDTH_PX
            * ((PDF_PAGE_HEIGHT_MM - (PDF_MARGIN_MM * 2)) / (PDF_PAGE_WIDTH_MM - (PDF_MARGIN_MM * 2)))
            - PDF_FOOTER_HEIGHT_PX,
        );
        const originalWindowGetComputedStyle = typeof window !== 'undefined'
            ? window.getComputedStyle
            : null;

        const sanitizeColorValue = (val) => {
            if (typeof val === 'string' && val.includes('color(')) {
                return val.replace(/color\((?:srgb|srgb-linear|display-p3|a98-rgb|prophoto-rgb|rec2020|xyz|xyz-d50|xyz-d65)?\s*([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+))?\)/gi, (_, r, g, b, a) => {
                    const red = Math.max(0, Math.min(255, Math.round(parseFloat(r) * 255)));
                    const green = Math.max(0, Math.min(255, Math.round(parseFloat(g) * 255)));
                    const blue = Math.max(0, Math.min(255, Math.round(parseFloat(b) * 255)));
                    const alpha = a !== undefined ? Math.max(0, Math.min(1, parseFloat(a))) : 1;
                    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
                });
            }
            return val;
        };

        const createStyleProxy = (origFunc, targetWin) => {
            return function (el, pseudo) {
                const style = origFunc.call(targetWin, el, pseudo);
                return new Proxy(style, {
                    get(target, prop) {
                        if (prop === 'getPropertyValue') {
                            return (propertyName) => sanitizeColorValue(target.getPropertyValue(propertyName));
                        }
                        const val = typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
                        if (typeof val === 'string' && val.includes('color(')) {
                            return sanitizeColorValue(val);
                        }
                        return val;
                    },
                });
            };
        };

        try {
            // html2canvas reads computed styles through the main window while it
            // parses its cloned document. Production Chrome can return wide-gamut
            // `color(...)` values there, which this renderer cannot parse.
            if (originalWindowGetComputedStyle && typeof window !== 'undefined') {
                window.getComputedStyle = createStyleProxy(originalWindowGetComputedStyle, window);
            }
            if (document.fonts?.ready) await document.fonts.ready;

            const streamTitle = stream?.title || 'Transmissão';
            const eventTitle = dataTable?.title || '';
            const cleanStreamTitle = streamTitle.replace(/[/\\?%*:|"<>]/g, '-');
            const filename = `Relatório da transmissão - ${cleanStreamTitle}.pdf`;
            const generatedDate = new Date().toLocaleString('pt-BR');

            // Capture the rendered chart surface and its displayed aspect ratio. A cloned
            // canvas loses its drawing buffer, while a height-capped replacement image is
            // stretched when the report is reflowed to the PDF page width.
            const origCanvases = reportElement.querySelectorAll('canvas');
            const canvasImages = Array.from(origCanvases).map((origCanvas) => {
                if (origCanvas && origCanvas.width && origCanvas.height) {
                    try {
                        const bounds = origCanvas.getBoundingClientRect();
                        return {
                            dataUrl: origCanvas.toDataURL('image/png', 1.0),
                            width: Math.max(1, Math.round(bounds.width || origCanvas.width)),
                            height: Math.max(1, Math.round(bounds.height || origCanvas.height)),
                        };
                    } catch (e) {
                        return null;
                    }
                }
                return null;
            });

            // 1. Create a clean clone of the report element
            const exportEl = reportElement.cloneNode(true);
            exportEl.classList.add('streaming-report-pdf-export');
            exportEl.style.width = `${PDF_EXPORT_WIDTH_PX}px`;
            exportEl.style.maxWidth = 'none';
            exportEl.style.boxSizing = 'border-box';
            exportEl.style.margin = '0';

            // 2. Remove interactive UI and stale errors. Keep warnings so an exported
            // report never hides that lists were limited by a technical cap.
            exportEl.querySelectorAll([
                '.streaming-report-no-print',
                '.streaming-report-no-pdf',
                '.streaming-report-section-activities',
                '.dropdown',
                '.input-group',
                'button',
                '.streaming-report-search-clear',
                '.alert-danger',
            ].join(', ')).forEach((el) => el.remove());
            exportEl.querySelectorAll('.html2pdf__page-break').forEach((el) => el.remove());

            // Remove existing print header placeholder
            const existingHeader = exportEl.querySelector('.streaming-report-print-header');
            if (existingHeader) existingHeader.remove();

            // 3. Create and prepend a clean official header without interpolating
            // report values as HTML.
            const headerContainer = document.createElement('div');
            headerContainer.className = 'streaming-report-pdf-header';
            headerContainer.style.marginBottom = '16px';
            headerContainer.style.paddingBottom = '10px';
            headerContainer.style.borderBottom = '2px solid #dee2e6';
            headerContainer.style.display = 'block';
            headerContainer.style.breakInside = 'avoid';
            headerContainer.style.pageBreakInside = 'avoid';
            const headerTitle = document.createElement('h3');
            headerTitle.style.margin = '0 0 4px 0';
            headerTitle.style.fontWeight = '700';
            headerTitle.style.color = '#212529';
            headerTitle.style.fontSize = '20px';
            headerTitle.textContent = `Relatório da transmissão: ${streamTitle}`;
            const headerMeta = document.createElement('div');
            headerMeta.style.fontSize = '12px';
            headerMeta.style.color = '#6c757d';
            if (eventTitle) {
                const eventLabel = document.createElement('span');
                eventLabel.textContent = 'Evento: ';
                const eventName = document.createElement('strong');
                eventName.textContent = eventTitle;
                eventLabel.appendChild(eventName);
                headerMeta.appendChild(eventLabel);
                headerMeta.appendChild(document.createTextNode(' · '));
            }
            const generatedLabel = document.createElement('span');
            generatedLabel.textContent = `Gerado em: ${generatedDate}`;
            headerMeta.appendChild(generatedLabel);
            const metadataList = document.createElement('div');
            metadataList.style.marginTop = '6px';
            metadataList.style.fontSize = '11px';
            metadataList.style.color = '#495057';
            pdfExportMetadata.forEach(({ label, value }) => {
                const metadataLine = document.createElement('div');
                const metadataLabel = document.createElement('strong');
                metadataLabel.textContent = `${label}: `;
                metadataLine.append(metadataLabel, document.createTextNode(value));
                metadataList.appendChild(metadataLine);
            });
            headerContainer.append(headerTitle, headerMeta, metadataList);
            exportEl.insertBefore(headerContainer, exportEl.firstChild);

            // 4. Expand all poll questions and hide summary chevrons.
            exportEl.querySelectorAll('details').forEach((detail) => {
                detail.setAttribute('open', '');
                detail.style.marginBottom = '8px';
                detail.style.padding = '8px 12px';
                detail.style.border = '1px solid #dee2e6';
                detail.style.borderRadius = '6px';
                const chevron = detail.querySelector('.streaming-report-poll-chevron');
                if (chevron) chevron.style.display = 'none';
            });

            // 5. Replace all chart canvases with rendered PNGs. Width and height
            // attributes retain the on-screen chart ratio when the clone is resized.
            const clonedCanvases = exportEl.querySelectorAll('canvas');
            clonedCanvases.forEach((cloneCanvas, i) => {
                const chartImage = canvasImages[i];
                if (chartImage?.dataUrl && cloneCanvas.parentNode) {
                    const img = document.createElement('img');
                    img.src = chartImage.dataUrl;
                    img.width = chartImage.width;
                    img.height = chartImage.height;
                    img.className = 'streaming-report-pdf-chart-image';
                    img.alt = cloneCanvas.getAttribute('aria-label') || 'Gráfico do relatório';
                    img.style.width = '100%';
                    img.style.height = 'auto';
                    img.style.maxWidth = '100%';
                    img.style.display = 'block';
                    const chartViewport = cloneCanvas.parentElement;
                    if (chartViewport) {
                        chartViewport.style.width = '100%';
                        chartViewport.style.height = 'auto';
                        chartViewport.style.minHeight = '0';
                    }
                    cloneCanvas.parentNode.replaceChild(img, cloneCanvas);
                } else if (cloneCanvas.parentNode) {
                    const fallback = document.createElement('p');
                    fallback.className = 'streaming-report-chart-empty text-muted mb-0';
                    fallback.textContent = 'O gráfico não pôde ser incluído no PDF.';
                    cloneCanvas.parentNode.replaceChild(fallback, cloneCanvas);
                }
            });
            const preparedImages = Array.from(exportEl.querySelectorAll('img'));
            await Promise.all(preparedImages.map((image) => {
                if (typeof image.decode === 'function') {
                    return image.decode().catch(() => undefined);
                }
                if (image.complete) return Promise.resolve();
                return new Promise((resolve) => {
                    image.addEventListener('load', resolve, { once: true });
                    image.addEventListener('error', resolve, { once: true });
                });
            }));

            // 6. Preserve the report visual structure before moving its blocks into
            // explicit PDF pages.
            exportEl.querySelectorAll('section').forEach((sec) => {
                sec.style.border = '1px solid #dee2e6';
                sec.style.borderRadius = '6px';
                sec.style.padding = '10px 14px';
                sec.style.marginBottom = '12px';
                sec.style.background = '#ffffff';
                sec.style.breakInside = 'auto';
                sec.style.pageBreakInside = 'auto';
            });

            exportEl.querySelectorAll('section > h5, .streaming-report-section-description').forEach((el) => {
                el.style.breakAfter = 'avoid';
                el.style.pageBreakAfter = 'avoid';
            });

            exportEl.querySelectorAll('.streaming-report-chart, .streaming-report-chart-empty').forEach((el) => {
                el.style.boxSizing = 'border-box';
            });

            // The overview header becomes a direct grid item in the paged clone.
            // Remove its screen-only auto margins so its title starts on the same
            // vertical line as the report content below.
            const exportOverviewHeader = exportEl.querySelector('.streaming-report-overview-header');
            if (exportOverviewHeader) {
                exportOverviewHeader.style.width = '100%';
                exportOverviewHeader.style.maxWidth = 'none';
                exportOverviewHeader.style.margin = '0';
                exportOverviewHeader.style.boxSizing = 'border-box';
            }

            // Sanitize any inline colors on all cloned elements.
            exportEl.querySelectorAll('*').forEach((el) => {
                ['color', 'backgroundColor', 'borderColor', 'fill', 'stroke'].forEach((prop) => {
                    if (el.style && el.style[prop] && typeof el.style[prop] === 'string' && el.style[prop].includes('color(')) {
                        el.style[prop] = sanitizeColorValue(el.style[prop]);
                    }
                });
            });

            // 7. Mount explicit, off-screen PDF pages. html2canvas renders one complete
            // measured page at a time, which prevents an element from being cropped by
            // an automatic page-break algorithm.
            exportWrapper = document.createElement('div');
            exportWrapper.style.position = 'absolute';
            exportWrapper.style.top = '0';
            exportWrapper.style.left = '-100000px';
            exportWrapper.style.width = `${PDF_EXPORT_WIDTH_PX}px`;
            exportWrapper.style.maxWidth = 'none';
            exportWrapper.style.zIndex = '-1';
            exportWrapper.style.pointerEvents = 'none';
            exportWrapper.style.background = '#ffffff';
            exportWrapper.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
            exportWrapper.style.fontSize = '12px';
            exportWrapper.style.color = '#212529';
            exportWrapper.setAttribute('aria-hidden', 'true');

            const exportPages = document.createElement('div');
            exportPages.className = 'streaming-report-pdf-export';
            exportPages.style.width = `${PDF_EXPORT_WIDTH_PX}px`;
            exportPages.style.maxWidth = 'none';
            exportPages.style.display = 'grid';
            exportPages.style.gap = '24px';
            exportWrapper.appendChild(exportPages);
            document.body.appendChild(exportWrapper);

            const createPage = () => {
                const page = document.createElement('div');
                page.className = 'streaming-report-pdf-page streaming-report-content';
                page.style.width = '100%';
                page.style.maxWidth = 'none';
                page.style.boxSizing = 'border-box';
                page.style.margin = '0';
                page.style.padding = '0';
                page.style.background = '#ffffff';
                page.style.display = 'grid';
                page.style.gap = '12px';
                exportPages.appendChild(page);
                return page;
            };

            const getPageHeight = (page) => Math.ceil(Math.max(
                page.scrollHeight,
                page.getBoundingClientRect().height,
            ));

            let currentPage = createPage();
            const appendBlock = (block) => {
                if (!block) return;
                currentPage.appendChild(block);
                if (getPageHeight(currentPage) <= PDF_PAGE_MAX_CONTENT_HEIGHT_PX) return;

                currentPage.removeChild(block);
                if (currentPage.childElementCount === 0) {
                    // A single oversized block is kept whole and scaled to fit its PDF
                    // page instead of being cut in the middle.
                    currentPage.appendChild(block);
                    return;
                }

                currentPage = createPage();
                currentPage.appendChild(block);
            };

            const startPollPageSection = (sourceSection, continuation = false) => {
                const section = sourceSection.cloneNode(false);
                const sourceTitle = Array.from(sourceSection.children).find((child) => child.tagName === 'H5');
                const sourceDescription = Array.from(sourceSection.children).find((child) => child.classList?.contains('streaming-report-section-description'));
                const sourcePollList = sourceSection.querySelector('.streaming-report-polls');
                const pollList = sourcePollList ? sourcePollList.cloneNode(false) : document.createElement('div');

                if (sourceTitle) {
                    const title = sourceTitle.cloneNode(true);
                    if (continuation) title.textContent = `${title.textContent} (continuação)`;
                    section.appendChild(title);
                }
                if (sourceDescription) section.appendChild(sourceDescription.cloneNode(true));
                section.appendChild(pollList);
                currentPage.appendChild(section);

                return { section, pollList };
            };

            const appendPollSection = (sourceSection) => {
                const sourcePollList = sourceSection.querySelector('.streaming-report-polls');
                const details = sourcePollList
                    ? Array.from(sourcePollList.children).filter((child) => child.tagName === 'DETAILS')
                    : [];

                if (!sourcePollList || details.length === 0) {
                    appendBlock(sourceSection);
                    return;
                }

                let { section, pollList } = startPollPageSection(sourceSection);
                details.forEach((detail) => {
                    pollList.appendChild(detail);
                    if (getPageHeight(currentPage) <= PDF_PAGE_MAX_CONTENT_HEIGHT_PX) return;

                    pollList.removeChild(detail);
                    const sectionHasPolls = pollList.children.length > 0;
                    section.remove();
                    currentPage = createPage();
                    ({ section, pollList } = startPollPageSection(sourceSection, sectionHasPolls));
                    pollList.appendChild(detail);
                });
            };

            // The report sections are children of .streaming-report-content. Flatten
            // that wrapper here; keeping it as one block would put the complete report
            // back on a single canvas and defeat the explicit pagination above.
            const contentContainer = exportEl.querySelector('.streaming-report-content');
            const reportBlocks = [
                ...Array.from(exportEl.children).filter((block) => block !== contentContainer),
                ...Array.from(contentContainer?.children || []),
            ];
            reportBlocks.forEach((block) => {
                if (block.classList.contains('streaming-report-section-polls')) {
                    appendPollSection(block);
                    return;
                }
                appendBlock(block);
            });

            await new Promise((resolve) => window.requestAnimationFrame(() => window.requestAnimationFrame(resolve)));
            const pdfPages = Array.from(exportPages.children).filter((page) => page.childElementCount > 0);
            if (pdfPages.length === 0) throw new Error('Não há conteúdo disponível para exportar.');

            const pdf = new jsPDF({
                unit: 'mm',
                format: 'a4',
                orientation: 'landscape',
                compress: true,
            });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const availableWidth = pageWidth - (PDF_MARGIN_MM * 2);
            const availableHeight = pageHeight - (PDF_MARGIN_MM * 2);
            const footerIdentity = [eventTitle, streamTitle, selectedRunLabel, `Gerado em ${generatedDate}`]
                .filter(Boolean)
                .join(' | ');
            const composePdfPage = (bodyCanvas, pageNumber, totalPages) => {
                const composedCanvas = document.createElement('canvas');
                const footerHeight = PDF_FOOTER_HEIGHT_PX * 2;
                composedCanvas.width = bodyCanvas.width;
                composedCanvas.height = Math.round(bodyCanvas.width * (availableHeight / availableWidth));

                const context = composedCanvas.getContext('2d');
                context.fillStyle = '#ffffff';
                context.fillRect(0, 0, composedCanvas.width, composedCanvas.height);

                const bodyMaxHeight = composedCanvas.height - footerHeight;
                const bodyScale = Math.min(1, bodyMaxHeight / bodyCanvas.height);
                context.drawImage(
                    bodyCanvas,
                    0,
                    0,
                    Math.round(bodyCanvas.width * bodyScale),
                    Math.round(bodyCanvas.height * bodyScale),
                );

                const footerTop = composedCanvas.height - footerHeight;
                context.strokeStyle = '#dee2e6';
                context.lineWidth = 2;
                context.beginPath();
                context.moveTo(0, footerTop + 1);
                context.lineTo(composedCanvas.width, footerTop + 1);
                context.stroke();
                context.font = '24px "Segoe UI", Arial, sans-serif';
                context.fillStyle = '#6c757d';
                context.textBaseline = 'middle';

                const pageLabel = `Página ${pageNumber} de ${totalPages}`;
                const pageLabelWidth = context.measureText(pageLabel).width;
                const footerRightPadding = 24;
                const identityMaxWidth = composedCanvas.width - pageLabelWidth - footerRightPadding - 64;
                let fittedIdentity = footerIdentity;
                while (fittedIdentity.length > 0 && context.measureText(`${fittedIdentity}...`).width > identityMaxWidth) {
                    fittedIdentity = fittedIdentity.slice(0, -1);
                }
                if (fittedIdentity !== footerIdentity) fittedIdentity = `${fittedIdentity.trimEnd()}...`;

                const footerTextY = footerTop + (footerHeight / 2);
                context.fillText(fittedIdentity, 0, footerTextY);
                context.fillText(pageLabel, composedCanvas.width - pageLabelWidth - footerRightPadding, footerTextY);
                return composedCanvas;
            };

            for (let index = 0; index < pdfPages.length; index += 1) {
                const canvas = await html2canvas(pdfPages[index], {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    backgroundColor: '#ffffff',
                    windowWidth: PDF_EXPORT_WIDTH_PX,
                    onclone: (clonedDoc) => {
                        const clonedWin = clonedDoc.defaultView || window;
                        if (clonedWin && typeof clonedWin.getComputedStyle === 'function') {
                            const originalGetComputedStyle = clonedWin.getComputedStyle;
                            clonedWin.getComputedStyle = createStyleProxy(originalGetComputedStyle, clonedWin);
                        }
                    },
                });
                if (index > 0) pdf.addPage();

                const composedCanvas = composePdfPage(canvas, index + 1, pdfPages.length);
                pdf.addImage(
                    composedCanvas.toDataURL('image/jpeg', 0.95),
                    'JPEG',
                    PDF_MARGIN_MM,
                    PDF_MARGIN_MM,
                    availableWidth,
                    availableHeight,
                    `streaming-report-page-${index + 1}`,
                    'FAST',
                );
            }
            pdf.save(filename);

            notyf.open({
                type: 'success',
                message: 'PDF do relatório gerado com sucesso!',
                ripple: true,
                dismissible: true,
            });
        } catch (err) {
            console.error('Erro ao gerar PDF:', err);
            notyf.open({
                type: 'danger',
                message: 'Houve um erro ao gerar o arquivo PDF.',
                ripple: true,
                dismissible: true,
            });
        } finally {
            if (originalWindowGetComputedStyle && typeof window !== 'undefined') {
                window.getComputedStyle = originalWindowGetComputedStyle;
            }
            if (exportWrapper && exportWrapper.parentNode) {
                exportWrapper.parentNode.removeChild(exportWrapper);
            }
            setGeneratingPdf(false);
        }
    };    return (
        <>
        <Modal
            show={modal.showStreamingReportModal}
            onHide={closeModal}
            fullscreen
            backdrop="static"
            style={{ zIndex: 1064 }}
            backdropClassName="nested-modal-backdrop-lv3"
            className="streaming-report-modal"
        >
            <Modal.Header closeButton className="streaming-report-actions">
                <Modal.Title>Relatório da transmissão<br /><small className="text-muted">{stream.title || 'Transmissão'}</small></Modal.Title>
            </Modal.Header>
            <Button
                type="button"
                variant="primary"
                className="btn update-side-panel-button-modal streaming-report-no-print"
                onClick={refreshReport}
                disabled={loading}
                aria-label="Atualizar relatório"
                title="Atualizar relatório"
            >
                <FontAwesomeIcon icon={faSync} spin={loading} size="lg" />
            </Button>
            <Modal.Body className="streaming-report-print">
                <div className="streaming-report-print-header d-none mb-4">
                    <h3 className="mb-1">Relatório da transmissão: {stream.title || 'Transmissão'}</h3>
                    {dataTable?.title && <h6 className="text-muted mb-1">Evento: {dataTable.title}</h6>}
                    <small className="text-muted">Gerado em: {new Date().toLocaleString('pt-BR')}</small>
                    <hr className="my-3" />
                </div>
                <div className="streaming-report-overview-header">
                    <div>
                        <h5>Visão geral</h5>
                        <p className="streaming-report-section-description mb-0">Resumo acumulado na mesma ordem visual do gerenciamento da transmissão.</p>
                        {streamRuns.length > 0 && (
                            <Form.Group className="mt-3 streaming-report-no-print">
                                <Form.Label className="mb-1">Execução do relatório</Form.Label>
                                <Form.Select
                                    value={activeSelectedStreamRunId}
                                    onChange={(event) => {
                                        setSelectedStreamRunId(event.target.value);
                                        setLoading(true);
                                        setError('');
                                    }}
                                    disabled={loading}
                                    aria-label="Selecionar execução da transmissão"
                                >
                                    {streamRuns.map((run) => {
                                        const runStatus = String(run?.run_status || 'allocated').toLowerCase();
                                        const runDate = run?.scheduled_start_at || run?.started_at || run?.allocated_at || null;
                                        return (
                                            <option key={run.stream_run_id} value={run.stream_run_id}>
                                                {`Execução ${Number(run.run_sequence || 0)} — ${STREAMING_RUN_STATUS_LABELS[runStatus] || runStatus}${runDate ? ` · ${formatStreamingReportDateTime(runDate)}` : ''}`}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                                <Form.Text className="text-muted">A transmissão é reutilizável; cada execução mantém seu próprio relatório.</Form.Text>
                            </Form.Group>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2 streaming-report-no-print">
                        <Dropdown>
                            <Dropdown.Toggle variant="primary" aria-label="Mais opções" title="Mais opções">
                                <FontAwesomeIcon icon={faCog} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={handleDownloadPdf} disabled={loading || Boolean(error) || !reportMatchesSelection || generatingPdf}>
                                    {generatingPdf ? 'Gerando PDF...' : 'Gerar PDF do relatório'}
                                </Dropdown.Item>
                                {canManage && (
                                    <Dropdown.Item
                                        onClick={endStreaming}
                                        disabled={loading || !canEndStreaming}
                                        title={!canEndStreaming ? 'A execução selecionada precisa estar ao vivo para encerrar a transmissão.' : undefined}
                                        className={!loading && canEndStreaming ? 'text-danger' : undefined}
                                    >
                                        Encerrar transmissão
                                    </Dropdown.Item>
                                )}
                                {canManage && (
                                    <Dropdown.Item
                                        onClick={resetStreaming}
                                        disabled={loading || !canResetStreaming}
                                        title={!canResetStreaming ? 'A transmissão precisa estar encerrada para ser resetada.' : undefined}
                                        className={!loading && canResetStreaming ? 'text-danger' : undefined}
                                    >
                                        Resetar transmissão
                                    </Dropdown.Item>
                                )}
                                <Dropdown.Item onClick={() => setShowActivityHelpModal(true)}>
                                    Logs das atividades da transmissão
                                </Dropdown.Item>
                                {canManage && (
                                    <Dropdown.Item
                                        onClick={() => setShowStreamingLoadTestModal?.(true)}
                                        disabled={!canManage}
                                    >
                                        {isStreamingLoadTestInProgress ? (
                                            <>Acompanhar teste em andamento</>
                                        ) : (
                                            <>Testar captação de dados analíticos</>
                                        )}
                                    </Dropdown.Item>
                                )}
                                {canManage && (
                                    <Dropdown.Item
                                        onClick={deleteSelectedStreaming}
                                        disabled={loading || !canDeleteStreaming}
                                        title={!canDeleteStreaming ? 'A transmissão precisa ter uma execução encerrada e não pode estar em andamento.' : undefined}
                                        className={!loading && canDeleteStreaming ? 'text-danger' : undefined}
                                    >
                                        Excluir transmissão e histórico
                                    </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                {loading && !reportMatchesSelection && <div className="py-5"><Loader /></div>}
                {!loading && error && !reportMatchesSelection && <div className="py-5 text-center text-danger">{error}</div>}
                {!loading && !error && !reportMatchesSelection && <div className="py-5 text-center text-muted">Ainda não há dados de audiência ou interação para esta transmissão.</div>}
                {reportMatchesSelection && (
                    <div className="streaming-report-content">
                        {hasStreamingReportAlerts && (
                            <div className="streaming-report-alert-stack">
                                {error && <Alert variant="danger" className="p-2">{error}</Alert>}
                                {truncatedSections > 0 && <Alert variant="primary" className="p-2">Algumas listas foram resumidas por limite técnico. Os totais apresentados permanecem completos.</Alert>}
                                {viewerSnapshotStorageUnavailable && <Alert variant="primary" className="p-2">As medições de audiência desta execução não são exibidas porque o armazenamento ainda não distingue execuções no mesmo minuto. Os demais dados do relatório continuam disponíveis.</Alert>}
                                {viewerMeasurementMissing && <Alert variant="primary" className="p-2">Não foram encontradas medições de audiência para o período desta execução. Isso é diferente de uma medição registrada em zero.</Alert>}
                                {viewerMeasurementZero && <Alert variant="primary" className="p-2">As medições de audiência foram registradas para este período e permaneceram em zero.</Alert>}
                                {unfinishedPresenceSessions > 0 && <Alert variant="primary" className="p-2">Há {formatStreamingReportNumber(unfinishedPresenceSessions)} {unfinishedPresenceSessions === 1 ? 'acesso' : 'acessos'} sem horário de saída gravado. Esse total é histórico e não mede as conexões abertas agora. O tempo médio usa os períodos com fim conhecido ou última observação registrada.</Alert>}
                            </div>
                        )}
                        <div className="streaming-report-summary">
                            <Row className="streaming-report-familiar-kpis mx-0">
                                {familiarCards.map((card, index) => (
                                    <AnalyticsKpiCard
                                        key={card.title}
                                        {...card}
                                        className={index === 0 ? 'streaming-report-duration-kpi' : ''}
                                        subtitleContent={index === 0 ? durationRange : undefined}
                                    />
                                ))}
                            </Row>
                        </div>

                        <section className="streaming-report-additional streaming-report-section-additional">
                            <h5>Dados adicionais</h5>
                            <p className="streaming-report-section-description">Indicadores históricos que complementam o resumo operacional.</p>
                            <Row>
                                {additionalCards.map((card) => (
                                    <AnalyticsKpiCard key={card.title} {...card} />
                                ))}
                            </Row>
                            <div className="streaming-report-summary-grid">
                                <div>
                                    <span><FontAwesomeIcon icon={faChartPie} className="text-primary me-2" />Acessos por espectador</span>
                                    <strong>{accessesPerUniqueViewer.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} acessos por espectador</strong>
                                    <small>Retornos e reconexões contam como novos acessos.</small>
                                </div>
                                <div className="streaming-report-poll-overview" aria-label="Resumo global das enquetes">
                                    <span><FontAwesomeIcon icon={faPoll} className="text-primary me-2" />Enquetes</span>
                                    <strong>{formatStreamingReportPercent(pollSummary.participation_percent)} de participação geral</strong>
                                    <small>{formatStreamingReportNumber(pollSummary.eligible_viewers)} pessoas conectadas na abertura · {formatStreamingReportNumber(pollSummary.unique_participants)} participantes elegíveis</small>
                                </div>
                            </div>
                        </section>

                        <section className="streaming-report-section-programme">
                            <h5>Programação da transmissão</h5>
                            <p className="streaming-report-section-description">Compara os horários previstos na agenda com os registros de início e encerramento da transmissão.</p>
                            <div className="streaming-report-summary-grid">
                                <div>
                                    <span><FontAwesomeIcon icon={faCalendarDays} className="text-primary me-2" />Agenda</span>
                                    <strong>{programme.title || 'Programação da agenda'}</strong>
                                    <small>Início previsto: {formatStreamingReportDateTime(programme.scheduled_start_at)}</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faSignInAlt} className="text-primary me-2" />Início da transmissão</span>
                                    <strong>{formatStreamingReportDateTime(programme.actual_start_at)}</strong>
                                    <small>{programmeStartVariance || 'Sem horário previsto para comparação'}</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faSignOutAlt} className="text-primary me-2" />Encerramento</span>
                                    <strong>{isLive ? 'Em andamento' : formatStreamingReportDateTime(programme.actual_end_at)}</strong>
                                    <small>{isLive ? 'O horário final será consolidado no encerramento.' : (programmeEndVariance || 'Sem horário previsto para comparação')}</small>
                                </div>
                            </div>
                        </section>

                        <section className="streaming-report-section-engagement">
                            <h5>Engajamento do público</h5>
                            <p className="streaming-report-section-description">Reúne as interações registradas no chat, nas reações rápidas e nas enquetes desta transmissão.</p>
                            <div className="streaming-report-summary-grid">
                                <div>
                                    <span><FontAwesomeIcon icon={faHeart} className="text-primary me-2" />Interações registradas</span>
                                    <strong>{formatStreamingReportNumber(totalEngagements)}</strong>
                                    <small>{engagementsPerUniqueViewer.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} por espectador</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faFire} className="text-primary me-2" />Reações rápidas</span>
                                    <strong>{formatStreamingReportNumber(reactionCount)}</strong>
                                    <small>{streamReportNumber(metrics.reactions_per_unique_viewer).toLocaleString('pt-BR', { maximumFractionDigits: 2 })} por espectador</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faComments} className="text-primary me-2" />Chat</span>
                                    <strong>{formatStreamingReportNumber(chatMessages)} mensagens</strong>
                                    <small>{formatStreamingReportNumber(chatParticipants)} participante(s) no chat</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faPoll} className="text-primary me-2" />Enquetes</span>
                                    <strong>{formatStreamingReportNumber(pollVotes)} votos</strong>
                                    <small>{formatStreamingReportNumber(pollSummary.total_count)} enquete(s) realizada(s)</small>
                                </div>
                            </div>
                        </section>

                        <section className="streaming-report-section-playback-observation">
                            <h5>{STREAMING_PLAYBACK_REPORT_COPY.sectionTitle}</h5>
                            <p className="streaming-report-section-description">{STREAMING_PLAYBACK_REPORT_COPY.sectionDescription}</p>
                            {playbackAvailable ? (
                                <>
                                    <div className="streaming-report-summary-grid">
                                        <div>
                                            <span><FontAwesomeIcon icon={faVideo} className="text-primary me-2" />{STREAMING_PLAYBACK_REPORT_COPY.activePeakTitle}</span>
                                            <strong>{formatStreamingReportNumber(playbackObservation.peak_active_playback)} {STREAMING_PLAYBACK_REPORT_COPY.playersUnit}</strong>
                                            <small>{STREAMING_PLAYBACK_REPORT_COPY.activePeakDetail}</small>
                                        </div>
                                        <div>
                                            <span><FontAwesomeIcon icon={faMobileAlt} className="text-primary me-2" />{STREAMING_PLAYBACK_REPORT_COPY.backgroundPeakTitle}</span>
                                            <strong>{formatStreamingReportNumber(playbackObservation.peak_background_playback)} {STREAMING_PLAYBACK_REPORT_COPY.playersUnit}</strong>
                                            <small>{STREAMING_PLAYBACK_REPORT_COPY.backgroundPeakDetail}</small>
                                        </div>
                                        <div>
                                            <span><FontAwesomeIcon icon={faPercent} className="text-primary me-2" />{STREAMING_PLAYBACK_REPORT_COPY.coverageTitle}</span>
                                            <strong>{playbackCoverageLabel}</strong>
                                            <small>{formatStreamingReportNumber(playbackObservation.qualified_viewer_sum)} de {formatStreamingReportNumber(playbackObservation.expected_viewer_sum)} {STREAMING_PLAYBACK_REPORT_COPY.qualifiedObservationsSuffix}</small>
                                        </div>
                                        <div>
                                            <span><FontAwesomeIcon icon={faClock} className="text-primary me-2" />{STREAMING_PLAYBACK_REPORT_COPY.lastQualifiedTitle}</span>
                                            <strong>{formatStreamingReportDateTime(playbackObservation.last_qualified_at)}</strong>
                                            <small>{formatStreamingReportNumber(playbackObservation.telemetry_sample_count)} {STREAMING_PLAYBACK_REPORT_COPY.samplesProcessedSuffix}</small>
                                        </div>
                                    </div>
                                    <div className="streaming-report-chart mt-3" aria-label={STREAMING_PLAYBACK_REPORT_COPY.chartAriaLabel}>
                                        {hasPlaybackChartData ? (
                                            <div style={{ height: '300px', minWidth: 0, width: '100%' }}><ChartLine data={playbackChart} options={playbackChartOptions} /></div>
                                        ) : (
                                            <p className="streaming-report-chart-empty text-muted mb-0">{STREAMING_PLAYBACK_REPORT_COPY.chartEmpty}</p>
                                        )}
                                    </div>
                                    <small className="d-block text-muted mt-2">{STREAMING_PLAYBACK_REPORT_COPY.chartFootnote}</small>
                                </>
                            ) : (
                                <Alert variant="primary" className="p-2 mb-0">
                                    <strong>{STREAMING_PLAYBACK_REPORT_COPY.unavailableTitle}</strong>
                                    <span className="ms-1">{playbackCoverageMessage} {STREAMING_PLAYBACK_REPORT_COPY.unavailableCoveragePrefix} {playbackCoverageLabel}.</span>
                                </Alert>
                            )}
                        </section>

                        <section className="streaming-report-section-identification">
                            <h5>Identificação do público e dos acessos</h5>
                            <p className="streaming-report-section-description">Separa pessoas identificadas de visitantes sem identificação. A mesma pessoa pode gerar mais de um acesso.</p>
                            <div className="streaming-report-summary-grid">
                                <div>
                                    <span><FontAwesomeIcon icon={faUsers} className="text-primary me-2" />Espectadores</span>
                                    <strong>{formatStreamingReportNumber(uniqueViewers)} no total</strong>
                                    <small>{formatStreamingReportNumber(registeredUniqueViewers)} identificados · {formatStreamingReportNumber(guestUniqueViewers)} visitantes</small>
                                </div>
                                <div>
                                    <span><FontAwesomeIcon icon={faSignInAlt} className="text-primary me-2" />Acessos à transmissão</span>
                                    <strong>{formatStreamingReportNumber(totalSessions)} no total</strong>
                                    <small>{formatStreamingReportNumber(registeredSessions)} identificados · {formatStreamingReportNumber(guestSessions)} visitantes</small>
                                </div>
                            </div>
                        </section>

                        <section className="streaming-report-section-audience">
                            <h5>Conexões médias ponderadas ao longo do tempo</h5>
                            <p className="streaming-report-section-description">Mostra a média ponderada pelo tempo das conexões ativas à página em cada intervalo. A linha tracejada indica o maior valor observado no intervalo.</p>
                            <div className="streaming-report-chart" aria-label="Gráfico de conexões médias ponderadas">
                                {hasViewerChartData ? (
                                    <div style={{ height: '320px', minWidth: 0, width: '100%' }}><ChartLine data={viewerChart} options={viewerChartOptions} /></div>
                                ) : (
                                    <p className="streaming-report-chart-empty text-muted mb-0">{viewerSnapshotStorageUnavailable
                                        ? 'As medições de audiência não estão disponíveis com segurança para esta execução.'
                                        : viewerMeasurementZero
                                            ? 'As medições de audiência foram registradas, mas permaneceram em zero durante todo o período.'
                                            : viewerMeasurementMissing
                                                ? 'Nenhuma medição de audiência foi encontrada para o período.'
                                                : 'Nenhuma medição de audiência foi registrada no período.'}</p>
                                )}
                            </div>
                        </section>

                        <section className="streaming-report-section-reactions">
                            <h5>Momentos com mais reações</h5>
                            <p className="streaming-report-section-description">Organiza as reações por data e hora ao longo da transmissão. Barras maiores indicam os intervalos com mais respostas do público.</p>
                            <div className="streaming-report-chart reactions" aria-label="Gráfico de reações ao longo da transmissão">
                                {hasReactionChartData ? (
                                    <div style={{ height: '280px', minWidth: 0, width: '100%' }}><ChartBar data={reactionChart} options={reactionChartOptions} /></div>
                                ) : (
                                    <p className="streaming-report-chart-empty text-muted mb-0">Nenhuma reação foi registrada no período.</p>
                                )}
                            </div>
                        </section>

                        <section className="streaming-report-section-polls">
                            <h5>Resultados das enquetes</h5>
                            <p className="streaming-report-section-description">Veja o total de votos por alternativa emitidos no período selecionado. A participação compara os votantes com o público que teve presença confirmada quando cada pergunta foi aberta.</p>
                            <div className="streaming-report-polls">
                                {polls.map((poll) => (
                                    <details key={poll.id}>
                                        <summary>
                                            <strong>{poll.question ? normalizeStreamingReportText(poll.question) : `Enquete #${poll.id}`}</strong>
                                            <span className="streaming-report-poll-summary-meta"><strong>{formatStreamingReportNumber(poll.total_votes)} votos</strong><FontAwesomeIcon icon={faChevronDown} className="streaming-report-poll-chevron" aria-hidden="true" /></span>
                                        </summary>
                                        <div className="streaming-report-voting-metrics streaming-report-poll-analytics" aria-label={`Engajamento da enquete ${poll.question || poll.id}`}>
                                            <div><strong>{formatStreamingReportPercent(poll.audience_engagement_percent)}</strong><span>Engajamento</span></div>
                                            <div><strong>{formatStreamingReportNumber(poll.audience_viewers)}</strong><span>Público na abertura</span></div>
                                            <div><strong>{formatStreamingReportNumber(poll.eligible_unique_voters)}</strong><span>Votantes do público inicial</span></div>
                                        </div>
                                        {streamReportNumber(poll.confirmed_late_arrival_voters) > 0 && <small className="d-block text-muted mt-2">{formatStreamingReportNumber(poll.confirmed_late_arrival_voters)} votante(s) tiveram entrada confirmada após a abertura; permanecem no total, mas não entram no engajamento do público inicial.</small>}
                                        {streamReportNumber(poll.unmatched_voter_identities) > 0 && <small className="d-block text-muted mt-1">{formatStreamingReportNumber(poll.unmatched_voter_identities)} identidade(s) de votantes não correspondem ao público inicial nem a uma entrada posterior confirmada. Elas permanecem no total e não são classificadas como chegada tardia.</small>}
                                        {streamReportNumber(poll.unknown_opening_presence_actors) > 0 && <small className="d-block text-warning mt-1">{formatStreamingReportNumber(poll.unknown_opening_presence_actors)} presença(s) não tinham observação suficiente na abertura da enquete.</small>}
                                        {poll.audience_quality === 'estimated' && <small className="d-block text-warning mt-1">O público na abertura é estimado porque havia conexões interrompidas ou presença sem observação suficiente.</small>}
                                        {(poll.options || []).map((option) => <div className="streaming-report-poll-option" key={option.id}><span>{option.label}</span><strong>{formatStreamingReportNumber(option.vote_count)} ({formatStreamingReportPercent(option.vote_percent)})</strong></div>)}
                                    </details>
                                ))}
                                {!polls.length && <p className="streaming-report-chart-empty text-muted mb-0">Nenhuma enquete foi realizada no período.</p>}
                            </div>
                        </section>

                        <section className="streaming-report-section-connected-participants streaming-report-no-pdf">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-1">
                                <h5 className="mb-0">Participantes conectados</h5>
                                <Dropdown align="end">
                                    <Dropdown.Toggle
                                        variant="primary"
                                        size="sm"
                                        aria-label="Opções da lista de participantes conectados"
                                        title="Opções da lista"
                                    >
                                        <FontAwesomeIcon icon={faCog} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            disabled={connectedParticipantsLoading || !connectedParticipantTableData.length}
                                            onClick={() => setTriggerConnectedParticipantsExport(true)}
                                        >
                                            Exportar
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => setShowConnectedParticipantInformation((currentValue) => !currentValue)}>
                                            {showConnectedParticipantInformation ? 'Ocultar informações adicionais' : 'Mostrar informações adicionais'}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <p className="streaming-report-section-description">Lista somente participantes cadastrados com presença confirmada na execução e no período deste relatório. Visitantes sem cadastro podem compor as métricas de público, mas não aparecem nesta lista. Use o menu de opções para exportar a lista ou exibir dados de conexão e interação por participante.</p>
                            {connectedParticipantsError && <Alert variant="danger" className="p-2">{connectedParticipantsError}</Alert>}
                            {connectedParticipantsLoading ? (
                                <div className="py-4"><Loader /></div>
                            ) : connectedParticipantFields.length > 0 ? (
                                <ColumnSortingTable
                                    key={`streaming-connected-participants-${selectedStreamId}-${connectedParticipantFields.length}`}
                                    columns={connectedParticipantFields}
                                    data={connectedParticipantTableData}
                                    title={connectedParticipantsExportTitle}
                                    initialState={{ pageIndex: 0, pageSize: 10 }}
                                    triggerExport={triggerConnectedParticipantsExport}
                                    setTriggerExport={setTriggerConnectedParticipantsExport}
                                    exportMetadata={connectedParticipantsExportMetadata}
                                    tableCountTooltip="Cada participante cadastrado é listado uma única vez neste período; este total não representa todos os espectadores únicos da transmissão."
                                />
                            ) : (
                                <p className="text-muted mb-0">Não há campos de cadastro disponíveis para exibir nesta lista.</p>
                            )}
                        </section>

                        <section className="streaming-report-section-activities streaming-report-no-pdf">
                            <h5>Atividades operacionais registradas</h5>
                            <p className="streaming-report-section-description">Reúne ações operacionais registradas e, quando faltarem, os marcos de início e encerramento consolidados a partir da transmissão. Eventos de alto volume permanecem resumidos nas métricas.</p>
                            {activityResultsCapped && <Alert variant="primary" className="p-2">Foram retornadas {formatStreamingReportNumber(returnedActivityCount)} de {formatStreamingReportNumber(totalActivityCount)} atividades operacionais disponíveis. O gráfico e a lista exibem somente as atividades retornadas dentro do limite técnico; os marcadores de início e encerramento podem ser adicionados separadamente.</Alert>}
                            <div className="streaming-report-chart activities" aria-label="Gráfico de atividades operacionais registradas">
                                {hasActivityChartData ? (
                                    <div style={{ height: '280px', minWidth: 0, width: '100%' }}><ChartBar data={activityChart} options={activityChartOptions} /></div>
                                ) : (
                                    <p className="streaming-report-chart-empty text-muted mb-0">Nenhuma atividade operacional foi registrada no período.</p>
                                )}
                            </div>
                            <div className="streaming-report-activities">
                                <InputGroup className="streaming-report-no-print mt-3 mb-3">
                                    <InputGroup.Text id="stream-report-search-icon"><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        placeholder="Pesquisar..."
                                        aria-label="Pesquisar atividades"
                                        aria-describedby={activitySearch ? 'stream-report-search-clear' : undefined}
                                        value={activitySearch}
                                        onChange={(event) => {
                                            setActivitySearch(event.target.value);
                                            setActivityPage(1);
                                        }}
                                    />
                                    {activitySearch && (
                                        <InputGroup.Text
                                            as="button"
                                            type="button"
                                            id="stream-report-search-clear"
                                            className="streaming-report-search-clear"
                                            aria-label="Limpar pesquisa"
                                            onClick={() => {
                                                setActivitySearch('');
                                                setActivityPage(1);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faClose} />
                                        </InputGroup.Text>
                                    )}
                                </InputGroup>
                                <div className="text-end mb-1 streaming-report-no-print"><small>Mostrando <strong>{visibleActivities.length}</strong> de <strong>{filteredActivities.length}</strong> atividades exibidas</small></div>
                                <div className="streaming-report-activity-list streaming-report-no-print" style={{ scrollMarginTop: '20px', minHeight: '60px' }}>
                                    {visibleActivities.length ? (
                                        <ol className="streaming-manager-activity-feed streaming-report-activity-feed">
                                            {visibleActivities.map((activity) => {
                                                const activityMeta = getStreamingActivityMeta(activity, activityColorMap);
                                                const activityTimestamp = activity.display_start_at || activity.activity_start_at || activity.created_at;
                                                const activityTimestampLabel = activity.is_ongoing
                                                    ? `${formatStreamingReportDateTime(activityTimestamp)} — em andamento até o fim do período`
                                                    : activityTimestamp ? formatStreamingReportDateTime(activityTimestamp) : '';
                                                return (
                                                    <li key={activity.id || `${activity.activity_type}:${activityTimestamp}`}>
                                                        <span
                                                            className="streaming-manager-activity-badge"
                                                            style={{ backgroundColor: activityMeta.color, borderColor: activityMeta.color }}
                                                            aria-hidden="true"
                                                        />
                                                        <div className="streaming-manager-activity-body">
                                                            <div className="streaming-manager-activity-heading d-flex justify-content-between align-items-center">
                                                                <strong>{activityMeta.title}</strong>
                                                                <small className="text-muted text-end">{activityTimestampLabel}</small>
                                                            </div>
                                                            {activity.message && normalizeStreamingReportText(activity.message).trim() !== activityMeta.title && (
                                                                <p className="streaming-manager-activity-description mb-0 text-muted">{normalizeStreamingReportText(activity.message)}</p>
                                                            )}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ol>
                                    ) : (
                                        <p className="text-muted text-center py-3 mb-0">Nenhuma atividade encontrada para os critérios informados.</p>
                                    )}
                                </div>
                                <div className="streaming-report-activity-list d-none">
                                    {filteredActivities.length ? (
                                        <ol className="streaming-manager-activity-feed streaming-report-activity-feed">
                                            {filteredActivities.map((activity) => {
                                                const activityMeta = getStreamingActivityMeta(activity, activityColorMap);
                                                const activityTimestamp = activity.display_start_at || activity.activity_start_at || activity.created_at;
                                                const activityTimestampLabel = activity.is_ongoing
                                                    ? `${formatStreamingReportDateTime(activityTimestamp)} — em andamento até o fim do período`
                                                    : activityTimestamp ? formatStreamingReportDateTime(activityTimestamp) : '';
                                                return (
                                                    <li key={activity.id || `${activity.activity_type}:${activityTimestamp}`}>
                                                        <span
                                                            className="streaming-manager-activity-badge"
                                                            style={{ backgroundColor: activityMeta.color, borderColor: activityMeta.color }}
                                                            aria-hidden="true"
                                                        />
                                                        <div className="streaming-manager-activity-body">
                                                            <div className="streaming-manager-activity-heading d-flex justify-content-between align-items-center">
                                                                <strong>{activityMeta.title}</strong>
                                                                <small className="text-muted text-end">{activityTimestampLabel}</small>
                                                            </div>
                                                            {activity.message && normalizeStreamingReportText(activity.message).trim() !== activityMeta.title && (
                                                                <p className="streaming-manager-activity-description mb-0 text-muted">{normalizeStreamingReportText(activity.message)}</p>
                                                            )}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ol>
                                    ) : (
                                        <p className="text-muted text-center py-3 mb-0">Nenhuma atividade registrada.</p>
                                    )}
                                </div>
                                {activityPageCount > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3 streaming-report-no-print">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            disabled={activityPage <= 1}
                                            onClick={() => setActivityPage((p) => Math.max(1, p - 1))}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
                                            Anterior
                                        </Button>
                                        <small className="text-muted">Página <strong>{activityPage}</strong> de <strong>{activityPageCount}</strong></small>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            disabled={activityPage >= activityPageCount}
                                            onClick={() => setActivityPage((p) => Math.min(activityPageCount, p + 1))}
                                        >
                                            Próxima
                                            <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </section>

                        <section className="streaming-report-guide streaming-report-section-guide">
                            <h5>Como interpretar estes números</h5>
                            <ul>
                                {interpretationItems.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </section>
                    </div>
                )}
            </Modal.Body>
        </Modal>
        <StreamingActivityHelpModal
            show={showActivityHelpModal}
            onHide={() => setShowActivityHelpModal(false)}
        />
        </>
    );
};

const TabGallery = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, setDataTableUpdate, setShowImageModal, dataAddForm, setDataAddForm }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [modal, setModal] = useState({ showGalleryItemForm: false });

    const [index, setIndex] = useState(-1);
    const zoomRef = useRef(null);
    const handleClick = (index, item) => setIndex(index);

    const handleDelete = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja remover essa imagem da galeria?"
                        action={() => {
                            deleteItem(id);
                            onClose();
                        }}
                        onClose={onClose}
                    />
                );
            }
        });
    };

    const deleteItem = (id) => {
        setLoading(true);
        axios.delete("/api/event/plataformaEventos/component", {
            data: {
                event_id: dataTable.event_id,
                component_type: 'galeria',
                id: id
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Imagem removida da galeria com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao remover a imagem da galeria',
                    ripple: true,
                    dismissible: true,
                });
            });
    };

    const handleNewItem = (item) => {

        // Check gallery limit before opening modal for new items
        if (!item) { // Only check for new items, not when editing
            const currentGalleryCount = componentData?.length || 0;
            const maxImages = 150;

            if (currentGalleryCount >= maxImages) {
                if (currentGalleryCount === maxImages) {
                    handlePreviewError('Limite máximo de 150 imagens atingido');
                } else {
                    handlePreviewError(`Esta galeria já possui ${currentGalleryCount} imagem(ns). Remova algumas imagens para adicionar novas (limite: 150 imagens)`);
                }
                return;
            }
        }

        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: item || false
        }));
        setModal((prevState) => {
            return {
                ...prevState,
                showGalleryItemForm: true
            };
        });
    };

    const clearAllImages = () => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja remover todas as imagens da galeria? Esta ação não pode ser desfeita."
                        action={() => {
                            setLoading(true);
                            axios.delete("/api/event/plataformaEventos/component", {
                                data: {
                                    event_id: dataTable.event_id,
                                    component_type: 'galeria'
                                }
                            })
                                .then(function (response) {
                                    setDataTableUpdate((prevCount) => prevCount + 1);
                                    notyf.open({
                                        type: "success",
                                        message: 'Todas as imagens foram removidas da galeria',
                                        ripple: true,
                                        dismissible: true,
                                    });
                                    setLoading(false);
                                    onClose();
                                })
                                .catch(function (error) {
                                    setLoading(false);
                                    notyf.open({
                                        type: "danger",
                                        message: 'Houve um erro ao limpar a galeria',
                                        ripple: true,
                                        dismissible: true,
                                    });
                                    onClose();
                                });
                        }}
                        onClose={onClose}
                    />
                );
            }
        });
    };

    // Process gallery data from componentData (API response)
    const galleryImages = (componentData || []).map(({ id, image, width, height }) => ({
        id: id,
        image: image,
        src: domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + image,
        height: parseInt(height),
        width: parseInt(width)
    }));


    return (
        <>
            <Form.Group as={Col} sm={"12"}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h6>Galeria ({componentData?.length || 0}/150)</h6>
                        <Form.Label>Gerencie as imagens da galeria do evento</Form.Label>
                    </div>
                    <div>
                        {componentData && componentData.length > 0 && (
                            <OverlayTrigger overlay={<Tooltip>Limpar galeria</Tooltip>}>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm me-1"
                                    onClick={clearAllImages}
                                    title="Limpar todas as imagens"
                                >
                                    <FontAwesomeIcon icon={faEraser} />
                                </button>
                            </OverlayTrigger>
                        )}
                        <OverlayTrigger overlay={<Tooltip>
                            {(componentData?.length || 0) >= 150 ?
                                "Máximo de 150 imagens atingido" :
                                "Adicionar imagem"
                            }
                        </Tooltip>}>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => handleNewItem(false)}
                                disabled={(componentData?.length || 0) >= 150}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        {galleryImages.length > 0 ? (
                            <>
                                <Gallery
                                    images={galleryImages.map((slide, index) => ({
                                        ...slide,
                                        customOverlay: (
                                            <div
                                                style={{
                                                    zIndex: 10000,
                                                    position: "relative",
                                                    width: "100%",
                                                    height: "100%",
                                                    pointerEvents: "none",
                                                }}>
                                                <div style={{ pointerEvents: "auto" }}>
                                                    {/* Edit Button */}
                                                    <button
                                                        style={{
                                                            position: "absolute",
                                                            top: "10px",
                                                            right: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-sm btn-primary float-end me-0"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleNewItem(slide);
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faPencil} />
                                                    </button>
                                                    {/* Delete Button */}
                                                    <button
                                                        style={{
                                                            position: "absolute",
                                                            top: "10px",
                                                            right: "40px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-sm btn-primary float-end me-2"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDelete(slide.id);
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </div>
                                            </div>
                                        ),
                                    }))}
                                    onClick={handleClick}
                                    enableImageSelection={false}
                                />
                                <Lightbox
                                    slides={galleryImages}
                                    open={index >= 0}
                                    index={index}
                                    close={() => setIndex(-1)}
                                    plugins={[Zoom]}
                                    zoom={{ ref: zoomRef }}
                                    styles={{
                                        container: { zIndex: 1200 }
                                    }}
                                />
                            </>
                        ) : (
                            <p className="opacity-75 text-center my-5">Nenhuma imagem encontrada</p>
                        )}
                    </div>
                </div>
            </Form.Group>
            <GalleryItemFormAPI
                modal={modal}
                setModal={setModal}
                dataAddForm={dataAddForm}
                setDataAddForm={setDataAddForm}
                dataTable={dataTable}
                handlePreviewError={handlePreviewError}
                setDataTableUpdate={setDataTableUpdate}
            />
        </>
    );
};

const GalleryItemFormAPI = ({
    dataAddForm,
    setDataAddForm,
    modal,
    setModal,
    dataTable,
    handlePreviewError,
    setDataTableUpdate
}) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const [isMultipleMode, setIsMultipleMode] = useState(false);

    const addGalleryItem = (values, actions) => {
        setLoading(true);

        const isEditing = dataAddForm.addFieldData && dataAddForm.addFieldData.id;

        if (isEditing) {
            // Update existing gallery item
            axios.put(`/api/event/plataformaEventos/component`, {
                id: dataAddForm.addFieldData.id,
                event_id: dataTable.event_id,
                component_type: 'galeria',
                image: values.image,
                width: parseInt(values.width) || null,
                height: parseInt(values.height) || null
            })
                .then(function (response) {
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Imagem da galeria atualizada com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    setLoading(false);
                    actions.setSubmitting(false);
                    setModal((prevState) => ({
                        ...prevState,
                        showGalleryItemForm: false
                    }));
                    setDataAddForm((prevState) => ({
                        ...prevState,
                        addFieldData: false
                    }));
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro ao atualizar a imagem da galeria',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            // Create new gallery item
            axios.post(`/api/event/plataformaEventos/component`, {
                event_id: dataTable.event_id,
                component_type: 'galeria',
                image: values.image,
                width: parseInt(values.width) || null,
                height: parseInt(values.height) || null
            })
                .then(function (response) {
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Imagem adicionada à galeria com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    setLoading(false);
                    actions.setSubmitting(false);
                    setModal((prevState) => ({
                        ...prevState,
                        showGalleryItemForm: false
                    }));
                    setDataAddForm((prevState) => ({
                        ...prevState,
                        addFieldData: false
                    }));
                })
                .catch(function (error) {
                    setLoading(false);
                    actions.setSubmitting(false);
                    notyf.open({
                        type: "danger",
                        message: 'Houve um erro ao adicionar a imagem à galeria',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    };

    // Custom handler for multiple file uploads
    const handleMultipleUploads = async (uploadResults, formValues) => {
        setLoading(true);

        try {
            const uploadPromises = uploadResults.map(result =>
                axios.post(`/api/event/plataformaEventos/component`, {
                    event_id: dataTable.event_id,
                    component_type: 'galeria',
                    image: result.filename,
                    width: parseInt(formValues.width) || null,
                    height: parseInt(formValues.height) || null
                })
            );

            await Promise.all(uploadPromises);

            setDataTableUpdate((prevCount) => prevCount + 1);
            notyf.open({
                type: "success",
                message: `${uploadResults.length} imagem(ns) adicionada(s) à galeria com sucesso`,
                ripple: true,
                dismissible: true,
            });
            setLoading(false);

            // Close the modal after successful uploads
            setModal((prevState) => ({
                ...prevState,
                showGalleryItemForm: false
            }));
        } catch (error) {
            setLoading(false);
            notyf.open({
                type: "danger",
                message: 'Houve um erro ao adicionar as imagens à galeria',
                ripple: true,
                dismissible: true,
            });
        }
    };

    // Custom handler for single file upload
    const handleSingleUploadSuccess = async (filename, setFieldValue, field, formValues) => {
        // Update the field value
        setFieldValue(field, filename);

        const isEditing = dataAddForm.addFieldData && dataAddForm.addFieldData.id;

        if (!isEditing) {
            // Auto-save for new images
            setLoading(true);

            try {
                await axios.post(`/api/event/plataformaEventos/component`, {
                    event_id: dataTable.event_id,
                    component_type: 'galeria',
                    image: filename,
                    width: parseInt(formValues.width) || null,
                    height: parseInt(formValues.height) || null
                });

                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Imagem adicionada à galeria com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false);

                // Close modal
                setModal((prevState) => ({
                    ...prevState,
                    showGalleryItemForm: false
                }));
            } catch (error) {
                setLoading(false);
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao adicionar a imagem à galeria',
                    ripple: true,
                    dismissible: true,
                });
            }
        }
    };

    return (
        <>
            <Modal
                show={modal.showGalleryItemForm}
                size={"sm"}
                onHide={(e) => {
                    setIsMultipleMode(false);
                    setModal((prevState) => ({
                        ...prevState,
                        showGalleryItemForm: false
                    }));
                }}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Formik
                    validationSchema={schemaAddGallery}
                    onSubmit={addGalleryItem}
                    initialValues={{
                        id: dataAddForm.addFieldData && dataAddForm.addFieldData.id !== undefined ? dataAddForm.addFieldData.id : undefined,
                        image: dataAddForm.addFieldData && dataAddForm.addFieldData.image !== undefined ? dataAddForm.addFieldData.image : null,
                        width: dataAddForm.addFieldData && dataAddForm.addFieldData.width !== undefined ? dataAddForm.addFieldData.width : "300",
                        height: dataAddForm.addFieldData && dataAddForm.addFieldData.height !== undefined ? dataAddForm.addFieldData.height : "300",
                    }}>
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        isValid,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{dataAddForm.addFieldData ? 'Editar imagem' : 'Adicionar imagem'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Form.Group as={Col} md={6} className="mb-3">
                                        <Form.Label>Largura (px)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="width"
                                            value={values.width}
                                            onChange={handleChange}
                                            isInvalid={!!errors.width}
                                            isValid={touched.width && !errors.width}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.width}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} md={6} className="mb-3">
                                        <Form.Label>Altura (px)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="height"
                                            value={values.height}
                                            onChange={handleChange}
                                            isInvalid={!!errors.height}
                                            isValid={touched.height && !errors.height}
                                        />
                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.height}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                {!dataAddForm.addFieldData && (
                                    <Row className="mb-3">
                                        <Col sm="12">
                                            <Form.Check
                                                type="checkbox"
                                                label="Múltiplos elementos"
                                                checked={isMultipleMode}
                                                onChange={(e) => setIsMultipleMode(e.target.checked)}
                                            />
                                        </Col>
                                    </Row>
                                )}
                                {isMultipleMode && !dataAddForm.addFieldData ? (
                                    <Row className="mb-3">
                                        <Col sm="12">
                                            <Form.Label>Imagens</Form.Label>
                                            <Card className="mb-3">
                                                <Card.Body>
                                                    <MultipleDropzoneComponent
                                                        className="mt-3 dropzoneComp"
                                                        type="image"
                                                        handlePreviewSuccessMultiple={(uploadResults) => handleMultipleUploads(uploadResults, values)}
                                                        handlePreviewError={handlePreviewError}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                        dataTable={dataTable}
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="mb-3">
                                        <Form.Group as={Col} className={"mb-3"} sm={"12"}>
                                            <Form.Label>Imagem</Form.Label>
                                            <Card className="mb-0">
                                                <Card.Body>
                                                    <Form.Control
                                                        type="hidden"
                                                        name="image"
                                                        value={values.image}
                                                        onChange={(e) => {
                                                            setFieldValue("image", e.target.value);
                                                        }}
                                                        isInvalid={!!errors?.image}
                                                        isValid={touched?.image && !errors?.image}
                                                    />
                                                    <div className="imagesUpload">
                                                        <img
                                                            className={`h-100 img-thumbnail ${!!errors?.image ? "is-invalid" : ""}`}
                                                            src={
                                                                values.image !== "" && values.image !== null
                                                                    ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.image
                                                                    : domainConfig.imageServer + "/empty-background.png"
                                                            }
                                                            alt="Imagem preview"
                                                        />
                                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.image}
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <DropzoneComponent
                                                        className="mt-3 dropzoneComp"
                                                        type="image"
                                                        handlePreviewSuccess={(filename, setFieldValue, field) => handleSingleUploadSuccess(filename, setFieldValue, field, values)}
                                                        handlePreviewError={handlePreviewError}
                                                        setFieldValue={setFieldValue}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                        field="image"
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Form.Group>
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={!dirty || !isValid || isSubmitting}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

const TabActivity = ({ selectedValue, handleSelectChange, setFieldValue, dataTable, handleChange, touched, errors, handlePreviewError, componentData, dataAddForm, setDataAddForm, setComponentData, setDataTableUpdate, setDataTableUpdateWarning }) => {
    const notyf = useContext(NotyfContext);
    const { setLoading } = useLayout();
    const userState = useAuth();
    const canEditActivityReports = canEditEventReports(userState, dataTable.platform);
    const [triggerExport, setTriggerExport] = useState(false);
    const [deletingAllHistory, setDeletingAllHistory] = useState(false);
    const [showTypeModal, setShowTypeModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState({ show: false, data: {} });
    const [reportActivity, setReportActivity] = useState(null);
    const activityTableData = Array.isArray(componentData)
        ? componentData.map((activity) => ({
            ...activity,
            configuredScoreText: getActivityScoreText(activity, dataAddForm.availableScores),
        }))
        : [];

    const addActivity = () => {
        setShowTypeModal(true);
    }

    const handleActivityTypeSelect = (appId) => {
        setShowTypeModal(false);
        const json = Number(appId) === 1 ? jsonCustomizacao(1) : Number(appId) === PARTICIPANT_VOTING_ACTIVITY_ID ? createParticipantVotingJson() : createPhotoActivityJson(appId);
        setShowEditModal({ show: true, data: { app_id: Number(appId), json } });
    }

    const handleDataActivity = (activityData) => {
        const appId = Number(activityData.app_id || 1);
        const defaultJson = appId === 1 ? jsonCustomizacao(1) : appId === PARTICIPANT_VOTING_ACTIVITY_ID ? createParticipantVotingJson() : createPhotoActivityJson(appId);
        let savedJson = {};
        if (activityData.json && typeof activityData.json === 'object') {
            savedJson = JSON.parse(JSON.stringify(activityData.json));
        } else if (typeof activityData.json === 'string') {
            try {
                savedJson = JSON.parse(activityData.json);
            } catch (error) {
                savedJson = {};
            }
        }
        const mergedJson = normalizeActivityScoreJson(fillMissingProperties(savedJson, defaultJson), appId);

        // Existing/legacy quizzes can have an empty or missing questions array.
        // The activity editor and its validation require at least one question.
        if (appId === 1 && (!Array.isArray(mergedJson.questions) || mergedJson.questions.length === 0)) {
            mergedJson.questions = jsonCustomizacao(1).questions;
        }

        const formJson = formatActivityAvailabilityForForm(
            appId === 1 || appId === PARTICIPANT_VOTING_ACTIVITY_ID ? mergedJson : formatPhotoActivityJsonForForm(mergedJson)
        );
        setShowEditModal({ show: true, data: { id: activityData.id, app_id: appId, title: activityData.title || activityData.activityTitle || '', json: formJson } });
    }

    const registerActivity = (values, actions) => {
        setLoading(true);
        const id = values.id || null;
        const title = values.title;
        const appId = Number(values.app_id || 1);
        const availabilityJson = normalizeActivityAvailabilityForSubmit(values.json);
        const activityJson = appId === 1 || appId === PARTICIPANT_VOTING_ACTIVITY_ID ? availabilityJson : normalizePhotoActivityJsonForSubmit(availabilityJson);
        const json = JSON.stringify(activityJson);

        if (id) {
            axios.put(`/api/event/plataformaEventos/activity`, {
                activity_id: id,
                event_id: dataTable.event_id,
                app_id: appId,
                title: title,
                json: json,
            })
                .then(function () {
                    setShowEditModal((prevState) => ({ ...prevState, show: false }));
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Atividade salva com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false);
                    setLoading(false);
                })
                .catch(function (error) {
                    actions.setSubmitting(false);
                    setLoading(false);
                    notyf.open({
                        type: "danger",
                        message: error?.response?.data?.message || 'Houve um erro ao salvar a atividade',
                        ripple: true,
                        dismissible: true,
                    });
                });
        } else {
            axios.post(`/api/event/plataformaEventos/component`, {
                event_id: dataTable.event_id,
                component_type: 'atividades',
                app_id: appId,
                title: title,
                json: json,
            })
                .then(function () {
                    setShowEditModal((prevState) => ({ ...prevState, show: false }));
                    setDataTableUpdate((prevCount) => prevCount + 1);
                    notyf.open({
                        type: "success",
                        message: 'Atividade criada com sucesso',
                        ripple: true,
                        dismissible: true,
                    });
                    actions.setSubmitting(false);
                    setLoading(false);
                })
                .catch(function (error) {
                    actions.setSubmitting(false);
                    setLoading(false);
                    notyf.open({
                        type: "danger",
                        message: error?.response?.data?.message || 'Houve um erro ao criar a atividade',
                        ripple: true,
                        dismissible: true,
                    });
                });
        }
    }

    const handleStatusActivity = (props) => {
        setLoading(true);

        const currentStatus = props.normalizedStatus ?? props.status ?? 0;
        let status = 0
        let message = null
        if (currentStatus === 0) {
            message = 'Atividade iniciada'
            status = 1
        } else if (currentStatus === 1) {
            status = 2
            message = 'Atividade finalizada'
        } else {
            status = [PHOTO_COMPETITION_ACTIVITY_ID, PARTICIPANT_VOTING_ACTIVITY_ID].includes(Number(props.app_id)) ? 1 : 0
            message = 'Atividade reiniciada'
        }
        axios.put(`/api/event/plataformaEventos/activity`, {
            activity_id: props.id,
            event_id: dataTable.event_id,
            status: status
        }).then(function (response) {
            setDataTableUpdate((prevCount) => prevCount + 1);
            setLoading(false)
            notyf.open({
                type: "success",
                message: message,
                ripple: true,
                dismissible: true,
            });
        }).catch(function (error) {
            setLoading(false)
            notyf.open({
                type: "danger",
                message: error.response?.data?.message || 'Houve um erro, tente novamente',
                ripple: true,
                dismissible: true,
            });
        });
    }

    const deleteActivity = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja excluir essa atividade? Todos os dados relacionados a ela serão excluídos"
                        action={handleDelete}
                        onClose={onClose}
                        param={id}
                    />
                );
            },
        });
    }

    function handleDelete(id) {
        setLoading(true)
        axios.delete("/api/event/plataformaEventos/component", {
            data: {
                event_id: dataTable.event_id,
                component_type: 'atividades',
                id: id
            }
        })
            .then(function (response) {
                setDataTableUpdate((prevCount) => prevCount + 1);
                notyf.open({
                    type: "success",
                    message: 'Atividade excluída com sucesso',
                    ripple: true,
                    dismissible: true,
                });
                setLoading(false)
            })
            .catch(function (error) {
                setLoading(false)
                notyf.open({
                    type: "danger",
                    message: 'Houve um erro ao excluir a atividade',
                    ripple: true,
                    dismissible: true,
                });
            });
    }

    const deleteAllActivityHistory = () => {
        if (deletingAllHistory || !activityTableData.length) return;
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ShowConfirm
                    title="Excluir histórico das atividades"
                    description="Todos os resultados, envios, fotos e votos das atividades deste evento serão excluídos. As configurações das atividades serão preservadas."
                    textConfirm="Excluir histórico"
                    action={() => {
                        setDeletingAllHistory(true);
                        axios.delete("/api/event/plataformaEventos/activity-reports", {
                            params: { event_id: dataTable.event_id },
                        }).then((response) => {
                            notyf.open({
                                type: response.data?.media_cleanup_pending ? "warning" : "success",
                                message: response.data?.media_cleanup_pending
                                    ? "Histórico excluído, mas alguns arquivos ainda precisam de limpeza."
                                    : "Histórico de todas as atividades excluído com sucesso.",
                                ripple: true,
                                dismissible: true,
                            });
                            setDataTableUpdate((current) => current + 1);
                        }).catch((error) => notyf.open({
                            type: "danger",
                            message: error.response?.data?.message || "Não foi possível excluir o histórico das atividades.",
                            ripple: true,
                            dismissible: true,
                        })).finally(() => setDeletingAllHistory(false));
                    }}
                    onClose={onClose}
                />
            ),
        });
    };

    const tableColumns = [
        {
            Header: "Título",
            accessor: "activityTitle",
            sortDescFirst: false,
            Cell: (cell) => {
                const title = cell.row.original.activityTitle;
                return (title === "" || title === null || title === undefined) ? (
                    <span className="text-muted">Sem título</span>
                ) : (
                    title
                );
            }
        },
        {
            Header: "Tipo",
            accessor: "activityType",
            sortDescFirst: false
        },
        {
            Header: "Status",
            accessor: "statusText",
            Cell: (cell) => {
                const statusText = cell.row.original.statusText;
                const badgeClass = cell.row.original.statusBadgeClass;
                return <Badge className={badgeClass}>{statusText}</Badge>;
            }
        },
        {
            Header: "Período de disponibilidade",
            accessor: "availabilityPeriodText",
            sortDescFirst: false,
        },
        {
            Header: "Pontuação definida",
            accessor: "configuredScoreText",
            sortDescFirst: false,
        },
        {
            Header: "",
            accessor: 'icons',
            disableSortBy: true,
            Filter: false,
            Cell: (cell) => {
                const props = cell.row.original;
                // Ensure props exists and has required properties
                if (!props || props.id === undefined || props.id === null) {
                    return <span className="text-muted">-</span>;
                }

                return (
                    <>
                        <OverlayTrigger overlay={<Tooltip>Relatórios</Tooltip>}>
                            <FileText
                                role="button"
                                aria-label="Relatórios"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => setReportActivity(props)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <Trash
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => deleteActivity(props.id)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <Edit
                                role="button"
                                className="align-middle cursor-pointer me-2"
                                onClick={() => handleDataActivity(props)}
                                size={18}
                            />
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>{props.normalizedStatus === 0 ? 'Iniciar' : props.normalizedStatus === 1 ? 'Finalizar' : 'Reiniciar'}</Tooltip>}>
                            {props.normalizedStatus === 0 ?
                                <Play
                                    role="button"
                                    className="align-middle cursor-pointer text-success"
                                    onClick={() => handleStatusActivity(props)}
                                    size={18}
                                /> : props.normalizedStatus === 1 ?
                                    <Square
                                        role="button"
                                        className="align-middle cursor-pointer text-danger"
                                        onClick={() => handleStatusActivity(props)}
                                        size={18}
                                    /> :
                                    <RotateCcw
                                        role="button"
                                        className="align-middle cursor-pointer text-danger"
                                        onClick={() => handleStatusActivity(props)}
                                        size={18}
                                    />
                            }
                        </OverlayTrigger>
                    </>
                );
            },
        },
    ];


    return (
        <>

            {/* Type-selection modal */}
            <Modal
                show={showTypeModal}
                onHide={() => setShowTypeModal(false)}
                centered
                size="md"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Tipo de atividade</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Selecione uma atividade para continuar</Form.Label>
                    <div className="list-group">
                        {ACTIVITY_TYPE_OPTIONS.map(({ appId, image }) => {
                            const activityName = getActivityTypeLabel(appId);

                            return (
                                <button
                                    key={`activity-type-${appId}`}
                                    type="button"
                                    className="list-group-item list-group-item-action rounded-3 mb-2 py-2 px-2 text-start"
                                    onClick={() => handleActivityTypeSelect(appId)}
                                >
                                    <div className="d-flex w-100 align-items-center">
                                        <img
                                            src={image}
                                            alt={activityName}
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                marginRight: "15px",
                                            }}
                                        />
                                        <h5 className="mb-0">{activityName}</h5>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </Modal.Body>
            </Modal>

            {/* Add / Edit modal */}
            <Modal
                show={showEditModal.show}
                size="lg"
                onHide={() => setShowEditModal((prevState) => ({ ...prevState, show: false }))}
                fullscreen="sm-down"
                centered
                backdrop="static"
                style={{ zIndex: 1060 }}
                backdropClassName="nested-modal-backdrop"
            >
                <Formik
                    enableReinitialize
                    onSubmit={registerActivity}
                    validationSchema={Number(showEditModal.data.app_id || 1) === 1
                        ? schemaComponents('atividades', dataTable)
                        : Number(showEditModal.data.app_id) === PARTICIPANT_VOTING_ACTIVITY_ID
                            ? participantVotingValidationSchema(dataTable)
                            : photoActivityValidationSchema(showEditModal.data.app_id, dataTable)}
                    initialValues={{
                        id: showEditModal.data.id || null,
                        app_id: Number(showEditModal.data.app_id || 1),
                        title: showEditModal.data.title || '',
                        json: showEditModal.data.json || jsonCustomizacao(1),
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange: formHandleChange,
                        values,
                        touched: formTouched,
                        errors: formErrors,
                        isSubmitting,
                        submitCount,
                        setFieldValue: formSetFieldValue,
                        setFieldTouched: formSetFieldTouched,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {values.id ? 'Editar atividade' : 'Adicionar atividade'}
                                    <br />
                                    <small className="text-muted">Atividade: {getActivityTypeLabel(values.app_id)}</small>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {(() => {
                                    const activityFormProps = {
                                        values,
                                        setFieldValue: formSetFieldValue,
                                        errors: formErrors,
                                        touched: formTouched,
                                        availableScores: dataAddForm.availableScores,
                                        eventId: dataTable.event_id,
                                        dataTable,
                                        handlePreviewSuccess,
                                        handlePreviewError,
                                        setFieldTouched: formSetFieldTouched,
                                        onScoresChanged: (scores) => {
                                            setDataAddForm((current) => ({ ...current, availableScores: scores }));
                                            setDataTableUpdate((current) => current + 1);
                                        },
                                        availabilityFields: (
                                            <ActivityAvailabilityFields
                                                values={values}
                                                setFieldValue={formSetFieldValue}
                                                errors={formErrors}
                                                touched={formTouched}
                                                dataTable={dataTable}
                                            />
                                        ),
                                    };

                                    switch (Number(values.app_id)) {
                                        case 1:
                                            return <ActivityQuizForm
                                                handleChange={formHandleChange}
                                                submitCount={submitCount}
                                                {...activityFormProps}
                                            />;
                                        case PHOTO_SUBMISSION_ACTIVITY_ID:
                                            return <ActivityPhotoSubmissionForm {...activityFormProps} />;
                                        case PHOTO_COMPETITION_ACTIVITY_ID:
                                            return <ActivityPhotoCompetitionForm {...activityFormProps} />;
                                        case PARTICIPANT_VOTING_ACTIVITY_ID:
                                            return <ActivityVotingForm {...activityFormProps} />;
                                        default:
                                            return null;
                                    }
                                })()}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            <Form.Group as={Col} className="textHeaderAplicativo d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Lista de atividades ({componentData ? componentData.length : 0})</h5>
                <div>
                    <Dropdown className="d-inline">
                        <Dropdown.Toggle className="btn-outline-primary">
                            <FontAwesomeIcon icon={faCog} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setTriggerExport(true);
                                }}
                            >
                                Exportar
                            </Dropdown.Item>
                            {canEditActivityReports && (
                                <Dropdown.Item
                                    disabled={deletingAllHistory || !activityTableData.length}
                                    onClick={deleteAllActivityHistory}
                                >
                                    Excluir o histórico de todas as atividades
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button type="button" className="btn btn-outline-primary ms-2" onClick={() => {
                        addActivity()
                    }}><FontAwesomeIcon icon={faPlus} /></Button>
                </div>
            </Form.Group>
            <h6 className="text-muted m-3">
                Gerencie as atividades que estarão disponíveis no evento
            </h6>
            <div className="pb-3 mt-3">
                {(componentData === false || componentData === undefined) ?
                    <div className="py-5">
                        <Loader></Loader>
                    </div>
                    :
                    <ColumnSortingTable
                        columns={tableColumns}
                        data={activityTableData}
                        title={`${dataTable.title} - Atividades`}
                        initialState={{
                            sortBy: [
                                {
                                    id: 'title',
                                    desc: false
                                }
                            ]
                        }}
                        getCellProps={(cellinfo) => ({
                            className: cellinfo.column.id === "icons" ? "table-icons-fourth" : "",
                        })}
                        triggerExport={triggerExport}
                        setTriggerExport={setTriggerExport}
                    />}
            </div>

            <ActivityReportModal
                dataTable={dataTable}
                activity={reportActivity}
                show={Boolean(reportActivity)}
                onHide={() => setReportActivity(null)}
                canEdit={canEditActivityReports}
            />
        </>
    )
}


const SocialMediaComponent = ({ dataAddForm, setDataAddForm, setModal }) => {
    const [draggedIndex, setDraggedIndex] = useState(null);

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (index) => {
        if (draggedIndex === index) return;

        const updatedForm = [...dataAddForm.socialMedia];
        const [draggedItem] = updatedForm.splice(draggedIndex, 1);
        updatedForm.splice(index, 0, draggedItem);

        setDraggedIndex(index);
        setDataAddForm((prevDataAddForm) => {
            return {
                ...prevDataAddForm,
                socialMedia: updatedForm
            }
        });
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };


    return (
        <Row className="mb-3 mx-0">
            <Card className="mb-0 formCard col-md-12 px-0">
                <Card.Body>
                    <Col className="text-center mb-2">
                        {dataAddForm.socialMedia.length > 0 && <small className="text-center opacity-75">(Clique e arraste para ordenar)</small>}
                    </Col>
                    {dataAddForm.socialMedia.length > 0 ? (
                        <Row>
                            {dataAddForm.socialMedia.map((valueX, index) => (
                                <Col
                                    key={'dataAddForm' + index}
                                    className="mb-3"
                                    md={3}
                                    sm={12}>
                                    <Button
                                        style={{ height: "50px" }}
                                        variant="secondary"
                                        className={`w-100 b-15`}
                                        draggable
                                        onDragStart={() => handleDragStart(index)}
                                        onDragOver={(e) => {
                                            e.preventDefault();
                                            handleDragOver(index);
                                        }}
                                        onClick={() => {
                                            setDataAddForm((prevState) => ({
                                                ...prevState,
                                                addFieldData: valueX
                                            }));
                                            setModal((prevState) => ({
                                                ...prevState,
                                                showSocialMediaForm: true
                                            }));
                                        }}
                                        onDragEnd={handleDragEnd}
                                    >
                                        {valueX.name}
                                    </Button>
                                </Col>
                            ))
                            }
                        </Row>
                    ) : (
                        <>
                            <p className="text-center opacity-75">Nenhum ícone encontrado</p>
                        </>

                    )}
                </Card.Body>
                <Col className="mb-3 text-center">
                    <Button
                        variant="primary"
                        className="btn-sm"
                        onClick={() => {
                            setDataAddForm((prevState) => ({
                                ...prevState,
                                addFieldData: false
                            }));
                            setModal((prevState) => ({
                                ...prevState,
                                showSocialMediaForm: true
                            }));
                        }}
                    >
                        Adicionar ícone
                    </Button>
                </Col>
            </Card>
        </Row>
    )
}

const GalleryItemForm = ({
    dataAddForm,
    setDataAddForm,
    modal,
    setModal,
    dataTable,
    handlePreviewError
}) => {
    const [isMultipleMode, setIsMultipleMode] = useState(false);

    const addGalleryItem = (values, actions) => {
        const newObject = {
            id: values.id,
            image: values.image,
            original: values.image,
            thumbnail: values.image
        }
        setDataAddForm((prevDataAddForm) => {
            const indexToUpdate = prevDataAddForm.gallery.findIndex(field =>
                field.id === values.id);
            let newDataAddForm = [...prevDataAddForm.gallery];
            if (indexToUpdate !== -1) {
                newDataAddForm[indexToUpdate] = newObject;
            } else {
                newDataAddForm = [...newDataAddForm, newObject];
            }
            return {
                ...prevDataAddForm,
                gallery: newDataAddForm
            }
        });
        setModal((prevState) => ({
            ...prevState,
            showGalleryItemForm: false
        }));
        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: false
        }));
    };

    const removeGalleryItem = (galleryItem) => {
        setDataAddForm((prevDataAddForm) => {
            const indexToRemove = prevDataAddForm.gallery.findIndex(field =>
                field.id === galleryItem.id);
            const newDataAddForm = [...prevDataAddForm.gallery];
            newDataAddForm.splice(indexToRemove, 1);
            return {
                ...prevDataAddForm,
                gallery: newDataAddForm
            }
        });
    }

    // Custom handler for multiple file uploads
    const handleMultipleUploads = (uploadResults, formValues) => {
        const currentGalleryCount = dataAddForm.gallery?.length || 0;
        const maxImages = 8;
        const availableSlots = maxImages - currentGalleryCount;

        if (availableSlots <= 0) {
            if (currentGalleryCount === maxImages) {
                handlePreviewError('Limite máximo de 8 imagens atingido');
            } else {
                handlePreviewError(`Esta galeria já possui ${currentGalleryCount} imagem(ns). Remova algumas imagens para adicionar novas (limite: 8 imagens)`);
            }
            return;
        }

        // Limit the upload results to available slots
        const limitedResults = uploadResults.slice(0, availableSlots);

        if (limitedResults.length < uploadResults.length) {
            handlePreviewError(`Apenas ${limitedResults.length} imagem(ns) foram adicionadas devido ao limite de 8 imagens`);
        }

        const newGalleryItems = limitedResults.map(result => ({
            id: generateSixDigitCode(),
            image: result.filename,
            original: result.filename,
            thumbnail: result.filename
        }));

        setDataAddForm((prevDataAddForm) => ({
            ...prevDataAddForm,
            gallery: [...prevDataAddForm.gallery, ...newGalleryItems]
        }));

        // Close the modal after successful uploads
        setModal((prevState) => ({
            ...prevState,
            showGalleryItemForm: false
        }));
    };

    // Custom handler for single file upload that also closes modal
    const handleSingleUploadSuccess = (filename, setFieldValue, field, formValues) => {
        // Update the field value (same as handlePreviewSuccess)
        setFieldValue(field, filename);

        if (!dataAddForm.addFieldData) {
            // Adding new image - check gallery limit first
            const currentGalleryCount = dataAddForm.gallery?.length || 0;
            const maxImages = 8;

            if (currentGalleryCount >= maxImages) {
                if (currentGalleryCount === maxImages) {
                    handlePreviewError('Limite máximo de 8 imagens atingido');
                } else {
                    handlePreviewError(`Esta galeria já possui ${currentGalleryCount} imagem(ns). Remova algumas imagens para adicionar novas (limite: 150 imagens)`);
                }
                return;
            }

            // Create new gallery item
            const newGalleryItem = {
                id: generateSixDigitCode(),
                image: filename,
                original: filename,
                thumbnail: filename
            };

            setDataAddForm((prevDataAddForm) => ({
                ...prevDataAddForm,
                gallery: [...prevDataAddForm.gallery, newGalleryItem]
            }));
        } else {
            // Editing existing image - find and update the item in gallery
            const updatedGalleryItem = {
                id: dataAddForm.addFieldData.id,
                image: filename,
                original: filename,
                thumbnail: filename
            };

            setDataAddForm((prevDataAddForm) => {
                const indexToUpdate = prevDataAddForm.gallery.findIndex(item =>
                    item.id === dataAddForm.addFieldData.id);
                const updatedGallery = [...prevDataAddForm.gallery];

                if (indexToUpdate !== -1) {
                    updatedGallery[indexToUpdate] = updatedGalleryItem;
                }

                return {
                    ...prevDataAddForm,
                    gallery: updatedGallery
                };
            });
        }

        // Close modal in both cases (new and edit)
        setModal((prevState) => ({
            ...prevState,
            showGalleryItemForm: false
        }));
    };

    return (
        <>
            <Modal
                show={modal.showGalleryItemForm}
                size={"sm"}
                onHide={(e) => {
                    setIsMultipleMode(false); // Reset multiple mode when modal closes
                    setModal((prevState) => ({
                        ...prevState,
                        showGalleryItemForm: false
                    }));
                }}
                fullscreen={'sm-down'}
                centered
                backdrop={true}
                style={{ zIndex: 1062 }}
                backdropClassName="nested-modal-backdrop-lv2"
            >
                <Formik
                    validationSchema={schemaAddGallery}
                    onSubmit={addGalleryItem}
                    initialValues={{
                        id: dataAddForm.addFieldData && dataAddForm.addFieldData.id !== undefined ? dataAddForm.addFieldData.id : generateSixDigitCode(),
                        thumbnail: dataAddForm.addFieldData && dataAddForm.addFieldData.thumbnail !== undefined ? dataAddForm.addFieldData.thumbnail : null,
                        original: dataAddForm.addFieldData && dataAddForm.addFieldData.original !== undefined ? dataAddForm.addFieldData.original : null,
                        image: dataAddForm.addFieldData && dataAddForm.addFieldData.image !== undefined ? dataAddForm.addFieldData.image : null,
                    }}>
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        isValid,
                        errors,
                        dirty,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{dataAddForm.addFieldData ? 'Editar imagem' : 'Adicionar imagem'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="mb-3">
                                    <Col sm="12">
                                        <Form.Check
                                            type="checkbox"
                                            label="Múltiplos elementos"
                                            checked={isMultipleMode}
                                            onChange={(e) => setIsMultipleMode(e.target.checked)}
                                        />
                                    </Col>
                                </Row>
                                {isMultipleMode ? (
                                    <Row className="mb-3">
                                        <Col sm="12">
                                            <Form.Label>Imagens</Form.Label>
                                            <Card className="mb-3">
                                                <Card.Body>
                                                    <MultipleDropzoneComponent
                                                        className="mt-3 dropzoneComp"
                                                        type="image"
                                                        handlePreviewSuccessMultiple={(uploadResults) => handleMultipleUploads(uploadResults, values)}
                                                        handlePreviewError={handlePreviewError}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                        dataTable={dataTable}
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="mb-3">
                                        <Form.Group
                                            as={Col}
                                            className={"mb-3"}
                                            sm={"12"}
                                        >
                                            <Form.Label>
                                                Imagem
                                            </Form.Label>
                                            <Card className="mb-0">
                                                <Card.Body>
                                                    <Form.Control
                                                        type="hidden"
                                                        name="image"
                                                        value={values.image}
                                                        onChange={(e) => {
                                                            setFieldValue("image", e.target.value);
                                                        }}
                                                        isInvalid={!!errors?.image}
                                                        isValid={touched?.image && !errors?.image}
                                                    />
                                                    <div className="imagesUpload">
                                                        <img
                                                            className={`h-100 img-thumbnail ${!!errors?.image ? "is-invalid" : ""}`}
                                                            src={
                                                                values.image !== "" && values.image !== null
                                                                    ? domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + values.image
                                                                    : domainConfig.imageServer + "/empty-background.png"
                                                            }
                                                            alt="image preview"
                                                        />
                                                        <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.image}
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <DropzoneComponent
                                                        className="mt-3 dropzoneComp"
                                                        type="image"
                                                        handlePreviewSuccess={(filename, setFieldValue, field) => handleSingleUploadSuccess(filename, setFieldValue, field, values)}
                                                        handlePreviewError={handlePreviewError}
                                                        setFieldValue={setFieldValue}
                                                        folder="plataforma-eventos"
                                                        id={dataTable.event_id}
                                                        field="image"
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </Form.Group>
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                {dataAddForm.addFieldData ? <Button
                                    variant="danger"
                                    type="button"
                                    className="float-end me-2"
                                    onClick={() => {
                                        removeGalleryItem(values)
                                        setModal((prevState) => ({
                                            ...prevState,
                                            showGalleryItemForm: false
                                        }));
                                    }}
                                >
                                    Excluir
                                </Button> : ''}
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="float-end"
                                    disabled={!dirty || !isValid || isSubmitting}
                                >
                                    Salvar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

        </>
    );
};

// Validation functions
const validateGoogleMapsUrl = (url) => {
    if (!url || url.trim() === '') {
        return { isValid: false, error: 'URL inválida' };
    }

    try {
        const urlObj = new URL(url);

        // Check if it's a Google Maps URL
        const validDomains = [
            'maps.google.com',
            'www.google.com',
            'google.com',
            'maps.app.goo.gl',
            'goo.gl'
        ];

        const isGoogleDomain = validDomains.some(domain =>
            urlObj.hostname.includes(domain) || urlObj.hostname.endsWith(domain)
        );

        if (!isGoogleDomain) {
            return { isValid: false, error: 'URL inválida' };
        }

        // Check for common Google Maps URL patterns
        const hasValidPattern =
            url.includes('maps') ||
            url.includes('place') ||
            url.includes('embed') ||
            url.includes('@') || // coordinates
            url.includes('goo.gl');

        if (!hasValidPattern) {
            return { isValid: false, error: 'URL inválida' };
        }

        return { isValid: true, error: '' };
    } catch (error) {
        return { isValid: false, error: 'URL inválida' };
    }
};

// New component to handle different content types
const TabCustomizationContent = ({
    currentContent,
    currentTab,
    localInputs,
    setLocalInputs,
    debouncedChange,
    debouncedHtmlChange,
    handleContentChange,
    dataTable,
    handlePreviewError
}) => {
    const [urlValidation, setUrlValidation] = useState({ isValid: true, error: '' });

    // Handle HTML content changes
    const handleHtmlChange = (value) => {
        setLocalInputs(prev => ({ ...prev, htmlContent: value }));
        debouncedHtmlChange(value);
    };

    // Validate URL when it changes
    const handleUrlChange = (value) => {
        const validation = validateGoogleMapsUrl(value);
        setUrlValidation(validation);

        setLocalInputs(prev => ({ ...prev, location: value }));
        debouncedChange('location', value);
    };

    switch (currentContent.type) {
        case 'html':
            return (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="location-html-content">Conteúdo HTML</Form.Label>
                        <Form.Control
                            as="textarea"
                            id="location-html-content"
                            value={localInputs.htmlContent !== undefined ? localInputs.htmlContent : currentTab?.htmlContent || ''}
                            onChange={(e) => handleHtmlChange(e.target.value)}
                            placeholder="Digite conteúdo HTML adicional aqui..."
                        />
                    </Form.Group>
                </>
            );
        case 'cardWithImage':
            return (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label>Conteúdo HTML <span className="badge text-dark bg-light cursor-pointer ms-1" onClick={() => redirectURL(true, 'https://jsonformatter.org/html-validator')}>Validador de HTML</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            id="html-content"
                            value={localInputs.htmlContent !== undefined ? localInputs.htmlContent : currentTab?.htmlContent || ''}
                            onChange={(e) => handleHtmlChange(e.target.value)}
                            placeholder="Digite o conteúdo HTML aqui..."
                        />
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        className={"mb-3"}
                        sm={"6"}
                    >
                        <Form.Label>Imagem</Form.Label>
                        <Card className="mb-0">
                            <Card.Body>
                                <Form.Control
                                    type="hidden"
                                    name="image"
                                    value={currentContent.image || ''}
                                />
                                <div className="imagesUpload">
                                    <img
                                        className="h-100 img-thumbnail"
                                        src={
                                            currentContent.image !== "" && currentContent.image !== null
                                                ? currentContent.image.startsWith('http')
                                                    ? currentContent.image
                                                    : domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + currentContent.image
                                                : domainConfig.imageServer + "/empty-background.png"
                                        }
                                        alt="Imagem preview"
                                    />
                                </div>
                                <DropzoneComponent
                                    className="mt-3 dropzoneComp"
                                    type="image"
                                    handlePreviewSuccess={(filename) => {
                                        handleContentChange('image', filename);
                                    }}
                                    handlePreviewError={handlePreviewError}
                                    folder="plataforma-eventos"
                                    id={dataTable.event_id}
                                    field="image"
                                />
                            </Card.Body>
                        </Card>
                    </Form.Group>
                </>
            );

        case 'link':
            return (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="location-html-content">Conteúdo HTML (Opcional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            id="location-html-content"
                            value={localInputs.htmlContent !== undefined ? localInputs.htmlContent : currentTab?.htmlContent || ''}
                            onChange={(e) => handleHtmlChange(e.target.value)}
                            placeholder="Digite conteúdo HTML adicional aqui..."
                        />
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        className={"mb-3"}
                        sm={"6"}
                    >
                        <Form.Label>Imagem</Form.Label>
                        <Card className="mb-0">
                            <Card.Body>
                                <Form.Control
                                    type="hidden"
                                    name="image"
                                    value={currentContent.image || ''}
                                />
                                <div className="imagesUpload">
                                    <img
                                        className="h-100 img-thumbnail"
                                        src={
                                            currentContent.image !== "" && currentContent.image !== null
                                                ? currentContent.image.startsWith('http')
                                                    ? currentContent.image
                                                    : domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + currentContent.image
                                                : domainConfig.imageServer + "/empty-background.png"
                                        }
                                        alt="Imagem preview"
                                    />
                                </div>
                                <DropzoneComponent
                                    className="mt-3 dropzoneComp"
                                    type="image"
                                    handlePreviewSuccess={(filename) => {
                                        handleContentChange('image', filename);
                                    }}
                                    handlePreviewError={handlePreviewError}
                                    folder="plataforma-eventos"
                                    id={dataTable.event_id}
                                    field="image"
                                />
                            </Card.Body>
                        </Card>
                    </Form.Group>
                </>
            );

        case 'location':
            return (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="location-html-content">Conteúdo HTML (Opcional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            id="location-html-content"
                            value={localInputs.htmlContent !== undefined ? localInputs.htmlContent : currentTab?.htmlContent || ''}
                            onChange={(e) => handleHtmlChange(e.target.value)}
                            placeholder="Digite conteúdo HTML adicional aqui..."
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="location-url">
                            URL do Google Maps
                        </Form.Label>
                        <Form.Control
                            type="url"
                            id="location-url"
                            value={localInputs.location !== undefined ? localInputs.location : currentContent.location || ''}
                            onChange={(e) => handleUrlChange(e.target.value)}
                            placeholder="https://maps.google.com/..."
                            isInvalid={!urlValidation.isValid}
                            isValid={urlValidation.isValid && currentContent.location && currentContent.location.trim() !== ''}
                        />
                        <Form.Control.Feedback type="invalid">
                            {urlValidation.error}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {urlValidation.isValid && currentContent.location && (
                        <Form.Group className="mb-3">
                            <Form.Label>Preview do Google Maps</Form.Label>
                            <div style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden', height: '300px' }}>
                                <iframe
                                    src={currentContent.location}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allow="fullscreen"
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Maps Preview"
                                    onError={() => setUrlValidation({ isValid: false, error: 'Erro ao carregar o mapa. Verifique se a URL está correta.' })}
                                ></iframe>
                            </div>
                        </Form.Group>
                    )}
                </>
            );

        default:
            return (
                <div className="text-center py-4">
                    <p className="text-muted">Selecione um tipo de conteúdo acima para começar a editar</p>
                </div>
            );
    }
};

export const TabCustomization = ({ selectedValue, currentIndex, handleContentChange, handleHtmlContentChange, handleSelectChange, dataTable, handlePreviewError, dataAddForm, setDataAddForm, propsDataAddForm, setPropsDataAddForm }) => {

    const [localInputs, setLocalInputs] = useState({});
    const timeoutRef = useRef({});

    // Debounced change handler
    const debouncedChange = useCallback((field, value, delay = 350) => {
        // Clear existing timeout for this field
        if (timeoutRef.current[field]) {
            clearTimeout(timeoutRef.current[field]);
        }

        // Set new timeout
        timeoutRef.current[field] = setTimeout(() => {
            handleContentChange(field, value);
        }, delay);
    }, [handleContentChange]);

    // Debounced HTML content change handler
    const debouncedHtmlChange = useCallback((value, delay = 350) => {
        // Clear existing timeout
        if (timeoutRef.current.htmlContent) {
            clearTimeout(timeoutRef.current.htmlContent);
        }

        // Set new timeout
        timeoutRef.current.htmlContent = setTimeout(() => {
            handleHtmlContentChange(value);
        }, delay);
    }, [handleHtmlContentChange]);

    // Initialize tab if it doesn't exist
    React.useEffect(() => {
        const refs = timeoutRef.current;
        return () => {
            Object.values(refs).forEach(clearTimeout);
        };
    }, []);

    React.useEffect(() => {
        // No need to create custom tabs, the tabs should already exist in propsDataAddForm
        // This component should only work with existing tabs
    }, [currentIndex, propsDataAddForm.tabs, setPropsDataAddForm]);

    const currentTab = propsDataAddForm?.tabs?.[currentIndex];
    const currentContent = currentTab?.content || {};

    // Show error if tab doesn't exist (shouldn't happen in normal flow)
    if (!currentTab) {
        return (
            <div className="row">
                <div className="col-md-12 text-center py-5">
                    <p className="text-danger">Tab não encontrada no índice {currentIndex}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <Form.Group className="mb-3">
                    <Form.Label htmlFor="content-type">Tipo de Conteúdo</Form.Label>
                    <Form.Select
                        id="content-type"
                        value={currentContent.type || ''}
                        onChange={(e) => {
                            const newType = e.target.value || null;
                            handleContentChange('type', newType);
                        }}
                    >
                        <option value="" disabled hidden>Selecione o tipo de conteúdo</option>
                        <option value="html">Apenas HTML</option>
                        <option value="cardWithImage">Card com imagem (Informativo)</option>
                        <option value="location">Localização (Google Maps)</option>
                        <option value="link">Imagem</option>
                    </Form.Select>
                </Form.Group>

                <TabCustomizationContent
                    currentContent={currentContent}
                    currentTab={currentTab}
                    localInputs={localInputs}
                    setLocalInputs={setLocalInputs}
                    debouncedChange={debouncedChange}
                    debouncedHtmlChange={debouncedHtmlChange}
                    handleContentChange={handleContentChange}
                    dataTable={dataTable}
                    handlePreviewError={handlePreviewError}
                />
            </div>
        </div>
    );
};

export const GalleryDisplay = ({ dataTable, dataAddForm, setDataAddForm, modal, setModal, handlePreviewError, disabled = false }) => {
    const [index, setIndex] = useState(-1);
    const [isSlideMode, setIsSlideMode] = useState(false); // true for ImageGallery, false for Gallery
    const zoomRef = useRef(null);
    const handleClick = (index, item) => setIndex(index);
    const hasGalleryItems = Array.isArray(dataAddForm.gallery) && dataAddForm.gallery.length > 0;

    useEffect(() => {
        if (!hasGalleryItems && isSlideMode) {
            setIsSlideMode(false);
        }
    }, [hasGalleryItems, isSlideMode]);

    const handleDelete = (id) => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja remover essa imagem da galeria?"
                        action={() => {
                            deleteItem(id);
                            onClose();
                        }}
                        onClose={onClose}
                    />
                );
            }
        });
    };

    const deleteItem = (id) => {
        setDataAddForm((prevDataAddForm) => {
            const indexToRemove = prevDataAddForm.gallery.findIndex(field => field.id === id);
            const newDataAddForm = [...prevDataAddForm.gallery];
            newDataAddForm.splice(indexToRemove, 1);
            return {
                ...prevDataAddForm,
                gallery: newDataAddForm
            }
        });
    };

    const handleNewItem = (item) => {
        if (!item) { // Only check for new items, not when editing
            const currentGalleryCount = dataAddForm.gallery?.length || 0;
            const maxImages = 8;

            if (currentGalleryCount >= maxImages) {
                if (currentGalleryCount === maxImages) {
                    handlePreviewError('Limite máximo de 8 imagens atingido');
                } else {
                    handlePreviewError(`Esta galeria já possui ${currentGalleryCount} imagem(ns). Remova algumas imagens para adicionar novas (limite: 8 imagens)`);
                }
                return;
            }
        }

        setDataAddForm((prevState) => ({
            ...prevState,
            addFieldData: item || false
        }));
        setModal((prevState) => {
            return {
                ...prevState,
                showGalleryItemForm: true
            };
        });
    };

    const clearAllImages = () => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Deseja remover todas as imagens da galeria? Esta ação não pode ser desfeita."
                        action={() => {
                            setDataAddForm((prevDataAddForm) => ({
                                ...prevDataAddForm,
                                gallery: []
                            }));
                            onClose();
                        }}
                        onClose={onClose}
                    />
                );
            }
        });
    };

    // Process gallery data directly from dataAddForm.gallery
    const galleryImages = (dataAddForm.gallery || []).map(({ id, image, original, thumbnail }) => ({
        id: id, // Fallback for items without id
        image: image,
        src: domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + image,
        original: domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + original,
        thumbnail: domainConfig.imageServer + "/plataforma-eventos/" + dataTable.event_id + "/" + thumbnail,
    }));

    return (
        <Form.Group
            as={Col}
            sm={"12"}>
            <hr></hr>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <h6>Galeria ({(dataAddForm.gallery?.length || 0)}/8)</h6>
                    <Form.Label>Adicione imagens para exibir nos detalhes do evento</Form.Label>
                </div>
                <div className="d-flex">
                    {hasGalleryItems && (
                        <OverlayTrigger overlay={<Tooltip>{isSlideMode ? 'Alternar para visualização em grade' : 'Alternar para visualização em slide'}</Tooltip>}>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm me-1"
                                onClick={() => setIsSlideMode(!isSlideMode)}
                            >
                                <FontAwesomeIcon icon={faImages} />
                            </button>
                        </OverlayTrigger>
                    )}
                    {!disabled && (Array.isArray(dataAddForm.gallery)) && dataAddForm.gallery.length > 0 && (
                        <OverlayTrigger overlay={<Tooltip>Limpar galeria</Tooltip>}>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm me-1"
                                onClick={clearAllImages}
                                title="Limpar todas as imagens"
                            >
                                <FontAwesomeIcon icon={faEraser} />
                            </button>
                        </OverlayTrigger>
                    )}
                    {!disabled && <OverlayTrigger overlay={<Tooltip>
                        {(dataAddForm.gallery?.length || 0) >= 150 ?
                            "Máximo de 150 imagens atingido" :
                            "Adicionar imagem"
                        }
                    </Tooltip>}>
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => handleNewItem(false)}
                            disabled={(dataAddForm.gallery?.length || 0) >= 8}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </OverlayTrigger>}
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12">
                    {hasGalleryItems && isSlideMode ? (
                        <ImageGallery items={galleryImages} className="mt-3" />
                    ) : (
                        <div className="mt-3">
                            <Gallery
                                images={galleryImages.map((slide, index) => ({
                                    ...slide,
                                    customOverlay: disabled ? null : (
                                        <div
                                            style={{
                                                zIndex: 10000,
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                pointerEvents: "none", // Prevent clicks from propagating to the parent
                                            }}>
                                            <div style={{ pointerEvents: "auto" }}> {/* Allow clicks on buttons */}
                                                {/* Edit Button */}
                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "10px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-sm btn-primary float-end me-0"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent triggering handleClick
                                                        handleNewItem(slide);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faPencil} />
                                                </button>
                                                {/* Delete Button */}
                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "40px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-sm btn-primary float-end me-2"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent triggering handleClick
                                                        handleDelete(slide.id);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </div>
                                    ),
                                }))}
                                onClick={handleClick}
                                enableImageSelection={false}
                            />
                        </div>
                    )}
                </div>
                <div className="col-12">
                    {(Array.isArray(galleryImages)) && galleryImages.length > 0 ? (
                        <>
                            <Lightbox
                                slides={galleryImages}
                                open={index >= 0}
                                index={index}
                                close={() => setIndex(-1)}
                                plugins={[Zoom]}
                                zoom={{ ref: zoomRef }}
                                styles={{
                                    container: { zIndex: 1200 }
                                }}
                            />
                        </>
                    ) : (
                        !isSlideMode && <p className="opacity-75 text-center my-5">Nenhuma imagem encontrada</p>
                    )}
                </div>
            </div>
        </Form.Group>
    );
};

export const ExtraSectionsForm = ({
    dataAddForm,
    setDataAddForm,
    modal,
    setModal,
    dataTable,
    handlePreviewError,
}) => {
    const HOME_PAGE_HREFS = ['/agenda', '/expositores', '/palestrantes', '/participantes', '/patrocinadores'];

    const [newSection, setNewSection] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [formData, setFormData] = useState({
        value: '',
        label: '',
        href: '',
        icon: '',
        title: '',
        displayOnFooter: false,
        displayOnHome: true,
        external_link: false,
        url: '',
        htmlContent: '',
        content: {
            type: 'cardWithImage',
            image: '',
            location: ''
        }
    });

    const configuredSectionValues = new Set(
        (dataAddForm.tabs || []).map((section) => section.value)
    );
    const filteredSections = Sections.filter(
        (section) => !configuredSectionValues.has(section.value)
    );

    // Available icons from iconMapping

    // URL validation function
    const isValidUrl = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
        } catch {
            return false;
        }
    };

    // Validate form data
    const validateForm = () => {
        const errors = {};

        if (formData.external_link && (!formData.href || !isValidUrl(formData.href))) {
            errors.href = 'Por favor, insira uma URL válida (deve começar com http:// ou https://)';
        }

        if (!formData.title || formData.title.trim() === '') {
            errors.title = 'O título é obrigatório';
        }

        if (!formData.label || formData.label.trim() === '') {
            errors.label = 'A seção é obrigatória';
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Available icons from iconMapping

    // Reset form when modal opens/closes
    useEffect(() => {
        if (modal.showExtraSectionsForm) {
            if (dataAddForm.editingSection) {
                // Edit mode - populate form with existing data
                setIsEditMode(true);
                setFormData(dataAddForm.editingSection);
                setNewSection('selected'); // To show form
                setValidationErrors({}); // Clear validation errors
            } else {
                // Add mode - reset form
                setIsEditMode(false);
                setNewSection('');
                setValidationErrors({}); // Clear validation errors
                setFormData({
                    value: '',
                    label: '',
                    href: '',
                    icon: 'faGlobe',
                    title: '',
                    displayOnFooter: false,
                    displayOnHome: true,
                    external_link: false,
                    url: '',
                    htmlContent: '',
                    content: {
                        type: 'cardWithImage',
                        image: '',
                        location: '',
                        link: ''
                    }
                });
            }
        }
    }, [modal.showExtraSectionsForm, dataAddForm.editingSection]);

    const getSectionFormData = (section) => ({
        value: section.value,
        label: section.label,
        href: section.href,
        icon: section.icon || 'faGlobe',
        title: section.title,
        displayOnFooter: section.displayOnFooter || false,
        displayOnHome: section.displayOnHome !== undefined ? section.displayOnHome : HOME_PAGE_HREFS.includes(section.href),
        external_link: section.external_link || false,
        url: section.url || '',
        htmlContent: section.htmlContent || '',
        content: section.content || {
            type: 'cardWithImage',
            image: '',
            location: '',
            link: ''
        }
    });

    const handleSectionSelect = (selectedValue) => {
        setNewSection(selectedValue);

        if (selectedValue === 'add_new') {
            setFormData({
                value: `add_new_${Date.now()}`,
                label: 'Página personalizada',
                href: '/complementos',
                icon: 'faGlobe',
                title: '',
                displayOnFooter: false,
                external_link: false,
                url: '',
                htmlContent: '',
                content: {
                    type: 'cardWithImage',
                    image: '',
                    location: '',
                    link: ''
                }
            });
        } else {
            const selectedSection = filteredSections.find(section => section.value === selectedValue);
            if (selectedSection) setFormData(getSectionFormData(selectedSection));
        }
    };

    const addSection = () => {
        // Validate form before adding
        if (!validateForm()) {
            return;
        }

        const persistSection = () => {
            setDataAddForm((prevDataAddForm) => {
                let newDataAddForm = [...(prevDataAddForm.tabs || [])];

                if (isEditMode) {
                    // Edit existing section
                    const sectionIndex = newDataAddForm.findIndex(tab => tab.value === dataAddForm.editingSection.value);
                    if (sectionIndex !== -1) {
                        newDataAddForm[sectionIndex] = { ...formData };
                    }
                } else if (isSocialComponentBundle(formData.value)) {
                    const configuredValues = new Set(newDataAddForm.map((tab) => tab.value));
                    const bundledSections = SOCIAL_COMPONENT_BUNDLE_VALUES
                        .map((sectionValue) => Sections.find((section) => section.value === sectionValue))
                        .filter(Boolean)
                        .filter((section) => !configuredValues.has(section.value))
                        .map((section) => section.value === formData.value ? formData : getSectionFormData(section));
                    newDataAddForm = [...newDataAddForm, ...bundledSections];
                } else {
                    // Add new section
                    newDataAddForm = [...newDataAddForm, { ...formData }];
                }

                return {
                    ...prevDataAddForm,
                    activeTab: formData.value,
                    tabs: newDataAddForm,
                    editingSection: null
                }
            });

            setModal((prevState) => ({
                ...prevState,
                showExtraSectionsForm: false
            }));

            setDataAddForm((prevState) => ({
                ...prevState,
                addFieldData: false,
                editingSection: null
            }));
        };

        if (!isEditMode && isSocialComponentBundle(formData.value)) {
            confirmAlert({
                closeOnEscape: false,
                closeOnClickOutside: false,
                customUI: ({ onClose }) => (
                    <ShowConfirm
                        title="Confirmar ação"
                        description="Networking, Social e Coleta de lead funcionam juntos. Ao adicionar este componente, os 3 componentes serão adicionados ao evento."
                        action={persistSection}
                        onClose={onClose}
                    />
                )
            });
            return;
        }

        persistSection();
    };

    return (
        <>
            <Modal
                show={modal.showExtraSectionsForm}
                size={newSection && newSection !== '' ? "lg" : "sm"}
                onHide={(e) => {
                    setModal((prevState) => ({
                        ...prevState,
                        showExtraSectionsForm: false
                    }));
                    setDataAddForm((prevState) => ({
                        ...prevState,
                        editingSection: null
                    }));
                    setValidationErrors({}); // Clear validation errors
                }}
                fullscreen={'sm-down'}
                centered
                backdrop
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isEditMode ? 'Editar seção' : 'Adicionar componente'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isEditMode && (
                        <Row className="mb-3">
                            <Form.Group as={Col} sm={"12"}>
                                <Form.Label>Selecione um componente</Form.Label>
                                <Form.Select
                                    name="sectionSelect"
                                    value={newSection}
                                    onChange={(e) => handleSectionSelect(e.target.value)}>
                                    <option value="" hidden>
                                        Selecione um componente
                                    </option>
                                    <option value="add_new">Nova página personalizada</option>
                                    {filteredSections.map((element, index) => (
                                        <option key={"fieldType" + index} value={element.value}>
                                            {element.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Row>
                    )}

                    {(newSection !== '' || isEditMode) && (
                        <>
                            <Row className="mb-3">
                                <Form.Group as={Col} md={6}>
                                    <Form.Label>Componente</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.label}
                                        readOnly={true}
                                        className={'bg-light'}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {validationErrors.label}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={6}>
                                    <Form.Label>Título</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.title}
                                        onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                                        placeholder="Digite o título da seção"
                                        isInvalid={!!validationErrors.title}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {validationErrors.title}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md={6}>
                                    <Form.Label>Link (URL)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.href}
                                        onChange={(e) => setFormData(prev => ({ ...prev, href: e.target.value }))}
                                        placeholder={formData.external_link ? "https://example.com" : "/exemplo"}
                                        readOnly={!(formData.external_link && formData.value.startsWith('add_new'))}
                                        className={!(formData.external_link && formData.value.startsWith('add_new')) ? 'bg-light' : ''}
                                        isInvalid={!!validationErrors.href}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {validationErrors.href}
                                    </Form.Control.Feedback>
                                    {!(formData.external_link && formData.value.startsWith('add_new')) ?
                                        <Form.Text className="text-muted">Este campo é imutável para links internos ou componentes padrão</Form.Text>
                                        : <Form.Text className="text-muted">Digite uma URL válida para redirecionar o usuário</Form.Text>}
                                </Form.Group>
                                <Form.Group as={Col} md={6}>
                                    <Form.Label>Ícone</Form.Label>
                                    <Select
                                        value={{
                                            value: formData.icon,
                                            label: (
                                                <div className="d-flex align-items-center">
                                                    <FontAwesomeIcon icon={iconMapping[formData.icon]} className="me-2" />
                                                    {formData.icon.replace('fa', '')}
                                                </div>
                                            )
                                        }}
                                        onChange={(selectedOption) => setFormData(prev => ({ ...prev, icon: selectedOption.value }))}
                                        options={Object.keys(iconMapping).sort().map(iconName => ({
                                            value: iconName,
                                            label: (
                                                <div className="d-flex align-items-center">
                                                    <FontAwesomeIcon icon={iconMapping[iconName]} className="me-2" />
                                                    {iconName.replace('fa', '')}
                                                </div>
                                            )
                                        }))}
                                        isSearchable
                                        placeholder="Selecione um ícone"
                                    />
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col} md={6}>
                                    <div>
                                        <Form.Check
                                            type="checkbox"
                                            label="Exibir no rodapé"
                                            checked={formData.displayOnFooter}
                                            onChange={(e) => setFormData(prev => ({ ...prev, displayOnFooter: e.target.checked }))}
                                        />
                                        {HOME_PAGE_HREFS.includes(formData.href) && (
                                            <Form.Check
                                                type="checkbox"
                                                label="Adicionar na página inicial"
                                                checked={formData.displayOnHome !== undefined ? formData.displayOnHome : true}
                                                onChange={(e) => setFormData(prev => ({ ...prev, displayOnHome: e.target.checked }))}
                                            />
                                        )}
                                        {formData.value.startsWith('add_new') && (
                                            <>
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Link externo"
                                                    checked={formData.external_link}
                                                    onChange={(e) => {
                                                        const isExternal = e.target.checked;
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            external_link: isExternal,
                                                            href: isExternal ? '' : (prev.value.startsWith('add_new') ? '/complementos' : prev.href)
                                                        }));
                                                        // Clear validation errors when toggling
                                                        setValidationErrors(prev => ({ ...prev, href: null }));
                                                    }}
                                                />
                                                <Form.Text className="text-muted">
                                                    Marque esta opção para apontar o link para um site externo
                                                </Form.Text>
                                            </>
                                        )}
                                    </div>
                                </Form.Group>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        type="button"
                        onClick={() => addSection()}
                        className="float-end"
                        disabled={!newSection && !isEditMode}
                    >
                        {isEditMode ? 'Salvar alterações' : 'Adicionar'}
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

const ModalImage = ({ showImageModal, setShowImageModal }) => {
    return (
        <Modal
            show={showImageModal.show}
            onHide={(e) => setShowImageModal(prevState => ({ ...prevState, show: false }))}
            centered
            fullscreen={true}
            backdrop
        >
            <Modal.Header closeButton>
                <Modal.Title>Visualizar imagem</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <img className="img-fluid" style={{ maxHeight: "700px" }} src={showImageModal.url} alt="" />
            </Modal.Body>
        </Modal>
    )
}

export const tierSponsorColumns = [{ description: '3/3', value: 12 }, { description: '1.5/3', value: 6 }, { description: '1/3', value: 4 }]
export const Sections = [
    {
        "value": "pagina-inicial",
        "label": "Página inicial",
        "href": "/",
        "icon": "faHome",
        "title": "Página inicial",
        "displayOnFooter": true
    },
    {
        "value": "agenda",
        "label": "Agenda",
        "href": "/agenda",
        "icon": "faCalendarDays",
        "title": "Agenda",
        "displayOnFooter": true
    },
    {
        "value": "expositores",
        "label": "Expositores",
        "href": "/expositores",
        "icon": "faStore",
        "title": "Expositores",
        "displayOnFooter": false
    },
    {
        "value": "participantes",
        "label": "Networking",
        "href": "/participantes",
        "icon": "faUserGroup",
        "title": "Networking",
        "displayOnFooter": true
    },
    {
        "value": "palestrantes",
        "label": "Palestrantes",
        "href": "/palestrantes",
        "icon": "faChalkboardUser",
        "title": "Palestrantes",
        "displayOnFooter": false
    },
    {
        "value": "patrocinadores",
        "label": "Patrocinadores",
        "href": "/patrocinadores",
        "icon": "faCrown",
        "title": "Patrocinadores",
        "displayOnFooter": false
    },
    {
        "value": "ranking",
        "label": "Ranking",
        "href": "/ranking",
        "icon": "faRankingStar",
        "title": "Ranking",
        "displayOnFooter": false
    },
    {
        "value": "pontos-de-interesse",
        "label": "Pontos de interesse",
        "href": "/pontos-de-interesse",
        "icon": "faMapLocation",
        "title": "Pontos de interesse",
        "displayOnFooter": false
    },
    {
        "value": "coleta-de-lead",
        "label": "Coleta de lead",
        "href": "/coleta-de-lead",
        "icon": "faAddressCard",
        "title": "Coleta de lead",
        "displayOnFooter": false
    },
    {
        "value": "galeria",
        "label": "Galeria",
        "href": "/galeria",
        "icon": "faImages",
        "title": "Galeria",
        "displayOnFooter": false
    },
    {
        "value": "atividades",
        "label": "Atividades",
        "href": "/atividades",
        "icon": "faCrown",
        "title": "Atividades",
        "displayOnFooter": false
    },
    createSocialSection(),
    {
        "value": "a&b",
        "label": "A&B",
        "href": "/a&b",
        "icon": "faUtensils",
        "title": "A&B",
        "displayOnFooter": false
    },
    {
        "value": "comunicados",
        "label": "Comunicados",
        "href": "/comunicados",
        "icon": "faBullhorn",
        "title": "Comunicados",
        "displayOnFooter": false
    }
]

export const iconMapping = {
    faAddressCard: faAddressCard,
    faBook: faBook,
    faBookmark: faBookmark,
    faBriefcase: faBriefcase,
    faBullhorn: faBullhorn,
    faCalendarDays: faCalendarDays,
    faCamera: faCamera,
    faChalkboardUser: faChalkboardUser,
    faChartLine: faChartLine,
    faChartPie: faChartPie,
    faClipboard: faClipboard,
    faCogs: faCogs,
    faComment: faComment,
    faCompass: faCompass,
    faCopy: faCopy,
    faCreditCard: faCreditCard,
    faCrown: faCrown,
    faDatabase: faDatabase,
    faDollarSign: faDollarSign,
    faDownload: faDownload,
    faExclamationCircle: faExclamationCircle,
    faExternalLinkAlt: faExternalLinkAlt,
    faFile: faFile,
    faFileAlt: faFileAlt,
    faFileArchive: faFileArchive,
    faFileAudio: faFileAudio,
    faFileCode: faFileCode,
    faFileExcel: faFileExcel,
    faFileImage: faFileImage,
    faFilePdf: faFilePdf,
    faFilePowerpoint: faFilePowerpoint,
    faFileVideo: faFileVideo,
    faFileWord: faFileWord,
    faFilter: faFilter,
    faFlag: faFlag,
    faFolder: faFolder,
    faFolderOpen: faFolderOpen,
    faFont: faFont,
    faGift: faGift,
    faGlobe: faGlobe,
    faGlobeAfrica: faGlobeAfrica,
    faHdd: faHdd,
    faHeadset: faHeadset,
    faHeart: faHeart,
    faHistory: faHistory,
    faHome: faHome,
    faImage: faImage,
    faImages: faImages,
    faInbox: faInbox,
    faKey: faKey,
    faLaptop: faLaptop,
    faLeaf: faLeaf,
    faLightbulb: faLightbulb,
    faLink: faLink,
    faLock: faLock,
    faLockOpen: faLockOpen,
    faMagic: faMagic,
    faMagnifyingGlass: faMagnifyingGlass,
    faMap: faMap,
    faMapLocation: faMapLocation,
    faMapMarkerAlt: faMapMarkerAlt,
    faMedal: faMedal,
    faMobileAlt: faMobileAlt,
    faMoneyBill: faMoneyBill,
    faMoneyCheckAlt: faMoneyCheckAlt,
    faPaintBrush: faPaintBrush,
    faPaperclip: faPaperclip,
    faPencilAlt: faPencilAlt,
    faPercent: faPercent,
    faPhone: faPhone,
    faPhoneAlt: faPhoneAlt,
    faPlane: faPlane,
    faPlug: faPlug,
    faPlus: faPlus,
    faPoll: faPoll,
    faPowerOff: faPowerOff,
    faPrint: faPrint,
    faQuestion: faQuestion,
    faRankingStar: faRankingStar,
    faReceipt: faReceipt,
    faRecycle: faRecycle,
    faRedo: faRedo,
    faRocket: faRocket,
    faRss: faRss,
    faSave: faSave,
    faSearch: faSearch,
    faShare: faShare,
    faShieldAlt: faShieldAlt,
    faShoppingBag: faShoppingBag,
    faShoppingCart: faShoppingCart,
    faSign: faSign,
    faSignInAlt: faSignInAlt,
    faSignOutAlt: faSignOutAlt,
    faSlidersH: faSlidersH,
    faSmile: faSmile,
    faSort: faSort,
    faSpinner: faSpinner,
    faStar: faStar,
    faStarHalf: faStarHalf,
    faStore: faStore,
    faSync: faSync,
    faTabletAlt: faTabletAlt,
    faTags: faTags,
    faThumbsDown: faThumbsDown,
    faThumbsUp: faThumbsUp,
    faTools: faTools,
    faTrophy: faTrophy,
    faTv: faTv,
    faUpload: faUpload,
    faUserCircle: faUserCircle,
    faUserGroup: faUserGroup,
    faComments: faComments,
    faUtensils: faUtensils,
    faVolumeUp: faVolumeUp,
    faWifi: faWifi,
    faWindowClose: faWindowClose,
    faWrench: faWrench
};
